var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _path1446, _path1447, _path1448, _path1449, _path1450, _path1451, _path1452, _path1453, _path1454, _path1455, _path1456, _path1457, _path1458, _path1459, _path1460, _path1461, _path1462, _path1463, _path1464, _path1465, _path1466, _path1467, _path1468, _path1469, _path1470, _path1471, _path1472, _path1473, _path1474, _path1475, _path1476, _path1477, _path1478, _path1479, _path1480, _path1481, _path1482, _path1483, _path1484, _path1485, _path1486, _path1487, _path1488, _path1489, _path1490, _path1491, _path1492, _path1493, _path1494, _path1495, _path1496, _path1497, _path1498, _path1499, _path1500, _path1501, _path1502, _path1503, _path1504, _path1505, _path1506, _path1507, _path1508, _path1509, _path1510, _path1511, _path1512, _path1513, _path1514, _path1515, _path1516, _path1517, _path1518, _path1519, _path1520, _path1521, _path1522, _path1523, _path1524, _path1525, _path1526, _path1527, _path1528, _path1529, _path1530, _path1531, _path1532, _path1533, _path1534, _path1535, _path1536, _path1537, _path1538, _path1539, _path1540, _path1541, _path1542, _path1543, _path1544, _path1545, _path1546, _path1547, _path1548, _path1549, _path1550, _path1551, _path1552, _path1553, _path1554, _path1555, _path1556, _path1557, _path1558, _path1559, _path1560, _path1561, _path1562, _path1563, _path1564, _path1565, _path1566, _path1567, _path1568, _path1569, _path1570, _path1571, _path1572, _path1573, _path1574, _path1575, _path1576, _path1577, _path1578, _path1579, _path1580, _path1581, _path1582, _path1583, _path1584, _path1585, _path1586, _path1587, _path1588, _path1589, _path1590, _path1591, _path1592, _path1593, _path1594, _path1595, _path1596, _path1597, _path1598, _path1599, _path1600, _path1601, _path1602, _path1603, _path1604, _path1605, _path1606, _path1607, _path1608, _path1609, _path1610, _path1611, _path1612, _path1613, _path1614, _path1615, _path1616, _path1617, _path1618, _path1619, _path1620, _path1621, _path1622, _path1623, _path1624, _path1625, _path1626, _path1627, _path1628, _path1629, _path1630, _path1631, _path1632, _path1633, _path1634, _path1635, _path1636, _path1637, _path1638, _path1639, _path1640, _path1641, _path1642, _path1643, _path1644, _path1645, _path1646, _path1647, _path1648, _path1649, _path1650, _path1651, _path1652, _path1653, _path1654, _path1655, _path1656, _path1657, _path1658, _path1659, _path1660, _path1661, _path1662, _path1663, _path1664, _path1665, _path1666, _path1667, _path1668, _path1669, _path1670, _path1671, _path1672, _path1673, _path1674, _path1675, _path1676, _path1677, _path1678, _path1679, _path1680, _path1681, _path1682, _path1683, _path1684, _path1685, _path1686, _path1687, _path1688, _path1689, _path1690, _path1691, _path1692, _path1693, _path1694, _path1695, _path1696, _path1697, _path1698, _path1699, _path1700, _path1701, _path1702, _path1703, _path1704, _path1705, _path1706, _path1707, _path1708, _path1709, _path1710, _path1711, _path1712, _path1713, _path1714, _path1715, _path1716, _path1717, _path1718, _path1719, _path1720, _path1721, _path1722, _path1723, _path1724, _path1725, _path1726, _path1727, _path1728, _path1729, _path1730, _path1731, _path1732, _path1733, _path1734, _path1735, _path1736, _path1737, _path1738, _path1739, _path1740, _path1741, _path1742, _path1743, _path1744, _path1745, _path1746, _path1747, _path1748, _path1749, _path1750, _path1751, _path1752, _path1753, _path1754, _path1755, _path1756, _path1757, _path1758, _path1759, _path1760, _path1761, _path1762, _path1763, _path1764, _path1765, _path1766, _path1767, _path1768, _path1769, _path1770, _path1771, _path1772, _path1773, _path1774, _path1775, _path1776, _path1777, _path1778, _path1779, _path1780, _path1781, _path1782, _path1783, _path1784, _path1785, _path1786, _path1787, _path1788, _path1789, _path1790, _path1791, _path1792, _path1793, _path1794, _path1795, _path1796, _path1797, _path1798, _path1799, _path1800, _path1801, _path1802, _path1803, _path1804, _path1805, _path1806, _path1807, _path1808, _path1809, _path1810, _path1811, _path1812, _path1813, _path1814, _path1815, _path1816, _path1817, _path1818, _path1819, _path1820, _path1821, _path1822, _path1823, _path1824, _path1825, _path1826, _path1827, _path1828, _path1829, _path1830, _path1831, _path1832, _path1833, _path1834, _path1835, _path1836, _path1837, _path1838, _path1839, _path1840, _path1841, _path1842, _path1843, _path1844, _path1845, _path1846, _path1847, _path1848, _path1849, _path1850, _path1851, _path1852, _path1853, _path1854, _path1855, _path1856, _path1857, _path1858, _path1859, _path1860, _path1861, _path1862, _path1863, _path1864, _path1865, _path1866, _path1867, _path1868, _path1869, _path1870, _path1871, _path1872, _path1873, _path1874, _path1875, _path1876, _path1877, _path1878, _path1879, _path1880, _path1881, _path1882, _path1883, _path1884, _path1885, _path1886, _path1887, _path1888, _path1889, _path1890, _path1891, _path1892, _path1893, _path1894, _path1895, _path1896, _path1897, _path1898, _path1899, _path1900, _path1901, _path1902, _path1903, _path1904, _path1905, _path1906, _path1907, _path1908, _path1909, _path1910, _path1911, _path1912, _path1913, _path1914, _path1915, _path1916, _path1917, _path1918, _path1919, _path1920, _path1921, _path1922, _path1923, _path1924, _path1925, _path1926, _path1927, _path1928, _path1929, _path1930, _path1931, _path1932, _path1933, _path1934, _path1935, _path1936, _path1937, _path1938, _path1939, _path1940, _path1941, _path1942, _path1943, _path1944, _path1945, _path1946, _path1947, _path1948, _path1949, _path1950, _path1951, _path1952, _path1953, _path1954, _path1955, _path1956, _path1957, _path1958, _path1959, _path1960, _path1961, _path1962, _path1963, _path1964, _path1965, _path1966, _path1967, _path1968, _path1969, _path1970, _path1971, _path1972, _path1973, _path1974, _path1975, _path1976, _path1977, _path1978, _path1979, _path1980, _path1981, _path1982, _path1983, _path1984, _path1985, _path1986, _path1987, _path1988, _path1989, _path1990, _path1991, _path1992, _path1993, _path1994, _path1995, _path1996, _path1997, _path1998, _path1999, _path2000, _path2001, _path2002, _path2003, _path2004, _path2005, _path2006, _path2007, _path2008, _path2009, _path2010, _path2011, _path2012, _path2013, _path2014, _path2015, _path2016, _path2017, _path2018, _path2019, _path2020, _path2021, _path2022, _path2023, _path2024, _path2025, _path2026, _path2027, _path2028, _path2029, _path2030, _path2031, _path2032, _path2033, _path2034, _path2035, _path2036, _path2037, _path2038, _path2039, _path2040, _path2041, _path2042, _path2043, _path2044, _path2045, _path2046, _path2047, _path2048, _path2049, _path2050, _path2051, _path2052, _path2053, _path2054, _path2055, _path2056, _path2057, _path2058, _path2059, _path2060, _path2061, _path2062, _path2063, _path2064, _path2065, _path2066, _path2067, _path2068, _path2069, _path2070, _path2071, _path2072, _path2073, _path2074, _path2075, _path2076, _path2077, _path2078, _path2079, _path2080, _path2081, _path2082, _path2083, _path2084, _path2085, _path2086, _path2087, _path2088, _path2089, _path2090, _path2091, _path2092, _path2093, _path2094, _path2095, _path2096, _path2097, _path2098, _path2099, _path2100, _path2101, _path2102, _path2103, _path2104, _path2105, _path2106, _path2107, _path2108, _path2109, _path2110, _path2111, _path2112, _path2113, _path2114, _path2115, _path2116, _path2117, _path2118, _path2119, _path2120, _path2121, _path2122, _path2123, _path2124, _path2125, _path2126, _path2127, _path2128, _path2129, _path2130, _path2131, _path2132, _path2133, _path2134, _path2135, _path2136, _path2137, _path2138, _path2139, _path2140, _path2141, _path2142, _path2143, _path2144, _path2145, _path2146, _path2147, _path2148, _path2149, _path2150, _path2151, _path2152, _path2153, _path2154, _path2155, _path2156, _path2157, _path2158, _path2159, _path2160, _path2161, _path2162, _path2163, _path2164, _path2165, _path2166, _path2167, _path2168, _path2169, _path2170, _path2171, _path2172, _path2173, _path2174, _path2175, _path2176, _path2177, _path2178, _path2179, _path2180, _path2181, _path2182, _path2183, _path2184, _path2185, _path2186, _path2187, _path2188, _path2189, _path2190, _path2191, _path2192, _path2193, _path2194, _path2195, _path2196, _path2197, _path2198, _path2199, _path2200, _path2201, _path2202, _path2203, _path2204, _path2205, _path2206, _path2207, _path2208, _path2209, _path2210, _path2211, _path2212, _path2213, _path2214, _path2215, _path2216, _path2217, _path2218, _path2219, _path2220, _path2221, _path2222, _path2223, _path2224, _path2225, _path2226, _path2227, _path2228, _path2229, _path2230, _path2231, _path2232, _path2233, _path2234, _path2235, _path2236, _path2237, _path2238, _path2239, _path2240, _path2241, _path2242, _path2243, _path2244, _path2245, _path2246, _path2247, _path2248, _path2249, _path2250, _path2251, _path2252, _path2253, _path2254, _path2255, _path2256, _path2257, _path2258, _path2259, _path2260, _path2261, _path2262, _path2263, _path2264, _path2265, _path2266, _path2267, _path2268, _path2269, _path2270, _path2271, _path2272, _path2273, _path2274, _path2275, _path2276, _path2277, _path2278, _path2279, _path2280, _path2281, _path2282, _path2283, _path2284, _path2285, _path2286, _path2287, _path2288, _path2289, _path2290, _path2291, _path2292, _path2293, _path2294, _path2295, _path2296, _path2297, _path2298, _path2299, _path2300, _path2301, _path2302, _path2303, _path2304, _path2305, _path2306, _path2307, _path2308, _path2309, _path2310, _path2311, _path2312, _path2313, _path2314, _path2315, _path2316, _path2317, _path2318, _path2319, _path2320, _path2321, _path2322, _path2323, _path2324, _path2325, _path2326, _path2327, _path2328, _path2329, _path2330, _path2331, _path2332, _path2333, _path2334, _path2335, _path2336, _path2337, _path2338, _path2339, _path2340, _path2341, _path2342, _path2343, _path2344, _path2345, _path2346, _path2347, _path2348, _path2349, _path2350, _path2351, _path2352, _path2353, _path2354, _path2355, _path2356, _path2357, _path2358, _path2359, _path2360, _path2361, _path2362, _path2363, _path2364, _path2365, _path2366, _path2367, _path2368, _path2369, _path2370, _path2371, _path2372, _path2373, _path2374, _path2375, _path2376, _path2377, _path2378, _path2379, _path2380, _path2381, _path2382, _path2383, _path2384, _path2385, _path2386, _path2387, _path2388, _path2389, _path2390, _path2391, _path2392, _path2393, _path2394, _path2395, _path2396, _path2397, _path2398, _path2399, _path2400, _path2401, _path2402, _path2403, _path2404, _path2405, _path2406, _path2407, _path2408, _path2409, _path2410, _path2411, _path2412, _path2413, _path2414, _path2415, _path2416, _path2417, _path2418, _path2419, _path2420, _path2421, _path2422, _path2423, _path2424, _path2425, _path2426, _path2427, _path2428, _path2429, _path2430, _path2431, _path2432, _path2433, _path2434, _path2435, _path2436, _path2437, _path2438, _path2439, _path2440, _path2441, _path2442, _path2443, _path2444, _path2445, _path2446, _path2447, _path2448, _path2449, _path2450, _path2451, _path2452, _path2453, _path2454, _path2455, _path2456, _path2457, _path2458, _path2459, _path2460, _path2461, _path2462, _path2463, _path2464, _path2465, _path2466, _path2467, _path2468, _path2469, _path2470, _path2471, _path2472, _path2473, _path2474, _path2475, _path2476, _path2477, _path2478, _path2479, _path2480, _path2481, _path2482, _path2483, _path2484, _path2485, _path2486, _path2487, _path2488, _path2489, _path2490, _path2491, _path2492, _path2493, _path2494, _path2495, _path2496, _path2497, _path2498, _path2499, _path2500, _path2501, _path2502, _path2503, _path2504, _path2505, _path2506, _path2507, _path2508, _path2509, _path2510, _path2511, _path2512, _path2513, _path2514, _path2515, _path2516, _path2517, _path2518, _path2519, _path2520, _path2521, _path2522, _path2523, _path2524, _path2525, _path2526, _path2527, _path2528, _path2529, _path2530, _path2531, _path2532, _path2533, _path2534, _path2535, _path2536, _path2537, _path2538, _path2539, _path2540, _path2541, _path2542, _path2543, _path2544, _path2545, _path2546, _path2547, _path2548, _path2549, _path2550, _path2551, _path2552, _path2553, _path2554, _path2555, _path2556, _path2557, _path2558, _path2559, _path2560, _path2561, _path2562, _path2563, _path2564, _path2565, _path2566, _path2567, _path2568, _path2569, _path2570, _path2571, _path2572, _path2573, _path2574, _path2575, _path2576, _path2577, _path2578, _path2579, _path2580, _path2581, _path2582, _path2583, _path2584, _path2585, _path2586, _path2587, _path2588, _path2589, _path2590, _path2591, _path2592, _path2593, _path2594, _path2595, _path2596, _path2597, _path2598, _path2599, _path2600, _path2601;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 812,
    height: 812,
    viewBox: "0 0 812 812",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M296.043 2.93568L288.554 0.388382L287.917 2.26131L295.406 4.80861L296.043 2.93568Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M315.078 15.9012L307.7 13.3918L307.073 15.2362L314.451 17.7456L315.078 15.9012Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M331.366 23.3162L324.021 20.8183L323.397 22.6549L330.741 25.1528L331.366 23.3162Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M342.508 17.9895L335.008 15.4386L334.37 17.3167L341.869 19.8676L342.508 17.9895Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M356.692 19.384L349.129 16.812L348.486 18.7031L356.048 21.2751L356.692 19.384Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M379.403 45.2142L372.155 42.7489L371.538 44.5621L378.786 47.0274L379.403 45.2142Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M406.385 88.4928L399.728 86.2287L399.161 87.8941L405.818 90.1582L406.385 88.4928Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M428.873 123.7L422.687 121.596L422.162 123.142L428.347 125.246L428.873 123.7Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M446.651 147.47L440.775 145.471L440.274 146.942L446.151 148.941L446.651 147.47Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M460.763 160.032L455.021 158.079L454.532 159.519L460.273 161.472L460.763 160.032Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M471.133 155.751L465.254 153.751L464.754 155.222L470.633 157.221L471.133 155.751Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M478.872 131.635L472.534 129.479L471.995 131.064L478.333 133.22L478.872 131.635Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M488.226 105.733L481.382 103.405L480.8 105.117L487.644 107.445L488.226 105.733Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M500.774 92.3782L493.629 89.9482L493.022 91.7356L500.166 94.1656L500.774 92.3782Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M515.026 86.6474L507.697 84.1547L507.073 85.9888L514.402 88.4814L515.026 86.6474Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M530.005 80.0787L522.476 77.5181L521.836 79.4014L529.364 81.9619L530.005 80.0787Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M545.853 71.5941L538.083 68.9515L537.422 70.8945L545.192 73.537L545.853 71.5941Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M562.575 65.9828L554.608 63.2732L553.931 65.2655L561.897 67.9751L562.575 65.9828Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M579.254 70.6483L571.271 67.9334L570.593 69.9283L578.575 72.6432L579.254 70.6483Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M595.289 81.0771L587.392 78.3913L586.72 80.368L594.616 83.0538L595.289 81.0771Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M611.906 85.6843L603.989 82.9914L603.316 84.9707L611.233 87.6635L611.906 85.6843Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M630.001 83.4396L621.941 80.6983L621.255 82.7139L629.315 85.4552L630.001 83.4396Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M646.549 90.1215L638.507 87.3863L637.823 89.3967L645.865 92.1319L646.549 90.1215Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M659.733 108.176L651.924 105.52L651.261 107.471L659.069 110.127L659.733 108.176Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M671.453 127.368L663.907 124.802L663.265 126.688L670.812 129.254L671.453 127.368Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M683.773 141.694L676.403 139.187L675.776 141.031L683.146 143.538L683.773 141.694Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M695.086 156.429L687.905 153.987L687.294 155.782L694.475 158.224L695.086 156.429Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M703.786 174.771L696.869 172.418L696.281 174.149L703.197 176.501L703.786 174.771Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M709.985 195.419L703.388 193.175L702.826 194.828L709.423 197.072L709.985 195.419Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M717.579 210.837L711.204 208.669L710.662 210.265L717.036 212.433L717.579 210.837Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M731.872 213.731L725.463 211.551L724.917 213.157L731.325 215.336L731.872 213.731Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M754.484 204.615L747.786 202.337L747.216 204.013L753.914 206.291L754.484 204.615Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M784.06 188.06L776.9 185.625L776.292 187.412L783.452 189.847L784.06 188.06Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M819.889 166.653L812.153 164.022L811.495 165.958L819.231 168.589L819.889 166.653Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M858.051 146.182L849.734 143.353L849.026 145.434L857.343 148.263L858.051 146.182Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M890.098 135.894L881.416 132.941L880.677 135.112L889.36 138.065L890.098 135.894Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M912.929 137.162L904.135 134.171L903.387 136.371L912.181 139.361L912.929 137.162Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M931.259 143.387L922.465 140.396L921.717 142.596L930.511 145.587L931.259 143.387Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M954.042 145.579L945.152 142.556L944.396 144.779L953.286 147.802L954.042 145.579Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M983.957 142.166L974.833 139.063L974.058 141.343L983.181 144.446L983.957 142.166Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1008.38 144.285L999.147 141.145L998.361 143.453L1007.59 146.593L1008.38 144.285Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1011.3 163.19L1002.38 160.155L1001.62 162.386L1010.54 165.421L1011.3 163.19Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M1000.22 190.764L991.836 187.914L991.123 190.01L999.505 192.86L1000.22 190.764Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M996.71 210.913L988.696 208.187L988.015 210.19L996.028 212.915L996.71 210.913Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1002.76 223.414L994.932 220.75L994.267 222.706L1002.1 225.37L1002.76 223.414Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1005.19 237.41L997.584 234.823L996.937 236.725L1004.54 239.312L1005.19 237.41Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M991.04 260.104L983.911 257.679L983.304 259.464L990.433 261.888L991.04 260.104Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M968.434 285.669L961.88 283.44L961.323 285.079L967.876 287.308L968.434 285.669Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M951.269 306.344L945.172 304.271L944.654 305.796L950.751 307.869L951.269 306.344Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M944.774 320.16L938.952 318.18L938.456 319.638L944.278 321.618L944.774 320.16Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M939.25 332.581L933.677 330.686L933.202 332.081L938.775 333.977L939.25 332.581Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M286.621 10.2976L279.01 7.70889L278.363 9.61034L285.975 12.1991L286.621 10.2976Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M312.542 36.9765L305.252 34.4971L304.632 36.3207L311.922 38.8001L312.542 36.9765Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M331.505 50.6123L324.343 48.1761L323.734 49.9661L330.897 52.4022L331.505 50.6123Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M344.727 51.6188L337.502 49.1615L336.888 50.9669L344.113 53.4243L344.727 51.6188Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M359.678 56.4896L352.45 54.0314L351.836 55.8369L359.064 58.2951L359.678 56.4896Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M380.381 77.2001L373.4 74.8257L372.807 76.5689L379.788 78.9433L380.381 77.2001Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M403.635 108.274L397.069 106.041L396.51 107.683L403.077 109.916L403.635 108.274Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M423.246 132.5L416.997 130.374L416.465 131.936L422.715 134.062L423.246 132.5Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M437.354 140.913L431.169 138.81L430.643 140.358L436.828 142.462L437.354 140.913Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M449.632 142.78L443.408 140.663L442.878 142.222L449.102 144.339L449.632 142.78Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M462.089 144.768L455.824 142.637L455.291 144.203L461.556 146.334L462.089 144.768Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M473.407 139.385L466.976 137.197L466.429 138.806L472.86 140.993L473.407 139.385Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M483.986 124.272L477.218 121.97L476.643 123.662L483.411 125.964L483.986 124.272Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M495.874 108.768L488.753 106.346L488.146 108.128L495.268 110.55L495.874 108.768Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M509.56 98.2605L502.166 95.7459L501.538 97.5928L508.932 100.108L509.56 98.2605Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M524.553 92.7992L516.97 90.2202L516.325 92.1165L523.908 94.6955L524.553 92.7992Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M540.347 88.6666L532.59 86.0284L531.931 87.9662L539.688 90.6044L540.347 88.6666Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M556.699 88.7813L548.849 86.1114L548.182 88.0725L556.032 90.7424L556.699 88.7813Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M572.611 100.216L564.87 97.5833L564.211 99.5211L571.952 102.154L572.611 100.216Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M587.582 115.721L580.025 113.151L579.382 115.042L586.939 117.612L587.582 115.721Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M603.389 120.687L595.827 118.115L595.184 120.006L602.746 122.578L603.389 120.687Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M620.819 117.649L613.094 115.021L612.436 116.954L620.162 119.581L620.819 117.649Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M637.087 122.417L629.348 119.785L628.69 121.721L636.428 124.352L637.087 122.417Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M649.068 142.332L641.612 139.796L640.978 141.661L648.433 144.197L649.068 142.332Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M658.203 166.838L651.136 164.435L650.534 166.204L657.601 168.607L658.203 166.838Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M669.447 181.035L662.561 178.693L661.976 180.413L668.862 182.755L669.447 181.035Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M681.503 191.225L674.732 188.922L674.156 190.616L680.927 192.919L681.503 191.225Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M692.575 202.382L685.933 200.123L685.368 201.786L692.009 204.045L692.575 202.382Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M704.693 210.333L698.121 208.098L697.563 209.74L704.134 211.975L704.693 210.333Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M721.139 210.254L714.467 207.985L713.899 209.653L720.572 211.922L721.139 210.254Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M738.165 210.089L731.383 207.782L730.807 209.476L737.589 211.782L738.165 210.089Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M756.157 209.311L749.253 206.963L748.666 208.691L755.569 211.039L756.157 209.311Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M778.463 203.666L771.324 201.237L770.717 203.022L777.856 205.45L778.463 203.666Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M808.521 190.032L800.951 187.458L800.307 189.351L807.877 191.926L808.521 190.032Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M842.435 174.64L834.377 171.899L833.692 173.912L841.75 176.653L842.435 174.64Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M872.402 166.289L864.013 163.436L863.299 165.535L871.689 168.388L872.402 166.289Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M891.394 170.732L882.968 167.866L882.252 169.972L890.677 172.838L891.394 170.732Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M905.3 180.103L896.957 177.266L896.248 179.352L904.59 182.189L905.3 180.103Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M928.039 181.326L919.577 178.448L918.858 180.562L927.32 183.44L928.039 181.326Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M962.78 173.259L953.966 170.261L953.216 172.466L962.03 175.464L962.78 173.259Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M989.507 173.05L980.524 169.995L979.76 172.241L988.743 175.297L989.507 173.05Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M993.142 190.401L984.447 187.444L983.708 189.618L992.403 192.575L993.142 190.401Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M984.918 214.659L976.71 211.867L976.012 213.919L984.22 216.71L984.918 214.659Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M986.702 230.416L978.767 227.717L978.092 229.702L986.027 232.401L986.702 230.416Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M1000.6 237.659L992.712 234.975L992.041 236.949L999.932 239.633L1000.6 237.659Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M1008.27 248.339L1000.53 245.706L999.87 247.643L1007.61 250.277L1008.27 248.339Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M995.746 269.594L988.461 267.116L987.842 268.937L995.126 271.415L995.746 269.594Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M975.664 293.138L968.924 290.845L968.351 292.531L975.091 294.824L975.664 293.138Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M963.627 310.81L957.276 308.65L956.736 310.235L963.088 312.395L963.627 310.81Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M956.108 325.039L950.06 322.982L949.547 324.492L955.594 326.549L956.108 325.039Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M948.277 338.418L942.52 336.46L942.029 337.902L947.786 339.86L948.277 338.418Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M280.364 24.5185L272.729 21.9218L272.08 23.8311L279.715 26.4278L280.364 24.5185Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M309.509 56.444L302.284 53.9867L301.67 55.7922L308.895 58.2495L309.509 56.444Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M330.801 74.8021L323.786 72.4162L323.189 74.1697L330.204 76.5556L330.801 74.8021Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M345.364 79.6568L338.346 77.27L337.75 79.0236L344.767 81.4104L345.364 79.6568Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M360.542 85.9769L353.548 83.5981L352.953 85.3465L359.947 87.7253L360.542 85.9769Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M379.856 103.199L373.059 100.888L372.481 102.587L379.278 104.899L379.856 103.199Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M400.155 125.251L393.643 123.036L393.089 124.666L399.601 126.88L400.155 125.251Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M416.604 138.724L410.24 136.559L409.701 138.147L416.065 140.311L416.604 138.724Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M428.249 137.758L421.794 135.563L421.244 137.179L427.699 139.374L428.249 137.758Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M439.735 134.858L433.153 132.619L432.594 134.264L439.176 136.503L439.735 134.858Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M453.227 138.547L446.628 136.302L446.065 137.955L452.665 140.199L453.227 138.547Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M466.212 139.322L459.542 137.054L458.975 138.722L465.645 140.99L466.212 139.322Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M478.062 131.406L471.169 129.061L470.582 130.786L477.476 133.131L478.062 131.406Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M490.546 121.363L483.383 118.927L482.774 120.717L489.937 123.153L490.546 121.363Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M504.345 113.976L496.959 111.464L496.331 113.311L503.717 115.823L504.345 113.976Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M519.285 110.575L511.736 108.007L511.095 109.893L518.644 112.461L519.285 110.575Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M534.945 111.542L527.318 108.948L526.669 110.855L534.296 113.449L534.945 111.542Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M550.803 118.392L543.199 115.806L542.552 117.707L550.156 120.293L550.803 118.392Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M565.891 135.262L558.51 132.752L557.883 134.596L565.264 137.107L565.891 135.262Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M579.896 153.284L572.764 150.858L572.157 152.643L579.289 155.068L579.896 153.284Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M594.753 158.397L587.621 155.972L587.015 157.754L594.147 160.179L594.753 158.397Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M611.141 155.486L603.852 153.006L603.231 154.83L610.521 157.309L611.141 155.486Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M626.825 158.594L619.491 156.1L618.867 157.934L626.201 160.428L626.825 158.594Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M638.78 175.447L631.69 173.035L631.086 174.81L638.177 177.221L638.78 175.447Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M647.923 197.429L641.185 195.138L640.613 196.821L647.35 199.113L647.923 197.429Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M659.135 209.61L652.553 207.371L651.994 209.016L658.575 211.254L659.135 209.61Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M673.11 213.657L666.515 211.414L665.954 213.063L672.549 215.306L673.11 213.657Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M688.035 215.873L681.388 213.613L680.823 215.276L687.47 217.536L688.035 215.873Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M705.168 214.491L698.384 212.184L697.808 213.878L704.592 216.185L705.168 214.491Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M726.175 207.715L719.134 205.32L718.534 207.084L725.575 209.479L726.175 207.715Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M744.62 206.924L737.442 204.483L736.831 206.278L744.009 208.719L744.62 206.924Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M759.284 212.418L752.113 209.979L751.505 211.769L758.675 214.208L759.284 212.418Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M775.123 216.32L767.929 213.873L767.317 215.671L774.511 218.118L775.123 216.32Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M798.291 211.628L790.859 209.1L790.227 210.958L797.659 213.485L798.291 211.628Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M826.921 202.302L819.134 199.653L818.471 201.601L826.259 204.25L826.921 202.302Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M854.463 196.151L846.382 193.402L845.695 195.423L853.776 198.172L854.463 196.151Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M872.393 200.822L864.286 198.065L863.596 200.093L871.703 202.851L872.393 200.822Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M885.385 210.074L877.366 207.347L876.684 209.352L884.703 212.079L885.385 210.074Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M906.801 211.784L898.681 209.022L897.991 211.054L906.11 213.815L906.801 211.784Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M939.642 204.973L931.183 202.095L930.464 204.21L938.923 207.087L939.642 204.973Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M965.097 205.153L956.477 202.221L955.744 204.377L964.364 207.309L965.097 205.153Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M971.087 219.612L962.703 216.76L961.99 218.857L970.374 221.708L971.087 219.612Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M968.76 238.559L960.747 235.833L960.065 237.839L968.078 240.564L968.76 238.559Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M976.865 249.566L969.004 246.893L968.336 248.857L976.197 251.53L976.865 249.566Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M996.05 253.49L988.143 250.8L987.469 252.78L995.376 255.469L996.05 253.49Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M1007.41 261.923L999.584 259.262L998.919 261.218L1006.74 263.879L1007.41 261.923Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M999.163 280.295L991.738 277.77L991.107 279.624L998.532 282.15L999.163 280.295Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M986.136 299.643L979.157 297.269L978.564 299.012L985.543 301.386L986.136 299.643Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M982.596 313.054L975.892 310.774L975.321 312.452L982.025 314.733L982.596 313.054Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M981.799 324.348L975.31 322.141L974.759 323.762L981.247 325.969L981.799 324.348Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M977.582 336.398L971.345 334.276L970.814 335.835L977.051 337.957L977.582 336.398Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M274.672 39.9271L267.027 37.3269L266.377 39.2387L274.022 41.839L274.672 39.9271Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M306.044 74.6448L298.871 72.2051L298.261 73.9976L305.434 76.4373L306.044 74.6448Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M329.022 95.8108L322.111 93.4602L321.524 95.1878L328.435 97.5384L329.022 95.8108Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M343.167 100.176L336.248 97.8228L335.66 99.553L342.579 101.906L343.167 100.176Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M357.567 105.044L350.648 102.691L350.059 104.421L356.978 106.775L357.567 105.044Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M376.512 120.935L369.777 118.644L369.205 120.328L375.94 122.618L376.512 120.935Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M395.647 139.094L389.137 136.88L388.583 138.51L395.092 140.723L395.647 139.094Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M409.82 145.487L403.344 143.284L402.794 144.903L409.269 147.105L409.82 145.487Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M421.016 142.861L414.416 140.616L413.854 142.268L420.454 144.513L421.016 142.861Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M432.997 141.295L426.286 139.012L425.715 140.691L432.426 142.973L432.997 141.295Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M446.117 142.609L439.341 140.304L438.766 141.995L445.542 144.3L446.117 142.609Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M458.184 137.943L451.239 135.581L450.648 137.319L457.593 139.681L458.184 137.943Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M470.746 132.289L463.606 129.861L462.999 131.645L470.139 134.074L470.746 132.289Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M484.873 132.13L477.632 129.668L477.015 131.481L484.256 133.943L484.873 132.13Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M499.532 133.325L492.219 130.837L491.596 132.669L498.909 135.156L499.532 133.325Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M514.331 132.127L506.896 129.598L506.264 131.456L513.699 133.984L514.331 132.127Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M529.8 136.578L522.35 134.044L521.716 135.909L529.166 138.443L529.8 136.578Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M545.241 148.371L537.918 145.88L537.295 147.711L544.619 150.202L545.241 148.371Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M559.911 164.531L552.806 162.115L552.201 163.892L559.307 166.308L559.911 164.531Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M573.9 177.879L566.968 175.522L566.379 177.254L573.311 179.612L573.9 177.879Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M588.163 184.111L581.254 181.761L580.667 183.489L587.575 185.838L588.163 184.111Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M602.248 190.635L595.376 188.297L594.791 190.017L601.663 192.355L602.248 190.635Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M616.031 197.817L609.208 195.497L608.627 197.204L615.45 199.524L616.031 197.817Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M628.944 207.274L622.217 204.986L621.646 206.667L628.373 208.955L628.944 207.274Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M640.613 219.1L634.041 216.865L633.483 218.507L640.054 220.742L640.613 219.1Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M652.891 227.432L646.402 225.225L645.851 226.847L652.339 229.054L652.891 227.432Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M670.109 223.57L663.429 221.298L662.86 222.969L669.541 225.241L670.109 223.57Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M689.737 216.681L682.789 214.318L682.198 216.056L689.146 218.419L689.737 216.681Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M710.304 210.476L703.099 208.026L702.486 209.828L709.69 212.279L710.304 210.476Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M732.722 203.378L725.227 200.829L724.59 202.705L732.084 205.254L732.722 203.378Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M751.489 203.961L743.881 201.373L743.234 203.275L750.843 205.863L751.489 203.961Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M760.753 218.376L753.364 215.863L752.736 217.71L760.124 220.223L760.753 218.376Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M768.451 233.291L761.306 230.861L760.699 232.646L767.844 235.076L768.451 233.291Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M786.806 234.337L779.558 231.871L778.941 233.684L786.19 236.15L786.806 234.337Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M814.44 226.009L806.844 223.425L806.199 225.324L813.794 227.907L814.44 226.009Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M841.411 220.286L833.522 217.602L832.851 219.576L840.74 222.26L841.411 220.286Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M863.406 220.719L855.38 217.989L854.697 219.997L862.723 222.727L863.406 220.719Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M881.828 224.939L873.763 222.195L873.077 224.211L881.142 226.954L881.828 224.939Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M899.78 229.73L891.686 226.978L890.998 229.001L899.092 231.754L899.78 229.73Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M918.041 234.405L909.919 231.642L909.227 233.676L917.35 236.438L918.041 234.405Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M935.595 239.715L927.457 236.947L926.764 238.983L934.902 241.751L935.595 239.715Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M950.34 246.95L942.247 244.197L941.558 246.22L949.652 248.973L950.34 246.95Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M963.382 255.078L955.361 252.35L954.679 254.356L962.7 257.084L963.382 255.078Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M977.574 262.241L969.599 259.529L968.922 261.521L976.896 264.233L977.574 262.241Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M993.519 268.263L985.555 265.555L984.878 267.544L992.842 270.253L993.519 268.263Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M1003.36 277.44L995.515 274.771L994.848 276.732L1002.7 279.401L1003.36 277.44Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M1001.06 292.226L993.515 289.661L992.874 291.547L1000.42 294.112L1001.06 292.226Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M997.376 306.629L990.141 304.168L989.525 305.979L996.76 308.439L997.376 306.629Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M1003 315.923L995.914 313.512L995.311 315.286L1002.4 317.698L1003 315.923Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M1014.02 322.51L1006.99 320.118L1006.39 321.88L1013.43 324.272L1014.02 322.51Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M1017.83 331.769L1010.95 329.43L1010.36 331.152L1017.24 333.491L1017.83 331.769Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M269.052 55.5138L261.402 52.9119L260.752 54.8237L268.402 57.4257L269.052 55.5138Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M301.726 90.9637L294.576 88.5319L293.968 90.3193L301.118 92.751L301.726 90.9637Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M325.468 112.76L318.601 110.424L318.017 112.141L324.884 114.477L325.468 112.76Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M338.865 115.803L331.964 113.456L331.378 115.181L338.278 117.528L338.865 115.803Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M352.514 119.151L345.59 116.796L345 118.529L351.925 120.884L352.514 119.151Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M371.507 134.444L364.761 132.15L364.188 133.836L370.933 136.13L371.507 134.444Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M390.484 151.312L383.954 149.091L383.399 150.725L389.929 152.946L390.484 151.312Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M403.691 154.872L397.143 152.644L396.586 154.281L403.134 156.508L403.691 154.872Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M415.093 152.967L408.423 150.698L407.856 152.366L414.526 154.635L415.093 152.967Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M427.605 153.237L420.854 150.941L420.28 152.63L427.03 154.926L427.605 153.237Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M440.205 152.675L433.356 150.346L432.774 152.058L439.623 154.387L440.205 152.675Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M451.141 143.524L444.025 141.104L443.42 142.884L450.536 145.304L451.141 143.524Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M463.935 138.499L456.629 136.014L456.007 137.843L463.313 140.327L463.935 138.499Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M479.277 144.406L471.985 141.925L471.363 143.752L478.656 146.232L479.277 144.406Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M494.693 151.304L487.434 148.835L486.816 150.651L494.075 153.12L494.693 151.304Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M509.417 151.797L502.065 149.297L501.439 151.136L508.791 153.636L509.417 151.797Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M524.778 157.997L517.444 155.503L516.82 157.337L524.154 159.831L524.778 157.997Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M540.068 171.97L532.918 169.538L532.309 171.328L539.459 173.759L540.068 171.97Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M554.581 186.378L547.626 184.013L547.035 185.751L553.99 188.116L554.581 186.378Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M568.692 195.736L561.83 193.402L561.246 195.119L568.108 197.453L568.692 195.736Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M582.709 202.706L575.891 200.387L575.311 202.094L582.129 204.413L582.709 202.706Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M595.417 215.881L588.781 213.624L588.216 215.284L594.853 217.542L595.417 215.881Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M607.987 226.052L601.473 223.836L600.919 225.465L607.433 227.681L607.987 226.052Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M621.597 230.536L615.08 228.319L614.526 229.949L621.043 232.165L621.597 230.536Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M635.134 235.276L628.617 233.06L628.063 234.689L634.58 236.905L635.134 235.276Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M648.359 240.79L641.865 238.582L641.313 240.205L647.807 242.414L648.359 240.79Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M667.592 232.467L660.792 230.155L660.214 231.854L667.014 234.166L667.592 232.467Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M689.819 221.119L682.632 218.675L682.022 220.47L689.208 222.914L689.819 221.119Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M711.884 213.52L704.387 210.97L703.749 212.845L711.246 215.395L711.884 213.52Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M734.489 207.576L726.711 204.931L726.05 206.874L733.828 209.519L734.489 207.576Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M753.192 209.446L745.321 206.769L744.652 208.735L752.523 211.412L753.192 209.446Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M759.089 229.016L751.579 226.462L750.94 228.34L758.451 230.894L759.089 229.016Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M762.058 249.808L754.955 247.392L754.35 249.169L761.453 251.584L762.058 249.808Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M778.222 253.305L771.078 250.875L770.471 252.66L777.615 255.09L778.222 253.305Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M806.031 244.973L798.521 242.419L797.882 244.297L805.393 246.851L806.031 244.973Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M832.708 239.715L824.9 237.059L824.235 239.012L832.044 241.668L832.708 239.715Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M857.441 237.696L849.42 234.968L848.738 236.973L856.759 239.701L857.441 237.696Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M879.638 238.829L871.485 236.056L870.791 238.095L878.944 240.868L879.638 238.829Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M894.955 245.891L886.84 243.131L886.15 245.16L894.265 247.92L894.955 245.891Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M902.578 258.347L894.666 255.656L893.993 257.635L901.905 260.326L902.578 258.347Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M914.399 267.105L906.585 264.448L905.921 266.401L913.734 269.059L914.399 267.105Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M935.378 269.659L927.47 266.97L926.798 268.946L934.705 271.636L935.378 269.659Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M959.242 270.867L951.194 268.13L950.511 270.141L958.558 272.878L959.242 270.867Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M977.556 275.707L969.478 272.96L968.791 274.981L976.869 277.728L977.556 275.707Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M991.211 283.104L983.19 280.376L982.508 282.381L990.529 285.109L991.211 283.104Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M1000.76 292.329L992.865 289.643L992.193 291.617L1000.09 294.303L1000.76 292.329Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M1003.74 304.204L996.065 301.593L995.412 303.513L1003.09 306.123L1003.74 304.204Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M1007.11 315.18L999.637 312.639L999.001 314.51L1006.47 317.051L1007.11 315.18Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M1019.15 321.933L1011.73 319.41L1011.1 321.265L1018.52 323.788L1019.15 321.933Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M1038.39 325.714L1030.92 323.172L1030.28 325.042L1037.76 327.584L1038.39 325.714Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M1047.96 333.226L1040.57 330.713L1039.94 332.558L1047.33 335.071L1047.96 333.226Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M266.938 76.8134L259.378 74.2423L258.736 76.1308L266.296 78.7019L266.938 76.8134Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M294.792 102.7L287.588 100.249L286.975 102.05L294.18 104.5L294.792 102.7Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M317.066 120.764L310.088 118.39L309.494 120.136L316.472 122.51L317.066 120.764Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M331.859 126.195L324.888 123.824L324.296 125.564L331.267 127.935L331.859 126.195Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M346.671 131.71L339.711 129.343L339.119 131.083L346.079 133.451L346.671 131.71Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M365.545 145.984L358.755 143.675L358.178 145.371L364.968 147.68L365.545 145.984Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M384.363 161.509L377.771 159.267L377.209 160.917L383.802 163.159L384.363 161.509Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M397.614 164.972L390.999 162.722L390.436 164.377L397.051 166.627L397.614 164.972Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M408.474 161.751L401.711 159.451L401.136 161.142L407.899 163.443L408.474 161.751Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M420.592 160.643L413.715 158.304L413.13 160.024L420.008 162.363L420.592 160.643Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M434.154 162.946L427.227 160.59L426.639 162.321L433.566 164.676L434.154 162.946Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M447.058 162.004L440.014 159.608L439.414 161.372L446.458 163.768L447.058 162.004Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M460.327 160.735L453.159 158.297L452.55 160.089L459.718 162.527L460.327 160.735Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M474.771 163.175L467.548 160.719L466.934 162.524L474.157 164.981L474.771 163.175Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M489.507 166.144L482.24 163.673L481.622 165.491L488.888 167.962L489.507 166.144Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M504.204 167.108L496.854 164.609L496.229 166.448L503.578 168.947L504.204 167.108Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M519.57 173.107L512.236 170.613L511.611 172.449L518.945 174.944L519.57 173.107Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M534.988 186.073L527.82 183.635L527.211 185.425L534.379 187.863L534.988 186.073Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M549.626 201.815L542.687 199.455L542.096 201.19L549.036 203.55L549.626 201.815Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M563.546 213.843L556.765 211.536L556.189 213.23L562.97 215.536L563.546 213.843Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M577.52 219.843L570.767 217.546L570.194 219.232L576.947 221.529L577.52 219.843Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M591.264 226.476L584.555 224.195L583.984 225.873L590.693 228.155L591.264 226.476Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M604.854 232.983L598.184 230.714L597.617 232.382L604.287 234.651L604.854 232.983Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M618.569 238.351L611.914 236.087L611.349 237.75L618.003 240.013L618.569 238.351Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M632.168 243.87L625.534 241.614L624.969 243.274L631.603 245.53L632.168 243.87Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M645.768 249.132L639.147 246.881L638.583 248.538L645.204 250.79L645.768 249.132Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M664.362 243.07L657.474 240.727L656.887 242.452L663.775 244.795L664.362 243.07Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M685.696 234.185L678.458 231.723L677.842 233.534L685.08 235.996L685.696 234.185Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M706.462 229.333L698.967 226.784L698.33 228.659L705.824 231.208L706.462 229.333Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M726.495 227.684L718.819 225.073L718.166 226.993L725.842 229.603L726.495 227.684Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M744.31 230.539L736.567 227.905L735.908 229.843L743.651 232.477L744.31 230.539Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M753.848 244.555L746.335 242L745.696 243.878L753.209 246.433L753.848 244.555Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M761.017 259.895L753.784 257.435L753.168 259.246L760.401 261.706L761.017 259.895Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M776.963 264.077L769.699 261.607L769.081 263.425L776.344 265.896L776.963 264.077Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M801.849 259.489L794.305 256.923L793.664 258.809L801.208 261.375L801.849 259.489Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M826.584 256.522L818.793 253.872L818.131 255.82L825.921 258.47L826.584 256.522Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M848.219 257.426L840.289 254.729L839.614 256.714L847.544 259.411L848.219 257.426Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M867.059 261.209L859.071 258.492L858.392 260.49L866.379 263.206L867.059 261.209Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M882.852 267.489L874.886 264.78L874.208 266.772L882.175 269.482L882.852 267.489Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M894.889 276.266L887.024 273.591L886.355 275.557L894.221 278.233L894.889 276.266Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M909.004 283.298L901.188 280.64L900.523 282.593L908.34 285.252L909.004 283.298Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M928.455 286.933L920.574 284.252L919.904 286.221L927.785 288.902L928.455 286.933Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M950.266 289.48L942.282 286.765L941.602 288.762L949.587 291.478L950.266 289.48Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M968.678 294.206L960.66 291.478L959.978 293.484L967.996 296.211L968.678 294.206Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M981.933 301.596L973.977 298.89L973.3 300.88L981.256 303.586L981.933 301.596Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M992.88 309.852L985.02 307.179L984.352 309.142L992.212 311.816L992.88 309.852Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M1001.92 318.617L994.185 315.986L993.527 317.921L1001.26 320.552L1001.92 318.617Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M1013.52 325.954L1005.86 323.348L1005.21 325.267L1012.87 327.874L1013.52 325.954Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M1029.46 331.395L1021.8 328.789L1021.14 330.703L1028.81 333.31L1029.46 331.395Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M1045.82 336.678L1038.15 334.07L1037.5 335.99L1045.16 338.598L1045.82 336.678Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M1052.49 345.288L1044.95 342.725L1044.31 344.609L1051.85 347.171L1052.49 345.288Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M271.456 107.68L264.164 105.199L263.544 107.023L270.836 109.503L271.456 107.68Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M287.039 113.474L279.757 110.998L279.137 112.821L286.419 115.298L287.039 113.474Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M304.567 122.602L297.357 120.15L296.745 121.95L303.955 124.402L304.567 122.602Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M321.694 131.454L314.554 129.026L313.947 130.811L321.087 133.239L321.694 131.454Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M338.964 141.007L331.908 138.607L331.307 140.373L338.363 142.773L338.964 141.007Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M357.737 154.138L350.834 151.79L350.246 153.518L357.149 155.866L357.737 154.138Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M376.418 168.237L369.691 165.949L369.12 167.63L375.847 169.918L376.418 168.237Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M390.189 172.443L383.452 170.151L382.879 171.835L389.617 174.126L390.189 172.443Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M400.183 167.075L393.248 164.717L392.658 166.452L399.592 168.811L400.183 167.075Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M411.525 163.4L404.414 160.981L403.809 162.758L410.92 165.176L411.525 163.4Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M427.316 171.456L420.268 169.059L419.668 170.823L426.716 173.22L427.316 171.456Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M444.941 186.68L438.102 184.354L437.52 186.066L444.358 188.392L444.941 186.68Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M459.38 192.323L452.562 190.004L451.982 191.711L458.8 194.03L459.38 192.323Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M471.49 187.062L464.457 184.67L463.859 186.429L470.892 188.821L471.49 187.062Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M484.33 181.135L477.061 178.662L476.442 180.481L483.711 182.953L484.33 181.135Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M498.893 181.599L491.52 179.091L490.894 180.933L498.267 183.441L498.893 181.599Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M514.13 185.331L506.726 182.813L506.096 184.665L513.5 187.184L514.13 185.331Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M529.684 194.503L522.371 192.015L521.748 193.847L529.061 196.334L529.684 194.503Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M544.77 211.653L537.729 209.258L537.13 211.02L544.171 213.414L544.77 211.653Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M558.712 228.414L551.943 226.112L551.368 227.803L558.137 230.106L558.712 228.414Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M572.874 232.687L566.092 230.38L565.516 232.074L572.298 234.381L572.874 232.687Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M588.637 227.496L581.617 225.109L581.021 226.862L588.041 229.25L588.637 227.496Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M604.115 228.538L596.999 226.118L596.394 227.897L603.51 230.317L604.115 228.538Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M617.822 237.68L610.807 235.294L610.211 237.048L617.225 239.433L617.822 237.68Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M631.116 246.65L624.202 244.298L623.613 246.028L630.527 248.38L631.116 246.65Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M645.038 252.774L638.158 250.434L637.573 252.154L644.453 254.494L645.038 252.774Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M661.852 252.178L654.826 249.788L654.228 251.547L661.254 253.936L661.852 252.178Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M680.651 249.102L673.411 246.639L672.794 248.452L680.035 250.915L680.651 249.102Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M697.954 250.426L690.61 247.928L689.985 249.767L697.329 252.265L697.954 250.426Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M712.143 257.344L704.845 254.862L704.225 256.685L711.522 259.168L712.143 257.344Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M727.929 261.706L720.608 259.216L719.986 261.045L727.307 263.535L727.929 261.706Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M745.272 264.274L737.876 261.758L737.247 263.608L744.643 266.123L745.272 264.274Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M762.072 267.936L754.629 265.404L753.997 267.264L761.44 269.795L762.072 267.936Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M779.145 271.571L771.653 269.023L771.015 270.899L778.507 273.447L779.145 271.571Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M799.687 272.159L792.052 269.563L791.403 271.472L799.038 274.069L799.687 272.159Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M821.73 272.172L813.921 269.516L813.258 271.467L821.066 274.123L821.73 272.172Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M838.104 277.614L830.293 274.957L829.628 276.911L837.439 279.567L838.104 277.614Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M851.21 285.536L843.479 282.906L842.822 284.839L850.553 287.468L851.21 285.536Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M869.368 289.578L861.588 286.932L860.926 288.878L868.706 291.524L869.368 289.578Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M891.881 290.981L883.958 288.287L883.284 290.269L891.207 292.963L891.881 290.981Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M911.487 294.712L903.497 291.995L902.818 293.992L910.808 296.71L911.487 294.712Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M926.972 301.032L919.006 298.323L918.328 300.315L926.295 303.025L926.972 301.032Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M942.051 307.478L934.115 304.779L933.44 306.763L941.376 309.462L942.051 307.478Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M956.959 313.903L949.057 311.215L948.384 313.194L956.286 315.882L956.959 313.903Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M965.126 323.348L957.372 320.711L956.713 322.649L964.467 325.286L965.126 323.348Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M974.6 331.74L966.965 329.143L966.316 331.052L973.951 333.649L974.6 331.74Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M992.039 336.528L984.375 333.921L983.724 335.836L991.388 338.442L992.039 336.528Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M1016.86 338.584L1009.05 335.928L1008.38 337.879L1016.19 340.534L1016.86 338.584Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M1037.43 342.577L1029.55 339.898L1028.88 341.865L1036.76 344.543L1037.43 342.577Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M1044.93 351.137L1037.19 348.505L1036.54 350.441L1044.28 353.073L1044.93 351.137Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M1043.64 362.084L1036.16 359.539L1035.52 361.412L1043 363.956L1043.64 362.084Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M278.223 140.144L271.247 137.771L270.654 139.514L277.63 141.887L278.223 140.144Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M286.256 135.258L279.098 132.824L278.489 134.614L285.647 137.048L286.256 135.258Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M297.718 134.871L290.459 132.402L289.841 134.22L297.099 136.689L297.718 134.871Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M312.201 138.94L304.921 136.464L304.302 138.285L311.581 140.761L312.201 138.94Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M329.008 146.98L321.78 144.522L321.166 146.327L328.394 148.786L329.008 146.98Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M348.085 159.633L341.008 157.226L340.405 158.998L347.482 161.405L348.085 159.633Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M367.426 173.817L360.53 171.472L359.944 173.197L366.839 175.542L367.426 173.817Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M382.344 179.898L375.475 177.562L374.89 179.282L381.759 181.618L382.344 179.898Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M393.035 176.342L385.994 173.948L385.394 175.712L392.435 178.106L393.035 176.342Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M404.617 173.457L397.408 171.005L396.796 172.806L404.005 175.258L404.617 173.457Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M421.164 182.891L414.048 180.471L413.443 182.25L420.559 184.671L421.164 182.891Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M440.518 202.269L433.708 199.953L433.129 201.657L439.939 203.973L440.518 202.269Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M455.742 210.873L449.014 208.585L448.443 210.266L455.17 212.554L455.742 210.873Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M467.361 205.387L460.406 203.022L459.814 204.76L466.77 207.125L467.361 205.387Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M479.605 198.516L472.385 196.06L471.771 197.863L478.991 200.319L479.605 198.516Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M493.926 198.739L486.595 196.245L485.971 198.079L493.302 200.573L493.926 198.739Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M508.72 199.163L501.28 196.632L500.647 198.492L508.087 201.023L508.72 199.163Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M524.161 203.289L516.695 200.75L516.059 202.62L523.525 205.16L524.161 203.289Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M539.744 216.452L532.467 213.977L531.847 215.798L539.124 218.273L539.744 216.452Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M554.438 231.545L547.403 229.152L546.804 230.911L553.84 233.304L554.438 231.545Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M569.174 235.755L562.118 233.355L561.518 235.119L568.574 237.519L569.174 235.755Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M585.385 230.934L578.082 228.45L577.461 230.276L584.764 232.76L585.385 230.934Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M601.007 234.189L593.655 231.689L593.029 233.528L600.381 236.029L601.007 234.189Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M614.357 246.709L607.197 244.274L606.588 246.066L613.748 248.502L614.357 246.709Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M627.295 257.781L620.293 255.399L619.697 257.15L626.699 259.532L627.295 257.781Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M641.296 264.236L634.336 261.868L633.744 263.609L640.704 265.976L641.296 264.236Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M656.84 266.897L649.814 264.508L649.216 266.267L656.241 268.656L656.84 266.897Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M673.348 268.312L666.224 265.889L665.619 267.669L672.743 270.092L673.348 268.312Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M688.013 273.65L680.897 271.23L680.291 273.01L687.407 275.43L688.013 273.65Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M699.512 283.651L692.541 281.28L691.948 283.023L698.919 285.394L699.512 283.651Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M714.047 288.562L707.076 286.192L706.483 287.935L713.454 290.306L714.047 288.562Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M733.769 287.239L726.607 284.803L725.997 286.595L733.16 289.032L733.769 287.239Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M754.796 285.639L747.42 283.13L746.794 284.972L754.169 287.48L754.796 285.639Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M774.713 286.312L767.192 283.754L766.552 285.635L774.073 288.193L774.713 286.312Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M796.05 286.452L788.36 283.837L787.707 285.759L795.396 288.374L796.05 286.452Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M817.658 287.206L809.811 284.537L809.144 286.498L816.991 289.167L817.658 287.206Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M833.118 293.463L825.292 290.801L824.627 292.757L832.453 295.418L833.118 293.463Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M846.021 301.446L838.283 298.814L837.625 300.749L845.363 303.381L846.021 301.446Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M866.016 304.359L858.184 301.695L857.518 303.654L865.35 306.318L866.016 304.359Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M891.875 304.04L883.825 301.303L883.14 303.316L891.19 306.053L891.875 304.04Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M913.192 307.155L905.041 304.383L904.348 306.422L912.499 309.194L913.192 307.155Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M926.92 314.661L918.837 311.911L918.15 313.932L926.233 316.681L926.92 314.661Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M938.079 323.196L930.109 320.486L929.432 322.478L937.401 325.189L938.079 323.196Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M949.269 331.341L941.403 328.666L940.735 330.629L948.601 333.304L949.269 331.341Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M954.298 341.803L946.642 339.199L945.991 341.114L953.647 343.717L954.298 341.803Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M963.637 349.885L956.099 347.321L955.458 349.204L962.997 351.768L963.637 349.885Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M985.024 353.087L977.392 350.491L976.742 352.4L984.374 354.996L985.024 353.087Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M1015.44 353.405L1007.57 350.726L1006.9 352.695L1014.77 355.374L1015.44 353.405Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M1039.91 356.348L1031.9 353.625L1031.22 355.627L1039.23 358.35L1039.91 356.348Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M1047.91 364.675L1040.04 361.999L1039.37 363.968L1047.24 366.644L1047.91 364.675Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M1046.33 375.388L1038.73 372.803L1038.08 374.702L1045.68 377.287L1046.33 375.388Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M282.139 166.774L275.394 164.479L274.821 166.166L281.566 168.46L282.139 166.774Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M288.647 160.808L281.695 158.443L281.103 160.181L288.056 162.546L288.647 160.808Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M295.51 154.379L288.334 151.938L287.724 153.731L294.9 156.171L295.51 154.379Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M307.897 155.463L300.644 152.996L300.026 154.812L307.28 157.279L307.897 155.463Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M324.376 162.851L317.167 160.399L316.555 162.199L323.764 164.651L324.376 162.851Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M341.861 172.268L334.74 169.846L334.134 171.625L341.256 174.047L341.861 172.268Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M358.49 180.653L351.439 178.254L350.839 180.018L357.89 182.417L358.49 180.653Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M373.967 187.21L366.946 184.823L366.35 186.576L373.37 188.964L373.967 187.21Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M388.727 192.488L381.715 190.103L381.118 191.857L388.131 194.242L388.727 192.488Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M403.052 196.793L396.024 194.403L395.426 196.161L402.454 198.552L403.052 196.793Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M418.284 203.305L411.295 200.928L410.7 202.676L417.689 205.053L418.284 203.305Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M435.137 214.857L428.291 212.529L427.709 214.241L434.555 216.569L435.137 214.857Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M450.03 221.789L443.232 219.477L442.655 221.174L449.453 223.486L450.03 221.789Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M462.188 218.938L455.214 216.566L454.621 218.309L461.595 220.681L462.188 218.938Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M474.662 214.376L467.465 211.929L466.853 213.729L474.049 216.177L474.662 214.376Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M488.722 213.955L481.39 211.461L480.767 213.295L488.098 215.789L488.722 213.955Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M502.812 209.448L495.244 206.874L494.6 208.768L502.168 211.342L502.812 209.448Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M518.112 208.467L510.389 205.841L509.732 207.773L517.455 210.4L518.112 208.467Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M534.21 214.023L526.487 211.397L525.831 213.327L533.554 215.953L534.21 214.023Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M550.22 221.882L542.559 219.277L541.908 221.191L549.568 223.797L550.22 221.882Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M566.083 228.435L558.453 225.84L557.804 227.749L565.433 230.344L566.083 228.435Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M581.259 238.905L573.762 236.355L573.124 238.23L580.621 240.78L581.259 238.905Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M595.151 252.7L587.884 250.228L587.266 252.047L594.532 254.518L595.151 252.7Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M608.017 266.406L600.989 264.016L600.391 265.775L607.419 268.165L608.017 266.406Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M620.867 276.826L613.992 274.487L613.407 276.207L620.282 278.545L620.867 276.826Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M634.519 283.388L627.693 281.066L627.113 282.773L633.938 285.095L634.519 283.388Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M647.596 290.672L640.843 288.375L640.269 290.064L647.022 292.361L647.596 290.672Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M660.795 297.088L654.088 294.807L653.518 296.483L660.225 298.764L660.795 297.088Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M675.467 300.695L668.727 298.403L668.153 300.089L674.893 302.381L675.467 300.695Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M691.23 302.992L684.412 300.673L683.832 302.377L690.65 304.696L691.23 302.992Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M706.761 306.115L699.888 303.777L699.303 305.497L706.176 307.835L706.761 306.115Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M723.637 308.023L716.666 305.652L716.073 307.395L723.044 309.766L723.637 308.023Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M742.965 307.926L735.826 305.497L735.219 307.282L742.358 309.71L742.965 307.926Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M765.571 305.618L758.175 303.102L757.547 304.949L764.943 307.465L765.571 305.618Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M790.161 302.865L782.484 300.254L781.831 302.176L789.507 304.787L790.161 302.865Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M812.609 303.157L804.743 300.482L804.075 302.448L811.94 305.124L812.609 303.157Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M831.961 306.556L824.017 303.854L823.342 305.841L831.285 308.543L831.961 306.556Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M850.561 310.804L842.563 308.084L841.883 310.084L849.881 312.804L850.561 310.804Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M870.64 314.345L862.556 311.596L861.869 313.617L869.952 316.366L870.64 314.345Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M889.736 318.768L881.601 316.001L880.908 318.037L889.043 320.804L889.736 318.768Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M907.369 324.166L899.218 321.394L898.525 323.433L906.676 326.205L907.369 324.166Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M921.708 331.245L913.614 328.492L912.926 330.516L921.02 333.269L921.708 331.245Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M932.773 339.648L924.795 336.935L924.117 338.93L932.094 341.643L932.773 339.648Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M941.522 348.658L933.7 345.998L933.035 347.954L940.856 350.614L941.522 348.658Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M945.993 358.896L938.395 356.312L937.748 358.213L945.346 360.797L945.993 358.896Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M956.482 366.261L948.977 363.708L948.338 365.586L955.843 368.139L956.482 366.261Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M976.743 369.982L969.16 367.403L968.515 369.3L976.098 371.879L976.743 369.982Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M1004.04 371.683L996.258 369.037L995.597 370.983L1003.37 373.628L1004.04 371.683Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M1030.85 374.032L1022.9 371.329L1022.22 373.316L1030.17 376.019L1030.85 374.032Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M1049.6 379.059L1041.62 376.344L1040.94 378.341L1048.92 381.057L1049.6 379.059Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M1056.38 387.254L1048.54 384.589L1047.88 386.547L1055.71 389.212L1056.38 387.254Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M280.965 185.47L274.313 183.208L273.748 184.87L280.4 187.133L280.965 185.47Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M288.007 181.049L281.171 178.724L280.589 180.433L287.425 182.759L288.007 181.049Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M292.724 172.556L285.613 170.137L285.009 171.914L292.12 174.333L292.724 172.556Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M304.778 173.55L297.587 171.104L296.975 172.902L304.167 175.348L304.778 173.55Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M321.564 181.421L314.43 178.995L313.823 180.78L320.957 183.206L321.564 181.421Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M337.292 187.888L330.186 185.471L329.582 187.248L336.688 189.665L337.292 187.888Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M350.848 190.762L343.698 188.33L343.089 190.12L350.239 192.552L350.848 190.762Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M366.333 196.92L359.206 194.496L358.6 196.278L365.727 198.702L366.333 196.92Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M384.674 208.923L377.703 206.552L377.11 208.295L384.081 210.666L384.674 208.923Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M401.523 218.897L394.666 216.565L394.082 218.282L400.939 220.614L401.523 218.897Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M415.403 222.798L408.526 220.459L407.941 222.179L414.818 224.518L415.403 222.798Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M429.586 227.283L422.698 224.941L422.112 226.663L429 229.006L429.586 227.283Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M443.926 232.138L437.036 229.794L436.45 231.517L443.34 233.86L443.926 232.138Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M456.496 230.917L449.46 228.524L448.862 230.283L455.898 232.676L456.496 230.917Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M469.203 227.916L461.967 225.456L461.352 227.266L468.587 229.727L469.203 227.916Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M483.095 227.053L475.709 224.541L475.082 226.385L482.468 228.897L483.095 227.053Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M496.614 219.562L488.902 216.939L488.245 218.869L495.958 221.492L496.614 219.562Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M511.819 215.979L503.871 213.275L503.195 215.262L511.144 217.966L511.819 215.979Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M528.183 216.749L520.102 214L519.414 216.021L527.495 218.769L528.183 216.749Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M545.055 219.509L536.896 216.734L536.202 218.776L544.361 221.551L545.055 219.509Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M561.858 227.968L553.772 225.218L553.085 227.238L561.171 229.989L561.858 227.968Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M576.514 250.228L568.895 247.636L568.247 249.54L575.866 252.132L576.514 250.228Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M589.284 271.507L582.124 269.072L581.515 270.862L588.675 273.297L589.284 271.507Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M601.978 285.106L595.069 282.757L594.482 284.484L601.39 286.834L601.978 285.106Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M614.92 294.428L608.141 292.123L607.565 293.817L614.344 296.122L614.92 294.428Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M628.279 301.114L621.562 298.829L620.991 300.51L627.707 302.795L628.279 301.114Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M639.509 311.702L632.974 309.48L632.418 311.114L638.953 313.337L639.509 311.702Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M650.407 321.267L644.03 319.098L643.487 320.693L649.864 322.862L650.407 321.267Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M665.741 322.543L659.258 320.338L658.707 321.96L665.19 324.165L665.741 322.543Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M685.768 318.079L678.979 315.77L678.402 317.467L685.191 319.776L685.768 318.079Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M702.414 319.787L695.518 317.442L694.932 319.167L701.827 321.512L702.414 319.787Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M716.437 325.049L709.557 322.709L708.971 324.431L715.851 326.771L716.437 325.049Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M733.301 327.407L726.328 325.035L725.735 326.779L732.708 329.15L733.301 327.407Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M756.971 324.066L749.691 321.59L749.072 323.411L756.351 325.887L756.971 324.066Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M783.403 319.951L775.768 317.355L775.12 319.261L782.755 321.858L783.403 319.951Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M806.29 320.11L798.448 317.442L797.782 319.401L805.624 322.068L806.29 320.11Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M828.853 321.376L820.84 318.65L820.158 320.653L828.172 323.378L828.853 321.376Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M851.959 323.001L843.774 320.217L843.078 322.264L851.263 325.047L851.959 323.001Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M871.413 327.4L863.169 324.596L862.468 326.656L870.713 329.46L871.413 327.4Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M883.907 335.753L875.771 332.987L875.08 335.02L883.215 337.787L883.907 335.753Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M897.947 342.954L889.881 340.211L889.196 342.227L897.261 344.97L897.947 342.954Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M913.138 349.406L905.107 346.674L904.424 348.682L912.455 351.414L913.138 349.406Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M925.067 357.13L917.134 354.432L916.46 356.416L924.393 359.115L925.067 357.13Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M932.849 366.185L925.09 363.546L924.43 365.486L932.189 368.125L932.849 366.185Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M937.657 375.81L930.113 373.244L929.471 375.13L937.015 377.696L937.657 375.81Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M949.08 382.596L941.614 380.056L940.979 381.924L948.445 384.463L949.08 382.596Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M967.455 387.005L959.94 384.448L959.3 386.329L966.816 388.885L967.455 387.005Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M990.828 390.109L983.18 387.508L982.53 389.42L990.177 392.021L990.828 390.109Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M1018.56 392.376L1010.72 389.71L1010.05 391.671L1017.89 394.337L1018.56 392.376Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M1046.02 395.186L1038 392.459L1037.32 394.464L1045.34 397.191L1046.02 395.186Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M1059.81 401.529L1051.84 398.818L1051.16 400.81L1059.13 403.521L1059.81 401.529Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M274.656 197.401L267.966 195.126L267.396 196.799L274.087 199.074L274.656 197.401Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M281.538 193.253L274.661 190.914L274.076 192.634L280.953 194.973L281.538 193.253Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M286.695 186.061L279.559 183.634L278.952 185.419L286.088 187.846L286.695 186.061Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M298.949 187.532L291.735 185.078L291.121 186.881L298.336 189.335L298.949 187.532Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M315.721 195.149L308.56 192.714L307.951 194.506L315.111 196.942L315.721 195.149Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M331.793 201.987L324.675 199.566L324.069 201.346L331.188 203.767L331.793 201.987Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M346.015 206.043L338.873 203.614L338.265 205.401L345.407 207.83L346.015 206.043Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M361.337 211.865L354.213 209.442L353.607 211.224L360.731 213.647L361.337 211.865Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M378.416 221.019L371.388 218.629L370.789 220.388L377.817 222.778L378.416 221.019Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M394.37 228.622L387.404 226.253L386.812 227.994L393.778 230.363L394.37 228.622Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M407.998 231.639L400.986 229.254L400.391 231.005L407.403 233.39L407.998 231.639Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M421.497 233.95L414.42 231.543L413.817 233.315L420.894 235.722L421.497 233.95Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M435.824 237.824L428.715 235.406L428.111 237.183L435.219 239.601L435.824 237.824Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M449.463 239.286L442.264 236.837L441.652 238.637L448.851 241.086L449.463 239.286Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M463.103 239.488L455.774 236.995L455.151 238.827L462.48 241.319L463.103 239.488Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M477.086 239.022L469.606 236.479L468.97 238.349L476.449 240.893L477.086 239.022Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M490.492 231.864L482.676 229.205L482.011 231.159L489.827 233.817L490.492 231.864Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M505.779 229.153L497.734 226.417L497.051 228.428L505.095 231.164L505.779 229.153Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M522.409 232.891L514.31 230.136L513.622 232.159L521.721 234.914L522.409 232.891Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M539.283 238.887L531.192 236.135L530.504 238.156L538.596 240.908L539.283 238.887Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M556.023 246.691L547.991 243.959L547.308 245.967L555.34 248.699L556.023 246.691Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M571.422 263.522L563.725 260.904L563.071 262.829L570.768 265.447L571.422 263.522Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M585.236 280.908L577.904 278.415L577.28 280.249L584.612 282.742L585.236 280.908Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M598.413 294.287L591.338 291.881L590.736 293.65L597.811 296.056L598.413 294.287Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M611.459 304.46L604.55 302.11L603.963 303.838L610.871 306.188L611.459 304.46Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M624.976 311.515L618.137 309.189L617.555 310.901L624.394 313.227L624.976 311.515Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M636.689 321.585L630.029 319.32L629.463 320.985L636.122 323.25L636.689 321.585Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M647.964 330.89L641.463 328.678L640.91 330.305L647.411 332.516L647.964 330.89Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M662.734 333.639L656.166 331.404L655.607 333.046L662.176 335.281L662.734 333.639Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M681.333 331.716L674.525 329.4L673.946 331.105L680.753 333.42L681.333 331.716Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M697.332 334.39L690.444 332.048L689.858 333.77L696.746 336.113L697.332 334.39Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M710.875 340.117L704.021 337.785L703.438 339.5L710.292 341.831L710.875 340.117Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M726.923 343.3L720.004 340.947L719.416 342.677L726.335 345.03L726.923 343.3Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M749.222 341.455L742.031 339.009L741.419 340.807L748.611 343.253L749.222 341.455Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M773.878 339.052L766.372 336.499L765.735 338.374L773.24 340.927L773.878 339.052Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M795.671 340.019L787.982 337.403L787.328 339.326L795.017 341.941L795.671 340.019Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M817.291 341.861L809.444 339.192L808.776 341.156L816.623 343.825L817.291 341.861Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M839.705 343.853L831.694 341.128L831.013 343.131L839.024 345.855L839.705 343.853Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M859.557 347.823L851.466 345.072L850.779 347.092L858.87 349.844L859.557 347.823Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M873.511 354.997L865.487 352.268L864.805 354.274L872.829 357.003L873.511 354.997Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M888.168 361.615L880.194 358.903L879.515 360.898L887.49 363.61L888.168 361.615Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M903.63 367.748L895.682 365.045L895.006 367.032L902.955 369.735L903.63 367.748Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M916.331 374.872L908.463 372.196L907.794 374.162L915.662 376.838L916.331 374.872Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M925.464 383.026L917.741 380.399L917.083 382.332L924.806 384.958L925.464 383.026Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M934.147 390.928L926.566 388.35L925.921 390.246L933.502 392.824L934.147 390.928Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M947.986 396.888L940.442 394.322L939.801 396.208L947.345 398.774L947.986 396.888Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M966.422 401.474L958.829 398.892L958.183 400.79L965.777 403.373L966.422 401.474Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M989.519 404.991L981.801 402.366L981.144 404.296L988.862 406.921L989.519 404.991Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M1016.16 407.972L1008.27 405.288L1007.6 407.263L1015.49 409.947L1016.16 407.972Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M1039.38 412.098L1031.38 409.376L1030.7 411.376L1038.7 414.098L1039.38 412.098Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M1050.15 418.936L1042.24 416.245L1041.56 418.224L1049.48 420.916L1050.15 418.936Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M263.387 203.909L256.535 201.579L255.952 203.293L262.804 205.624L263.387 203.909Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M270.93 200.802L263.902 198.412L263.304 200.171L270.332 202.561L270.93 200.802Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M278.965 197.645L271.753 195.193L271.14 196.995L278.352 199.448L278.965 197.645Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M292.74 201.152L285.494 198.688L284.877 200.501L292.123 202.966L292.74 201.152Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M309.662 208.751L302.473 206.306L301.862 208.104L309.05 210.549L309.662 208.751Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M326.814 216.918L319.695 214.497L319.09 216.276L326.208 218.697L326.814 216.918Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M343.178 224.26L336.116 221.859L335.514 223.628L342.576 226.03L343.178 224.26Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M357.807 229.135L350.74 226.731L350.139 228.498L357.206 230.901L357.807 229.135Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M370.504 230.704L363.354 228.272L362.746 230.059L369.896 232.491L370.504 230.704Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M383.421 232.139L376.177 229.676L375.561 231.489L382.804 233.952L383.421 232.139Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M396.487 233.261L389.143 230.763L388.518 232.599L395.863 235.097L396.487 233.261Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M408.239 230.711L400.69 228.144L400.047 230.032L407.597 232.6L408.239 230.711Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M422.336 232.105L414.683 229.502L414.033 231.414L421.685 234.017L422.336 232.105Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M439.046 239.638L431.45 237.055L430.804 238.953L438.4 241.537L439.046 239.638Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M455.558 247.219L448.021 244.656L447.381 246.539L454.917 249.102L455.558 247.219Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M469.976 247.651L462.305 245.042L461.652 246.962L469.323 249.571L469.976 247.651Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M483.562 241.384L475.551 238.66L474.87 240.662L482.881 243.387L483.562 241.384Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M499.398 241.356L491.224 238.575L490.528 240.622L498.702 243.402L499.398 241.356Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M517.003 253.49L509.015 250.774L508.336 252.771L516.323 255.488L517.003 253.49Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M533.895 268.297L526.188 265.676L525.532 267.603L533.239 270.225L533.895 268.297Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M549.921 274.338L542.234 271.724L541.579 273.649L549.266 276.263L549.921 274.338Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M566.224 277.088L558.449 274.443L557.787 276.389L565.562 279.033L566.224 277.088Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M582.125 284.311L574.405 281.685L573.748 283.617L581.468 286.243L582.125 284.311Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M596.437 296.862L588.956 294.317L588.32 296.188L595.801 298.732L596.437 296.862Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M609.815 308.911L602.564 306.445L601.947 308.258L609.198 310.724L609.815 308.911Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M623.827 316.721L616.669 314.287L616.061 316.077L623.218 318.511L623.827 316.721Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M636.908 325.483L629.885 323.094L629.287 324.853L636.31 327.241L636.908 325.483Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M649.395 334.117L642.508 331.775L641.922 333.497L648.81 335.84L649.395 334.117Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M662.961 340.143L656.12 337.817L655.538 339.529L662.379 341.856L662.961 340.143Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M678.049 343.932L671.163 341.59L670.578 343.313L677.463 345.655L678.049 343.932Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M692.72 348.436L685.819 346.089L685.232 347.814L692.133 350.161L692.72 348.436Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M705.545 354.876L698.71 352.551L698.128 354.26L704.964 356.585L705.545 354.876Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M719.802 359.705L712.963 357.379L712.381 359.091L719.22 361.417L719.802 359.705Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M738.579 360.899L731.582 358.519L730.987 360.267L737.984 362.647L738.579 360.899Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M758.723 361.823L751.542 359.381L750.932 361.173L758.113 363.615L758.723 361.823Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M778.064 364.028L770.751 361.541L770.129 363.37L777.442 365.857L778.064 364.028Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M797.7 366.591L790.257 364.06L789.625 365.92L797.068 368.451L797.7 366.591Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M818.954 368.738L811.355 366.153L810.709 368.052L818.308 370.637L818.954 368.738Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M841.154 370.966L833.39 368.325L832.729 370.268L840.493 372.909L841.154 370.966Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M860.603 374.982L852.761 372.315L852.094 374.276L859.936 376.943L860.603 374.982Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M877.757 380.206L869.892 377.531L869.223 379.497L877.088 382.172L877.757 380.206Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M894.308 385.714L886.44 383.037L885.772 385.004L893.64 387.68L894.308 385.714Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M909.663 391.645L901.818 388.977L901.151 390.938L908.996 393.606L909.663 391.645Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M923.249 398.086L915.461 395.437L914.8 397.383L922.587 400.032L923.249 398.086Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M942.719 402.653L934.869 399.983L934.202 401.944L942.052 404.614L942.719 402.653Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M963.038 407.162L955.111 404.466L954.436 406.448L962.364 409.144L963.038 407.162Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M981.418 412.322L973.459 409.615L972.781 411.607L980.74 414.314L981.418 412.322Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M1003.44 416.749L995.389 414.009L994.703 416.025L1002.76 418.764L1003.44 416.749Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M1025.99 421.288L1017.84 418.516L1017.15 420.555L1025.3 423.327L1025.99 421.288Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M1035.88 428.374L1027.84 425.64L1027.16 427.648L1035.2 430.382L1035.88 428.374Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M1036.94 436.693L1029.15 434.043L1028.49 435.991L1036.28 438.641L1036.94 436.693Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M244.373 203.063L237.177 200.615L236.565 202.413L243.762 204.86L244.373 203.063Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M255.668 204.059L248.379 201.58L247.757 203.406L255.047 205.886L255.668 204.059Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M268.711 206.759L261.361 204.259L260.736 206.096L268.086 208.595L268.711 206.759Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M285.778 214.066L278.478 211.583L277.857 213.409L285.157 215.892L285.778 214.066Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M303.597 222.517L296.377 220.061L295.764 221.864L302.984 224.32L303.597 222.517Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M320.597 230.212L313.439 227.777L312.83 229.567L319.988 232.002L320.597 230.212Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M336.871 237.173L329.762 234.756L329.157 236.535L336.265 238.953L336.871 237.173Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M350.268 240.138L343.105 237.702L342.496 239.495L349.658 241.931L350.268 240.138Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M360.674 238.15L353.328 235.651L352.703 237.488L360.05 239.987L360.674 238.15Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M372.294 237.173L364.786 234.62L364.147 236.498L371.655 239.051L372.294 237.173Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M385.178 237.486L377.53 234.885L376.881 236.794L384.529 239.395L385.178 237.486Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M395.832 232.439L387.897 229.74L387.222 231.724L395.157 234.423L395.832 232.439Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M409.454 231.689L401.342 228.93L400.653 230.958L408.764 233.717L409.454 231.689Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M427.353 239.898L419.311 237.163L418.627 239.173L426.669 241.908L427.353 239.898Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M445.397 249.25L437.461 246.551L436.786 248.536L444.722 251.235L445.397 249.25Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M460.746 250.9L452.692 248.16L452.007 250.173L460.062 252.913L460.746 250.9Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M475.475 248.037L467.158 245.208L466.45 247.289L474.767 250.117L475.475 248.037Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M492.527 252.413L484.164 249.568L483.452 251.662L491.815 254.506L492.527 252.413Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M511.302 269.825L503.307 267.106L502.627 269.106L510.622 271.825L511.302 269.825Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M528.655 288.673L521.09 286.1L520.446 287.993L528.011 290.566L528.655 288.673Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M544.415 294.007L536.85 291.434L536.207 293.325L543.771 295.898L544.415 294.007Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M560.961 290.547L553.09 287.87L552.421 289.836L560.292 292.513L560.961 290.547Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M578.058 291.803L570.037 289.075L569.355 291.081L577.376 293.809L578.058 291.803Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M593.829 301.358L585.948 298.678L585.278 300.647L593.159 303.327L593.829 301.358Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M608.447 312.474L600.771 309.863L600.117 311.786L607.793 314.396L608.447 312.474Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M623.238 320.81L615.671 318.236L615.026 320.13L622.594 322.704L623.238 320.81Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M637.144 329.843L629.719 327.318L629.087 329.175L636.512 331.7L637.144 329.843Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M650.258 338.983L642.989 336.511L642.37 338.329L649.639 340.802L650.258 338.983Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M663.482 346.838L656.324 344.404L655.716 346.194L662.873 348.628L663.482 346.838Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M677.403 353.113L670.297 350.696L669.693 352.473L676.799 354.89L677.403 353.113Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M691.768 358.609L684.683 356.199L684.08 357.971L691.165 360.381L691.768 358.609Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M703.732 366.264L696.767 363.895L696.174 365.636L703.14 368.005L703.732 366.264Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M715.652 373.36L708.79 371.026L708.206 372.743L715.068 375.077L715.652 373.36Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M730.7 377.665L723.81 375.321L723.223 377.047L730.114 379.39L730.7 377.665Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M746.977 381.259L740.021 378.893L739.43 380.631L746.386 382.997L746.977 381.259Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M764.33 384.452L757.286 382.056L756.686 383.82L763.73 386.216L764.33 384.452Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M783.764 386.842L776.578 384.398L775.968 386.193L783.154 388.637L783.764 386.842Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M806.422 388.118L799.021 385.6L798.392 387.45L805.793 389.967L806.422 388.118Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M831.832 388.865L824.169 386.258L823.517 388.173L831.181 390.779L831.832 388.865Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M855.315 391.22L847.465 388.55L846.798 390.511L854.648 393.181L855.315 391.22Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M874.239 395.824L866.327 393.133L865.653 395.112L873.566 397.803L874.239 395.824Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M892.137 400.954L884.194 398.252L883.518 400.239L891.461 402.941L892.137 400.954Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M910.667 405.971L902.679 403.254L902 405.251L909.987 407.968L910.667 405.971Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M928.833 411.206L920.814 408.479L920.132 410.484L928.151 413.211L928.833 411.206Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M954.502 414.6L946.307 411.812L945.61 413.862L953.805 416.649L954.502 414.6Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M977.79 418.975L969.475 416.147L968.768 418.227L977.082 421.055L977.79 418.975Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M994.733 424.946L986.427 422.121L985.721 424.196L994.027 427.021L994.733 424.946Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M1013.29 430.597L1004.96 427.763L1004.25 429.849L1012.58 432.682L1013.29 430.597Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M1030.6 436.507L1022.28 433.675L1021.57 435.758L1029.9 438.59L1030.6 436.507Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.03 444.682L1024.95 441.933L1024.26 443.954L1032.34 446.703L1033.03 444.682Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M1029.66 453.168L1021.9 450.528L1021.24 452.471L1029 455.111L1029.66 453.168Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M226.449 205.223L218.947 202.672L218.309 204.547L225.811 207.099L226.449 205.223Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M241.623 210.06L234.108 207.504L233.468 209.385L240.983 211.941L241.623 210.06Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M258.726 216.948L251.252 214.406L250.616 216.276L258.09 218.818L258.726 216.948Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M274.875 222.883L267.416 220.347L266.782 222.212L274.24 224.749L274.875 222.883Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M290.869 228.694L283.421 226.16L282.788 228.02L290.236 230.554L290.869 228.694Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M307.117 234.871L299.693 232.346L299.062 234.201L306.487 236.726L307.117 234.871Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M322.003 239.381L314.56 236.85L313.928 238.71L321.371 241.241L322.003 239.381Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M334.651 240.789L327.105 238.222L326.462 240.111L334.009 242.677L334.651 240.789Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M347.752 242.365L340.101 239.763L339.45 241.677L347.1 244.279L347.752 242.365Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M362.01 245.206L354.287 242.579L353.63 244.512L361.353 247.138L362.01 245.206Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M374.47 244.665L366.573 241.98L365.902 243.954L373.799 246.64L374.47 244.665Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M383.244 236.444L374.943 233.62L374.237 235.695L382.538 238.519L383.244 236.444Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M396.044 233.431L387.476 230.517L386.747 232.66L395.316 235.574L396.044 233.431Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M412.858 237.214L404.22 234.276L403.485 236.437L412.123 239.375L412.858 237.214Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M430.577 242.659L421.921 239.714L421.185 241.878L429.841 244.822L430.577 242.659Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M448.228 247.638L439.533 244.68L438.794 246.854L447.489 249.811L448.228 247.638Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M467.135 256.641L458.536 253.716L457.803 255.869L466.403 258.794L467.135 256.641Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M486.343 268.664L477.938 265.805L477.223 267.907L485.628 270.765L486.343 268.664Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M505.529 285.779L497.508 283.051L496.826 285.056L504.847 287.784L505.529 285.779Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M523.09 301.937L515.437 299.334L514.787 301.246L522.44 303.848L523.09 301.937Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M539.036 307.149L531.373 304.542L530.722 306.457L538.385 309.063L539.036 307.149Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M555.548 304.514L547.589 301.807L546.911 303.799L554.87 306.506L555.548 304.514Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M572.979 304.474L564.805 301.694L564.109 303.738L572.284 306.518L572.979 304.474Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M590.003 310.293L581.829 307.513L581.134 309.557L589.308 312.337L590.003 310.293Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M606.291 318.363L598.21 315.614L597.523 317.635L605.603 320.383L606.291 318.363Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M621.913 326.984L613.949 324.275L613.272 326.265L621.237 328.974L621.913 326.984Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M635.883 337.642L628.134 335.007L627.475 336.944L635.224 339.58L635.883 337.642Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M648.846 348.187L641.32 345.627L640.68 347.511L648.205 350.07L648.846 348.187Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M662.114 356.772L654.734 354.261L654.106 356.106L661.487 358.616L662.114 356.772Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M676.208 363.481L668.898 360.995L668.276 362.824L675.586 365.31L676.208 363.481Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M690.88 369.224L683.596 366.746L682.976 368.567L690.261 371.045L690.88 369.224Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M704.033 376.166L696.839 373.719L696.228 375.517L703.422 377.964L704.033 376.166Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M716.04 383.584L708.966 381.178L708.364 382.947L715.439 385.353L716.04 383.584Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M727.859 390.614L720.893 388.244L720.301 389.985L727.267 392.354L727.859 390.614Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M739.803 397.136L732.928 394.798L732.343 396.518L739.218 398.856L739.803 397.136Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M755.201 401.415L748.29 399.065L747.702 400.792L754.614 403.143L755.201 401.415Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M778.68 401.809L771.493 399.365L770.883 401.16L778.069 403.604L778.68 401.809Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M807.885 400.542L800.294 397.96L799.648 399.859L807.239 402.441L807.885 400.542Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M836.787 400.651L828.843 397.949L828.168 399.936L836.111 402.638L836.787 400.651Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M862.788 402.84L854.603 400.057L853.907 402.103L862.092 404.887L862.788 402.84Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M883.012 407.597L874.752 404.788L874.05 406.853L882.309 409.662L883.012 407.597Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M898.627 413.918L890.406 411.122L889.707 413.177L897.928 415.973L898.627 413.918Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M914.298 420.134L906.108 417.349L905.411 419.398L913.601 422.183L914.298 420.134Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M934.537 425.177L926.28 422.369L925.578 424.434L933.835 427.242L934.537 425.177Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M960.572 429.112L952.139 426.244L951.422 428.353L959.855 431.221L960.572 429.112Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M982.78 434.194L974.256 431.294L973.53 433.429L982.054 436.329L982.78 434.194Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M996.086 441.002L987.645 438.131L986.926 440.243L995.368 443.114L996.086 441.002Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M1007.96 447.862L999.627 445.026L998.918 447.112L1007.26 449.947L1007.96 447.862Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M1021.14 454.347L1012.88 451.535L1012.17 453.602L1020.44 456.414L1021.14 454.347Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M1032.68 460.88L1024.51 458.1L1023.82 460.144L1031.99 462.924L1032.68 460.88Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M1038.48 467.847L1030.49 465.129L1029.81 467.129L1037.8 469.847L1038.48 467.847Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M210.839 211.222L203.096 208.588L202.437 210.526L210.18 213.16L210.839 211.222Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M227.925 217.635L220.205 215.009L219.548 216.939L227.268 219.565L227.925 217.635Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M246.803 225.896L239.156 223.295L238.505 225.207L246.153 227.808L246.803 225.896Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M259.703 228.171L251.973 225.542L251.315 227.474L259.046 230.104L259.703 228.171Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M272.79 230.382L264.969 227.722L264.304 229.675L272.126 232.335L272.79 230.382Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M288.516 235.288L280.682 232.623L280.016 234.582L287.85 237.246L288.516 235.288Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M302.463 238.026L294.545 235.333L293.872 237.312L301.789 240.005L302.463 238.026Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M315.016 238.724L306.959 235.984L306.273 237.999L314.331 240.74L315.016 238.724Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M331.922 244.593L323.87 241.854L323.186 243.867L331.238 246.606L331.922 244.593Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M349.649 251.632L341.635 248.906L340.954 250.909L348.967 253.634L349.649 251.632Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M361.839 250.531L353.618 247.735L352.92 249.789L361.141 252.585L361.839 250.531Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M368.89 239.949L360.158 236.979L359.416 239.161L368.148 242.13L368.89 239.949Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M381.247 235.747L372.184 232.664L371.413 234.929L380.477 238.012L381.247 235.747Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M397.051 236.095L387.79 232.945L387.002 235.262L396.263 238.411L397.051 236.095Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M414.353 238.22L404.945 235.02L404.144 237.376L413.552 240.576L414.353 238.22Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M434.505 246.295L425.145 243.112L424.349 245.455L433.708 248.638L434.505 246.295Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M458.156 265.696L449.243 262.665L448.485 264.893L457.398 267.924L458.156 265.696Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M479.673 283.425L471.172 280.534L470.45 282.658L478.951 285.549L479.673 283.425Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M499.118 298.64L490.954 295.863L490.26 297.904L498.423 300.681L499.118 298.64Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M516.913 311.302L509.011 308.615L508.339 310.591L516.241 313.279L516.913 311.302Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M533.365 316.582L525.448 313.89L524.775 315.869L532.692 318.562L533.365 316.582Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M550.137 316.015L541.976 313.239L541.282 315.281L549.443 318.057L550.137 316.015Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M567.841 316.578L559.464 313.729L558.751 315.825L567.128 318.674L567.841 316.578Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M585.733 320.586L577.271 317.707L576.551 319.824L585.013 322.702L585.733 320.586Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M603.271 326.843L594.824 323.97L594.106 326.082L602.552 328.954L603.271 326.843Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M619.575 335.85L611.263 333.023L610.556 335.103L618.867 337.93L619.575 335.85Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M633.579 347.886L625.553 345.156L624.871 347.161L632.897 349.891L633.579 347.886Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M646.392 359.502L638.654 356.87L637.995 358.805L645.734 361.437L646.392 359.502Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M659.733 368.52L652.171 365.948L651.528 367.839L659.09 370.411L659.733 368.52Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M674.029 375.463L666.547 372.918L665.91 374.791L673.392 377.335L674.029 375.463Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M689.02 381.32L681.57 378.786L680.937 380.646L688.388 383.18L689.02 381.32Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M703.975 387.057L696.547 384.531L695.915 386.388L703.343 388.915L703.975 387.057Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M717.288 393.86L709.951 391.365L709.327 393.199L716.664 395.694L717.288 393.86Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M727.258 402.4L720.127 399.974L719.52 401.759L726.651 404.185L727.258 402.4Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M735.922 410.912L729.008 408.56L728.42 410.291L735.334 412.642L735.922 410.912Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M749.824 416.06L742.928 413.715L742.342 415.44L749.237 417.785L749.824 416.06Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M777.247 415.165L769.947 412.682L769.326 414.508L776.626 416.991L777.247 415.165Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M812.255 412.508L804.381 409.83L803.713 411.796L811.586 414.474L812.255 412.508Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M843.273 412.92L835 410.106L834.297 412.173L842.57 414.987L843.273 412.92Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M870.604 415.588L862.069 412.685L861.343 414.82L869.878 417.723L870.604 415.588Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M891.7 420.699L883.082 417.768L882.349 419.924L890.967 422.855L891.7 420.699Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M904.069 428.209L895.584 425.323L894.862 427.444L903.348 430.331L904.069 428.209Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M914.755 435.794L906.426 432.96L905.716 435.046L914.046 437.879L914.755 435.794Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M934.74 441.169L926.353 438.317L925.64 440.413L934.027 443.265L934.74 441.169Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M958.928 445.923L950.404 443.024L949.68 445.154L958.204 448.053L958.928 445.923Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M978.704 451.648L970.141 448.736L969.412 450.878L977.976 453.791L978.704 451.648Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M988.1 458.867L979.698 456.009L978.983 458.11L987.386 460.968L988.1 458.867Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M993.838 466.216L985.646 463.43L984.95 465.476L993.142 468.263L993.838 466.216Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M1004.25 472.698L996.173 469.95L995.486 471.969L1003.56 474.716L1004.25 472.698Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M1027.29 477.882L1019.11 475.101L1018.41 477.147L1026.59 479.928L1027.29 477.882Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M1043.73 483.722L1035.56 480.943L1034.87 482.987L1043.04 485.766L1043.73 483.722Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M192.347 216.023L184.303 213.287L183.619 215.297L191.663 218.033L192.347 216.023Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M211.84 224.18L203.863 221.467L203.184 223.462L211.161 226.175L211.84 224.18Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M231.375 232.544L223.47 229.856L222.798 231.832L230.703 234.521L231.375 232.544Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M244.264 234.705L236.267 231.985L235.586 233.985L243.584 236.705L244.264 234.705Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M257.101 236.539L248.989 233.78L248.299 235.808L256.411 238.567L257.101 236.539Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M272.763 241.003L264.614 238.232L263.921 240.271L272.069 243.042L272.763 241.003Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M286.902 243.693L278.663 240.891L277.962 242.951L286.201 245.753L286.902 243.693Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M299.318 244.108L290.913 241.249L290.197 243.353L298.602 246.211L299.318 244.108Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M314.869 247.707L306.392 244.823L305.671 246.943L314.148 249.826L314.869 247.707Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M331.913 252.916L323.407 250.023L322.684 252.147L331.19 255.04L331.913 252.916Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M345.42 253.201L336.73 250.245L335.991 252.416L344.682 255.372L345.42 253.201Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M354.498 246.086L345.366 242.98L344.589 245.266L353.72 248.371L354.498 246.086Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M368.075 243.842L358.643 240.634L357.84 242.995L367.272 246.203L368.075 243.842Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M384.849 245.463L375.241 242.195L374.423 244.6L384.031 247.868L384.849 245.463Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M403.058 248.71L393.322 245.399L392.494 247.835L402.229 251.146L403.058 248.71Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M423.867 256.789L414.173 253.492L413.349 255.915L423.043 259.212L423.867 256.789Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M448.144 274.478L438.86 271.321L438.07 273.642L447.354 276.8L448.144 274.478Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M470.481 290.81L461.575 287.781L460.818 290.007L469.724 293.036L470.481 290.81Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M490.756 304.571L482.148 301.643L481.416 303.796L490.023 306.724L490.756 304.571Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M509.495 315.945L501.108 313.093L500.395 315.191L508.781 318.044L509.495 315.945Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M526.962 321.704L518.565 318.848L517.851 320.946L526.249 323.802L526.962 321.704Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M544.541 323.263L535.952 320.342L535.221 322.493L543.81 325.414L544.541 323.263Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M562.854 325.677L554.101 322.7L553.357 324.89L562.109 327.867L562.854 325.677Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M581.41 330.385L572.588 327.385L571.837 329.592L580.659 332.593L581.41 330.385Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M599.702 336.936L590.892 333.94L590.143 336.142L598.953 339.139L599.702 336.936Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M616.598 346.518L607.954 343.578L607.219 345.739L615.863 348.678L616.598 346.518Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M630.86 359.316L622.562 356.493L621.856 358.569L630.155 361.391L630.86 359.316Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M643.845 371.399L635.878 368.689L635.2 370.681L643.167 373.391L643.845 371.399Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M657.676 380.337L649.896 377.691L649.234 379.636L657.014 382.283L657.676 380.337Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M672.719 387.028L665.007 384.405L664.35 386.335L672.063 388.958L672.719 387.028Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M688.152 393.044L680.47 390.431L679.817 392.353L687.498 394.966L688.152 393.044Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M702.613 399.635L695.004 397.047L694.357 398.949L701.966 401.537L702.613 399.635Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M715.305 407.063L707.834 404.522L707.198 406.392L714.669 408.934L715.305 407.063Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M725.929 415.157L718.649 412.681L718.03 414.502L725.309 416.978L725.929 415.157Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M736.466 422.616L729.356 420.197L728.75 421.977L735.861 424.395L736.466 422.616Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M751.012 427.769L743.909 425.353L743.305 427.127L750.409 429.543L751.012 427.769Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M777.128 428.42L769.67 425.883L769.036 427.748L776.494 430.285L777.128 428.42Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M810.345 427.658L802.363 424.943L801.685 426.938L809.667 429.653L810.345 427.658Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M840.57 429.203L832.207 426.359L831.495 428.449L839.859 431.294L840.57 429.203Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M867.745 432.519L859.125 429.587L858.391 431.742L867.012 434.674L867.745 432.519Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M888.969 437.856L880.271 434.898L879.531 437.074L888.229 440.032L888.969 437.856Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M901.21 445.241L892.65 442.329L891.922 444.469L900.482 447.381L901.21 445.241Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M911.235 452.719L902.854 449.869L902.14 451.967L910.521 454.818L911.235 452.719Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M930.147 458.434L921.731 455.572L921.016 457.675L929.431 460.538L930.147 458.434Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M953.254 463.636L944.722 460.734L943.996 462.869L952.528 465.771L953.254 463.636Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M971.48 469.63L962.941 466.725L962.215 468.86L970.754 471.765L971.48 469.63Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M978.605 476.73L970.27 473.895L969.561 475.981L977.896 478.816L978.605 476.73Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M981.726 483.802L973.65 481.056L972.964 483.074L981.039 485.821L981.726 483.802Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M989.571 490.118L981.654 487.425L980.98 489.407L988.897 492.099L989.571 490.118Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M1008.96 495.579L1000.99 492.869L1000.31 494.862L1008.28 497.571L1008.96 495.579Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M1023 501.318L1015.07 498.623L1014.4 500.605L1022.32 503.3L1023 501.318Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M168.647 218.196L160.193 215.32L159.474 217.434L167.928 220.31L168.647 218.196Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M196.586 232.806L188.381 230.015L187.683 232.067L195.888 234.858L196.586 232.806Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M218.558 242.809L210.472 240.059L209.785 242.08L217.871 244.83L218.558 242.809Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M233.485 246.832L225.35 244.065L224.657 246.102L232.793 248.869L233.485 246.832Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M247.237 249.657L239.011 246.859L238.311 248.916L246.537 251.714L247.237 249.657Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M263.143 254.306L254.881 251.496L254.178 253.561L262.441 256.371L263.143 254.306Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M278.328 258.139L270.004 255.308L269.295 257.391L277.62 260.222L278.328 258.139Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M289.833 257.94L281.309 255.041L280.583 257.176L289.107 260.075L289.833 257.94Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M297.724 253.148L288.837 250.125L288.082 252.346L296.969 255.369L297.724 253.148Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M309.135 251.212L299.967 248.094L299.188 250.384L308.355 253.502L309.135 251.212Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M326.031 254.99L316.77 251.841L315.982 254.157L325.243 257.307L326.031 254.99Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M342.258 257.497L332.852 254.297L332.052 256.65L341.458 259.849L342.258 257.497Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M359.104 260.225L349.552 256.976L348.74 259.365L358.291 262.614L359.104 260.225Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M378.079 265.556L368.473 262.289L367.657 264.688L377.263 267.955L378.079 265.556Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M397.87 271.977L388.248 268.705L387.431 271.11L397.052 274.382L397.87 271.977Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M417.718 278.398L408.079 275.12L407.259 277.53L416.899 280.808L417.718 278.398Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M439.131 288.286L429.621 285.051L428.813 287.427L438.323 290.662L439.131 288.286Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M460.308 298.764L450.954 295.583L450.158 297.923L459.512 301.104L460.308 298.764Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M480.603 308.237L471.373 305.098L470.589 307.404L479.819 310.543L480.603 308.237Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M500.147 316.361L490.988 313.245L490.21 315.533L499.369 318.649L500.147 316.361Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M519.236 322.942L510.081 319.829L509.303 322.117L518.457 325.23L519.236 322.942Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M538.297 328.989L529.122 325.868L528.343 328.159L537.518 331.279L538.297 328.989Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M557.443 335.138L548.252 332.013L547.47 334.311L556.661 337.437L557.443 335.138Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M576.773 340.738L567.532 337.595L566.746 339.906L575.986 343.049L576.773 340.738Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M596.126 346.955L586.871 343.807L586.084 346.121L595.339 349.269L596.126 346.955Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M613.856 356.985L604.793 353.903L604.022 356.17L613.085 359.253L613.856 356.985Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M628.135 371.233L619.528 368.306L618.795 370.461L627.402 373.389L628.135 371.233Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M641.123 384.038L632.917 381.247L632.219 383.299L640.425 386.09L641.123 384.038Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M656.29 391.981L648.223 389.237L647.536 391.255L655.604 393.999L656.29 391.981Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M673.644 397.206L665.542 394.45L664.852 396.479L672.954 399.234L673.644 397.206Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M690.129 403.258L682.048 400.51L681.36 402.531L689.441 405.279L690.129 403.258Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M702.133 412.206L694.289 409.538L693.622 411.499L701.466 414.167L702.133 412.206Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M712.263 421.342L704.691 418.766L704.047 420.66L711.619 423.235L712.263 421.342Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M725.85 427.8L718.365 425.255L717.728 427.128L725.213 429.673L725.85 427.8Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M744.324 431.855L736.731 429.273L736.085 431.172L743.679 433.754L744.324 431.855Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M762.355 436.399L754.687 433.791L754.036 435.705L761.704 438.313L762.355 436.399Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M783.952 439.985L776.102 437.315L775.434 439.279L783.284 441.949L783.952 439.985Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M810.329 442.679L802.175 439.905L801.482 441.944L809.635 444.717L810.329 442.679Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M837.843 445.829L829.389 442.953L828.67 445.068L837.124 447.943L837.843 445.829Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M864.393 449.884L855.703 446.928L854.965 449.099L863.655 452.055L864.393 449.884Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M885.746 455.439L876.97 452.454L876.224 454.649L885 457.633L885.746 455.439Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M898.754 462.5L890.108 459.559L889.372 461.722L898.019 464.663L898.754 462.5Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M909.41 469.629L900.933 466.745L900.212 468.865L908.69 471.748L909.41 469.629Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M927.682 475.565L919.192 472.678L918.469 474.802L926.96 477.69L927.682 475.565Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M951.714 480.984L943.089 478.05L942.356 480.206L950.981 483.139L951.714 480.984Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M969.949 487.073L961.318 484.137L960.584 486.296L969.214 489.231L969.949 487.073Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M974.767 493.976L966.393 491.128L965.681 493.221L974.055 496.069L974.767 493.976Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M974.472 500.697L966.425 497.96L965.74 499.973L973.787 502.71L974.472 500.697Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M977.476 506.813L969.678 504.16L969.014 506.111L976.812 508.763L977.476 506.813Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M982.881 512.518L975.267 509.928L974.62 511.832L982.234 514.422L982.881 512.518Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M986.291 517.966L978.885 515.447L978.255 517.3L985.661 519.819L986.291 517.966Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M151.724 227.602L143.029 224.645L142.289 226.821L150.984 229.779L151.724 227.602Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M184.582 245.133L176.228 242.292L175.517 244.383L183.87 247.224L184.582 245.133Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M208.507 256.232L200.315 253.445L199.618 255.495L207.81 258.281L208.507 256.232Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M224.85 261.443L216.642 258.651L215.944 260.703L224.152 263.494L224.85 261.443Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M239.022 264.775L230.731 261.955L230.027 264.028L238.317 266.848L239.022 264.775Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M254.685 269.246L246.35 266.411L245.641 268.497L253.976 271.331L254.685 269.246Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M269.958 273.239L261.553 270.38L260.838 272.482L269.243 275.34L269.958 273.239Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M280.546 272.623L271.912 269.687L271.178 271.845L279.812 274.782L280.546 272.623Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M284.232 264.506L275.091 261.397L274.314 263.682L283.455 266.791L284.232 264.506Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M292.67 259.868L283.119 256.62L282.307 259.006L291.858 262.255L292.67 259.868Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M311.549 265.499L301.956 262.237L301.141 264.634L310.734 267.896L311.549 265.499Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M332.198 273.09L322.636 269.838L321.823 272.229L331.384 275.481L332.198 273.09Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M351.687 279.31L342.099 276.049L341.285 278.443L350.872 281.704L351.687 279.31Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M372.527 287.307L362.991 284.064L362.18 286.448L371.716 289.691L372.527 287.307Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M393.394 295.591L383.926 292.37L383.12 294.739L392.589 297.959L393.394 295.591Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M412.348 300.978L402.817 297.736L402.007 300.118L411.538 303.359L412.348 300.978Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M431.129 305.646L421.507 302.374L420.689 304.781L430.31 308.054L431.129 305.646Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M450.508 310.912L440.814 307.615L439.99 310.038L449.684 313.335L450.508 310.912Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M470.124 316.105L460.349 312.78L459.518 315.224L469.293 318.548L470.124 316.105Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M490.112 321.58L480.265 318.231L479.428 320.693L489.274 324.042L490.112 321.58Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M510.651 328.702L500.812 325.356L499.974 327.818L509.814 331.164L510.651 328.702Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M531.239 337.516L521.501 334.204L520.673 336.64L530.411 339.952L531.239 337.516Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M551.411 346.467L541.785 343.193L540.965 345.602L550.591 348.877L551.411 346.467Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M571.38 353.724L561.78 350.459L560.964 352.859L570.564 356.124L571.38 353.724Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M591.324 360.725L581.734 357.463L580.919 359.86L590.509 363.122L591.324 360.725Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M609.682 371.012L600.312 367.825L599.515 370.167L608.885 373.354L609.682 371.012Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M624.483 385.238L615.614 382.221L614.86 384.439L623.729 387.455L624.483 385.238Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M638.095 397.635L629.649 394.762L628.93 396.874L637.377 399.747L638.095 397.635Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M654.447 404.878L646.091 402.036L645.381 404.124L653.737 406.966L654.447 404.878Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M673.313 409.587L664.866 406.714L664.147 408.829L672.594 411.701L673.313 409.587Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M690.678 415.739L682.244 412.871L681.527 414.98L689.961 417.848L690.678 415.739Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M702.308 425.202L694.173 422.436L693.481 424.469L701.616 427.236L702.308 425.202Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M712.323 434.42L704.504 431.761L703.839 433.717L711.658 436.376L712.323 434.42Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M728.354 440.072L720.542 437.415L719.879 439.366L727.69 442.023L728.354 440.072Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M751.276 443.18L743.214 440.438L742.528 442.453L750.591 445.196L751.276 443.18Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M771.39 447.862L763.208 445.079L762.512 447.123L770.694 449.906L771.39 447.862Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M790.414 453.125L782.167 450.321L781.466 452.383L789.713 455.188L790.414 453.125Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M812.068 457.949L803.683 455.097L802.97 457.193L811.355 460.045L812.068 457.949Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M836.154 462.611L827.576 459.693L826.846 461.838L835.425 464.756L836.154 462.611Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M860.57 467.615L851.815 464.638L851.07 466.83L859.825 469.807L860.57 467.615Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M881.33 473.475L872.508 470.474L871.757 472.682L880.579 475.683L881.33 473.475Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M894.641 480.294L885.943 477.336L885.202 479.512L893.9 482.471L894.641 480.294Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M905.272 487.131L896.747 484.232L896.023 486.362L904.547 489.261L905.272 487.131Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M922.543 493.202L914.031 490.308L913.308 492.435L921.819 495.33L922.543 493.202Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M946.072 498.933L937.439 495.997L936.705 498.155L945.338 501.091L946.072 498.933Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M963.453 505.073L954.83 502.141L954.096 504.299L962.719 507.232L963.453 505.073Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M966.057 511.487L957.735 508.656L957.028 510.737L965.35 513.567L966.057 511.487Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M962.169 517.501L954.246 514.806L953.572 516.788L961.495 519.483L962.169 517.501Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M960.348 522.983L952.757 520.401L952.112 522.297L959.703 524.879L960.348 522.983Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M956.896 527.985L949.642 525.518L949.026 527.331L956.279 529.798L956.896 527.985Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M954.053 532.575L947.1 530.21L946.509 531.948L953.462 534.313L954.053 532.575Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M139.828 241.755L131 238.752L130.25 240.96L139.077 243.962L139.828 241.755Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M173.08 258.569L164.597 255.684L163.876 257.803L172.359 260.688L173.08 258.569Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M197.887 269.79L189.578 266.964L188.872 269.039L197.181 271.865L197.887 269.79Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M213.575 274.458L205.225 271.617L204.514 273.706L212.865 276.546L213.575 274.458Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M226.872 277.209L218.412 274.331L217.693 276.446L226.153 279.323L226.872 277.209Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M242.347 281.482L233.825 278.584L233.101 280.714L241.623 283.612L242.347 281.482Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M257.407 285.293L248.805 282.368L248.072 284.521L256.674 287.446L257.407 285.293Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M267.883 284.978L259.038 281.97L258.285 284.182L267.131 287.191L267.883 284.978Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M274.604 280.726L265.354 277.58L264.567 279.894L273.817 283.04L274.604 280.726Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M285.692 279.569L276.135 276.318L275.323 278.708L284.879 281.958L285.692 279.569Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M304.492 285.236L294.889 281.97L294.071 284.375L303.674 287.641L304.492 285.236Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M325.148 292.728L315.574 289.472L314.759 291.866L324.334 295.122L325.148 292.728Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M345.642 300.127L336.094 296.879L335.281 299.268L344.83 302.516L345.642 300.127Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M366.295 307.817L356.788 304.583L355.98 306.959L365.487 310.193L366.295 307.817Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M386.427 314.988L376.94 311.761L376.133 314.135L385.619 317.361L386.427 314.988Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M405.462 320.643L395.924 317.399L395.113 319.783L404.652 323.027L405.462 320.643Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M424.203 325.515L414.574 322.24L413.755 324.65L423.384 327.925L424.203 325.515Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M442.337 328.583L432.513 325.242L431.678 327.696L441.502 331.037L442.337 328.583Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M460.221 329.439L450.071 325.987L449.207 328.526L459.358 331.979L460.221 329.439Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M479.747 331.646L469.322 328.1L468.435 330.707L478.86 334.253L479.747 331.646Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M501.492 339.152L491.075 335.609L490.189 338.213L500.606 341.757L501.492 339.152Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M523.604 350.539L513.425 347.077L512.56 349.622L522.739 353.084L523.604 350.539Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M544.704 361.788L534.78 358.412L533.935 360.895L543.86 364.27L544.704 361.788Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M565.187 369.987L555.342 366.639L554.504 369.103L564.348 372.451L565.187 369.987Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M585.651 377.133L575.815 373.787L574.978 376.246L584.815 379.592L585.651 377.133Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M604.701 387.093L595.082 383.822L594.264 386.229L603.882 389.501L604.701 387.093Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M621.254 399.14L612.032 396.003L611.247 398.309L620.469 401.446L621.254 399.14Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M636.905 409.745L628.012 406.72L627.256 408.943L636.148 411.968L636.905 409.745Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M653.753 417.559L644.993 414.58L644.248 416.771L653.008 419.751L653.753 417.559Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M671.573 424.086L662.841 421.116L662.099 423.297L670.831 426.267L671.573 424.086Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M688.953 430.764L680.268 427.81L679.529 429.981L688.214 432.935L688.953 430.764Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M702.584 439.142L694.132 436.267L693.414 438.379L701.866 441.254L702.584 439.142Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M715.181 447.215L706.966 444.421L706.267 446.475L714.482 449.269L715.181 447.215Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M731.401 453.348L723.225 450.567L722.528 452.614L730.705 455.395L731.401 453.348Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M750.756 458.466L742.488 455.655L741.785 457.722L750.052 460.534L750.756 458.466Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M769.318 463.998L761.002 461.17L760.294 463.25L768.611 466.079L769.318 463.998Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M789.617 469.284L781.199 466.421L780.482 468.528L788.9 471.391L789.617 469.284Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M811.721 474.484L803.158 471.572L802.429 473.714L810.992 476.627L811.721 474.484Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M831.757 480.254L823.131 477.32L822.398 479.476L831.023 482.41L831.757 480.254Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M848.717 486.474L840.117 483.549L839.386 485.699L847.985 488.624L848.717 486.474Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M865.757 492.646L857.181 489.729L856.451 491.874L865.027 494.791L865.757 492.646Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M883.523 498.726L874.949 495.81L874.219 497.955L882.793 500.871L883.523 498.726Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M900.852 504.822L892.289 501.91L891.56 504.052L900.123 506.965L900.852 504.822Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M916.959 510.929L908.438 508.03L907.713 510.16L916.235 513.058L916.959 510.929Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M931.977 516.989L923.515 514.111L922.796 516.225L931.258 519.103L931.977 516.989Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M943.148 522.936L934.821 520.103L934.113 522.186L942.44 525.019L943.148 522.936Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M949.042 528.593L940.941 525.837L940.252 527.86L948.354 530.616L949.042 528.593Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M951.73 533.851L943.901 531.188L943.235 533.144L951.064 535.807L951.73 533.851Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M947.623 538.465L940.167 535.929L939.533 537.794L946.989 540.33L947.623 538.465Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M933.438 542.068L926.506 539.711L925.916 541.446L932.848 543.804L933.438 542.068Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M922.626 545.3L916.127 543.089L915.574 544.716L922.073 546.926L922.626 545.3Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M129.316 257.426L120.4 254.393L119.643 256.621L128.558 259.654L129.316 257.426Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M162.253 273.105L153.662 270.183L152.931 272.331L161.523 275.253L162.253 273.105Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M187.459 284.074L179.041 281.211L178.325 283.315L186.743 286.178L187.459 284.074Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M201.743 287.81L193.247 284.92L192.524 287.045L201.02 289.934L201.743 287.81Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M213.863 289.903L205.216 286.962L204.481 289.123L213.128 292.064L213.863 289.903Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M229.473 294.289L220.762 291.326L220.022 293.503L228.733 296.466L229.473 294.289Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M244.745 298.303L235.946 295.31L235.197 297.512L243.996 300.505L244.745 298.303Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M255.529 298.691L246.494 295.618L245.725 297.878L254.761 300.951L255.529 298.691Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M266.968 299.138L257.681 295.979L256.891 298.301L266.178 301.459L266.968 299.138Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M281.954 302.041L272.507 298.828L271.703 301.191L281.151 304.404L281.954 302.041Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M300.186 307.458L290.684 304.226L289.875 306.605L299.377 309.836L300.186 307.458Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M319.726 313.953L310.211 310.717L309.402 313.096L318.917 316.332L319.726 313.953Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M340.386 321.518L330.908 318.294L330.101 320.665L339.58 323.889L340.386 321.518Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M359.747 327.834L350.25 324.604L349.443 326.978L358.94 330.208L359.747 327.834Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M378.348 333.202L368.784 329.95L367.97 332.341L377.534 335.594L378.348 333.202Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M397.87 339.46L388.278 336.198L387.461 338.597L397.054 341.86L397.87 339.46Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M417.854 346.257L408.259 342.994L407.444 345.391L417.039 348.654L417.854 346.257Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M435.455 349.19L425.639 345.852L424.805 348.306L434.621 351.644L435.455 349.19Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M451.331 347.317L440.984 343.798L440.104 346.384L450.452 349.903L451.331 347.317Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M469.762 347.045L458.94 343.364L458.02 346.069L468.842 349.75L469.762 347.045Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M492.337 354.841L481.525 351.164L480.606 353.867L491.418 357.544L492.337 354.841Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M515.808 368.222L505.39 364.679L504.505 367.283L514.922 370.826L515.808 368.222Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M537.631 380.848L527.59 377.433L526.737 379.941L536.778 383.357L537.631 380.848Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M558.421 388.97L548.455 385.58L547.607 388.073L557.573 391.462L558.421 388.97Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M579.336 395.504L569.331 392.101L568.481 394.602L578.486 398.005L579.336 395.504Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M599.039 404.854L589.226 401.516L588.393 403.968L598.206 407.305L599.039 404.854Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M617.374 414.707L607.825 411.46L607.013 413.846L616.562 417.094L617.374 414.707Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M635.104 423.681L625.768 420.506L624.974 422.84L634.31 426.016L635.104 423.681Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M652.107 432.225L642.973 429.119L642.197 431.401L651.331 434.508L652.107 432.225Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M668.157 440.552L659.233 437.517L658.474 439.748L667.398 442.783L668.157 440.552Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M685.19 447.662L676.36 444.659L675.609 446.866L684.44 449.87L685.19 447.662Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M700.744 455.074L692.067 452.122L691.328 454.294L700.006 457.245L700.744 455.074Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M715.702 462.248L707.177 459.348L706.453 461.478L714.977 464.377L715.702 462.248Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M731.109 468.917L722.688 466.053L721.972 468.16L730.392 471.024L731.109 468.917Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M744.941 475.689L736.671 472.876L735.968 474.943L744.238 477.756L744.941 475.689Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M760.998 481.749L752.772 478.951L752.073 481.008L760.299 483.806L760.998 481.749Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M783.511 486.845L775.098 483.983L774.383 486.087L782.796 488.948L783.511 486.845Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M807.874 492.098L799.241 489.162L798.507 491.32L807.14 494.256L807.874 492.098Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M824.811 498.292L816.209 495.367L815.478 497.517L824.08 500.443L824.811 498.292Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M833.745 504.853L825.397 502.014L824.687 504.102L833.035 506.942L833.745 504.853Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M846.485 510.9L838.264 508.104L837.565 510.158L845.786 512.954L846.485 510.9Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M870.304 516.656L861.914 513.803L861.201 515.902L869.59 518.755L870.304 516.656Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "M897.043 522.68L888.428 519.75L887.696 521.903L896.311 524.834L897.043 522.68Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "M912.49 528.724L903.932 525.813L903.203 527.956L911.761 530.867L912.49 528.724Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "M917.195 534.284L908.925 531.471L908.222 533.538L916.492 536.351L917.195 534.284Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "M921.126 539.461L913.136 536.743L912.456 538.741L920.446 541.458L921.126 539.461Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "M932.924 544.814L925.03 542.129L924.358 544.103L932.253 546.788L932.924 544.814Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "M946.888 550.22L939.046 547.553L938.379 549.514L946.221 552.181L946.888 550.22Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "M942.687 554.033L935.223 551.494L934.588 553.362L942.052 555.9L942.687 554.033Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "M916.634 555.391L909.917 553.106L909.345 554.787L916.062 557.072L916.634 555.391Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "M896.504 556.627L890.37 554.541L889.85 556.072L895.983 558.158L896.504 556.627Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "M125.481 277.454L116.618 274.439L115.863 276.657L124.727 279.672L125.481 277.454Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "M155.595 290.666L146.993 287.74L146.261 289.893L154.863 292.819L155.595 290.666Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "M180.144 300.792L171.697 297.919L170.979 300.031L179.426 302.903L180.144 300.792Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "M195.435 305.342L186.929 302.449L186.207 304.573L194.713 307.466L195.435 305.342Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "M208.239 308.241L199.608 305.305L198.874 307.464L207.505 310.399L208.239 308.241Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "M222.874 312.168L214.15 309.201L213.408 311.382L222.132 314.35L222.874 312.168Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "M236.36 315.197L227.498 312.183L226.744 314.401L235.606 317.415L236.36 315.197Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "M246.896 315.976L237.788 312.879L237.014 315.154L246.122 318.251L246.896 315.976Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "M260.208 318.365L250.914 315.204L250.123 317.529L259.418 320.69L260.208 318.365Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "M276.694 322.8L267.298 319.605L266.498 321.957L275.893 325.153L276.694 322.8Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "M294.378 327.987L284.91 324.767L284.104 327.135L293.573 330.356L294.378 327.987Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "M312.671 333.529L303.146 330.289L302.336 332.671L311.861 335.91L312.671 333.529Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "M333.099 340.775L323.597 337.543L322.789 339.919L332.291 343.151L333.099 340.775Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "M353.059 347.659L343.565 344.43L342.758 346.804L352.252 350.033L353.059 347.659Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "M372.113 353.671L362.577 350.427L361.766 352.811L371.302 356.055L372.113 353.671Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "M391.49 359.902L381.924 356.649L381.11 359.04L390.677 362.294L391.49 359.902Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M411.113 366.316L401.523 363.054L400.708 365.451L410.298 368.713L411.113 366.316Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M428.405 369.52L418.581 366.179L417.745 368.638L427.568 371.979L428.405 369.52Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M443.831 368.614L433.468 365.089L432.586 367.68L442.949 371.205L443.831 368.614Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M461.875 369.186L451.025 365.495L450.102 368.209L460.953 371.899L461.875 369.186Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "M484.517 376.959L473.671 373.27L472.749 375.981L483.595 379.669L484.517 376.959Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "M508.321 389.52L497.867 385.965L496.978 388.58L507.431 392.135L508.321 389.52Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "M530.477 401.339L520.397 397.911L519.539 400.432L529.619 403.861L530.477 401.339Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "M551.385 409.391L541.391 405.992L540.54 408.493L550.535 411.892L551.385 409.391Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "M572.293 416.196L562.27 412.786L561.417 415.292L571.441 418.701L572.293 416.196Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "M592.149 425.189L582.323 421.847L581.487 424.306L591.313 427.648L592.149 425.189Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "M610.742 434.436L601.172 431.181L600.359 433.573L609.928 436.827L610.742 434.436Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "M628.677 442.97L619.32 439.787L618.524 442.127L627.881 445.31L628.677 442.97Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "M645.73 451.195L636.589 448.086L635.812 450.371L644.953 453.481L645.73 451.195Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "M661.794 459.174L652.871 456.139L652.112 458.37L661.036 461.405L661.794 459.174Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "M678.869 466.087L670.044 463.085L669.293 465.293L678.118 468.294L678.869 466.087Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "M695.002 473.029L686.301 470.07L685.562 472.244L694.262 475.203L695.002 473.029Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "M710.638 479.78L702.065 476.864L701.335 479.01L709.909 481.926L710.638 479.78Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "M725.754 486.354L717.302 483.479L716.584 485.591L725.036 488.466L725.754 486.354Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "M738.134 493.051L729.905 490.252L729.205 492.309L737.434 495.108L738.134 493.051Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "M753.512 499.057L745.351 496.281L744.656 498.322L752.817 501.098L753.512 499.057Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "M776.257 504.466L767.89 501.62L767.178 503.713L775.545 506.559L776.257 504.466Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "M801.004 510.119L792.397 507.191L791.665 509.344L800.272 512.272L801.004 510.119Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "M817.973 516.229L809.394 513.311L808.664 515.459L817.243 518.377L817.973 516.229Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "M826.654 522.232L818.342 519.405L817.635 521.485L825.946 524.312L826.654 522.232Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "M839.204 527.993L831.022 525.211L830.326 527.257L838.508 530.04L839.204 527.993Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "M863.352 534.102L854.986 531.257L854.274 533.35L862.64 536.196L863.352 534.102Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "M890.517 540.61L881.912 537.683L881.18 539.836L889.785 542.763L890.517 540.61Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "M905.504 546.489L896.967 543.585L896.241 545.72L904.778 548.623L905.504 546.489Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "M909.03 551.323L900.815 548.529L900.116 550.583L908.332 553.377L909.03 551.323Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "M912.265 555.806L904.342 553.112L903.668 555.094L911.591 557.788L912.265 555.806Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "M923.669 560.872L915.85 558.212L915.186 560.166L923.005 562.825L923.669 560.872Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "M936.989 566.065L929.23 563.426L928.57 565.366L936.329 568.005L936.989 566.065Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "M933.062 569.044L925.679 566.533L925.051 568.377L932.435 570.889L933.062 569.044Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "M909.427 569.068L902.749 566.797L902.181 568.468L908.859 570.739L909.427 569.068Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "M891.269 569.28L885.154 567.2L884.634 568.728L890.749 570.808L891.269 569.28Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "M136.426 305.079L127.927 302.189L127.205 304.313L135.703 307.204L136.426 305.079Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "M150.614 309.199L142.035 306.281L141.306 308.426L149.884 311.344L150.614 309.199Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "M170.133 316.188L161.594 313.283L160.867 315.421L169.406 318.325L170.133 316.188Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "M191.203 324.072L182.741 321.194L182.022 323.308L190.484 326.186L191.203 324.072Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "M208.588 329.927L200.119 327.046L199.399 329.163L207.868 332.043L208.588 329.927Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "M218.232 331.253L209.55 328.3L208.811 330.471L217.494 333.424L218.232 331.253Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "M222.67 329.22L213.599 326.135L212.827 328.405L221.898 331.49L222.67 329.22Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "M232.482 330.054L223.135 326.875L222.34 329.212L231.687 332.391L232.482 330.054Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "M252.809 337.219L243.486 334.048L242.694 336.378L252.017 339.549L252.809 337.219Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "M274.651 345.412L265.413 342.27L264.628 344.579L273.865 347.721L274.651 345.412Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "M290.141 349.404L280.766 346.216L279.968 348.561L289.343 351.749L290.141 349.404Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "M302.989 351.305L293.341 348.024L292.521 350.436L302.168 353.718L302.989 351.305Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "M322.151 357.446L312.463 354.151L311.638 356.577L321.326 359.872L322.151 357.446Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "M346.515 367.588L337.029 364.362L336.223 366.733L345.709 369.959L346.515 367.588Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "M369.463 376.97L360.153 373.804L359.36 376.133L368.67 379.3L369.463 376.97Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "M387.79 382.607L378.412 379.418L377.616 381.76L386.993 384.95L387.79 382.607Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "M404.404 386.391L394.824 383.133L394.01 385.527L403.589 388.786L404.404 386.391Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "M420.987 389.499L411.125 386.145L410.286 388.612L420.148 391.966L420.987 389.499Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "M437.093 390.966L426.79 387.462L425.914 390.037L436.217 393.542L437.093 390.966Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "M455.355 393.536L444.653 389.896L443.742 392.573L454.445 396.213L455.355 393.536Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "M477.631 401.066L466.923 397.424L466.012 400.101L476.72 403.743L477.631 401.066Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "M500.947 411.404L490.506 407.853L489.619 410.463L500.06 414.014L500.947 411.404Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "M523.153 421.298L512.967 417.834L512.1 420.381L522.287 423.846L523.153 421.298Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "M544.334 429.478L534.254 426.049L533.396 428.571L543.476 431.999L544.334 429.478Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "M565.115 437.324L555.123 433.926L554.274 436.424L564.266 439.822L565.115 437.324Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "M584.889 446.16L575.128 442.84L574.299 445.278L584.06 448.598L584.889 446.16Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "M603.055 455.325L593.621 452.116L592.818 454.477L602.253 457.685L603.055 455.325Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "M620.033 463.892L610.91 460.789L610.134 463.069L619.258 466.172L620.033 463.892Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "M636.5 471.64L627.61 468.616L626.854 470.84L635.744 473.863L636.5 471.64Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "M652.957 478.693L644.227 475.724L643.485 477.906L652.215 480.875L652.957 478.693Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "M670.093 485.161L661.436 482.217L660.7 484.38L669.357 487.324L670.093 485.161Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "M687.37 491.445L678.755 488.515L678.022 490.668L686.637 493.598L687.37 491.445Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "M704.334 497.678L695.771 494.766L695.042 496.908L703.605 499.821L704.334 497.678Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "M718.239 504.092L709.863 501.243L709.15 503.339L717.527 506.188L718.239 504.092Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "M726.788 510.484L718.793 507.765L718.113 509.762L726.109 512.481L726.788 510.484Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "M740.34 516.202L732.467 513.524L731.797 515.493L739.67 518.171L740.34 516.202Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "M763.202 521.836L755.095 519.079L754.405 521.107L762.512 523.864L763.202 521.836Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "M789.013 527.868L780.603 525.008L779.887 527.111L788.298 529.972L789.013 527.868Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "M808.403 533.927L799.934 531.047L799.214 533.164L807.683 536.044L808.403 533.927Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "M820.897 539.566L812.58 536.737L811.873 538.818L820.19 541.646L820.897 539.566Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "M835.208 545.197L826.979 542.399L826.279 544.456L834.508 547.254L835.208 545.197Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "M857.019 551.496L848.664 548.654L847.952 550.745L856.308 553.587L857.019 551.496Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "M879.801 558.02L871.313 555.133L870.591 557.258L879.079 560.145L879.801 558.02Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "M892.102 563.367L883.741 560.524L883.029 562.617L891.39 565.461L892.102 563.367Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "M895.539 567.419L887.494 564.682L886.81 566.693L894.855 569.429L895.539 567.419Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "M899.281 571.253L891.516 568.612L890.856 570.552L898.621 573.193L899.281 571.253Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "M904.31 575.061L896.782 572.501L896.14 574.387L903.669 576.947L904.31 575.061Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "M906.406 578.231L899.142 575.761L898.524 577.577L905.788 580.047L906.406 578.231Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "M903.048 580.293L896.137 577.943L895.55 579.67L902.461 582.021L903.048 580.293Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "M898.203 581.855L891.65 579.626L891.092 581.266L897.646 583.494L898.203 581.855Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "M895.174 583.505L888.911 581.375L888.379 582.939L894.642 585.069L895.174 583.505Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "M148.891 331.676L140.774 328.916L140.084 330.947L148.201 333.708L148.891 331.676Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "M149.553 329.519L141.083 326.639L140.363 328.755L148.833 331.636L149.553 329.519Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "M161.814 332.865L153.222 329.943L152.491 332.093L161.083 335.015L161.814 332.865Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "M183.327 340.763L174.821 337.87L174.098 339.997L182.604 342.891L183.327 340.763Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "M202.192 347.371L193.715 344.487L192.994 346.607L201.472 349.49L202.192 347.371Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "M208.866 347.681L200.1 344.7L199.354 346.895L208.12 349.876L208.866 347.681Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "M208.408 343.983L199.116 340.823L198.326 343.144L207.618 346.305L208.408 343.983Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "M218.897 345.768L209.343 342.518L208.531 344.907L218.084 348.157L218.897 345.768Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "M244.726 355.823L235.356 352.636L234.559 354.979L243.929 358.165L244.726 355.823Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "M270.59 366.07L261.436 362.956L260.658 365.244L269.812 368.358L270.59 366.07Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "M284.824 369.724L275.495 366.552L274.702 368.884L284.03 372.056L284.824 369.724Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "M294.3 370.293L284.58 366.987L283.753 369.418L293.473 372.724L294.3 370.293Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "M312.813 376.081L303.018 372.749L302.185 375.198L311.98 378.529L312.813 376.081Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "M340.201 387.624L330.736 384.405L329.93 386.773L339.396 389.993L340.201 387.624Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "M365.791 398.406L356.632 395.291L355.853 397.581L365.012 400.697L365.791 398.406Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "M383.531 403.91L374.293 400.768L373.507 403.079L382.744 406.221L383.531 403.91Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "M398.671 407.201L389.162 403.967L388.353 406.346L397.862 409.58L398.671 407.201Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "M415.355 411.223L405.596 407.904L404.767 410.342L414.526 413.662L415.355 411.223Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "M432.208 414.773L422.128 411.344L421.27 413.866L431.35 417.294L432.208 414.773Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "M450.493 418.882L440.099 415.347L439.216 417.944L449.61 421.479L450.493 418.882Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "M472.047 426.117L461.643 422.579L460.758 425.181L471.162 428.719L472.047 426.117Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "M494.388 434.72L484.132 431.232L483.26 433.795L493.517 437.283L494.388 434.72Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "M516.056 442.915L505.921 439.468L505.059 442.002L515.194 445.449L516.056 442.915Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "M537.192 450.494L527.117 447.067L526.259 449.589L536.334 453.015L537.192 450.494Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "M557.977 458.345L548.019 454.958L547.172 457.448L557.131 460.835L557.977 458.345Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "M577.764 466.794L568.058 463.492L567.232 465.92L576.939 469.222L577.764 466.794Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "M595.539 475.647L586.247 472.486L585.457 474.811L594.748 477.971L595.539 475.647Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "M611.447 483.983L602.588 480.97L601.834 483.185L610.693 486.198L611.447 483.983Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "M626.645 491.343L618.11 488.44L617.384 490.575L625.919 493.478L626.645 491.343Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "M642.324 497.848L633.961 495.004L633.25 497.094L641.613 499.939L642.324 497.848Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "M658.813 503.899L650.517 501.077L649.811 503.152L658.107 505.974L658.813 503.899Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "M676.126 509.779L667.827 506.956L667.122 509.029L675.421 511.851L676.126 509.779Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "M693.218 515.661L684.927 512.842L684.222 514.914L692.513 517.734L693.218 515.661Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "M705.875 521.492L697.813 518.749L697.127 520.765L705.19 523.507L705.875 521.492Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "M711.829 526.767L704.249 524.189L703.604 526.085L711.184 528.663L711.829 526.767Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "M724.035 531.899L716.598 529.37L715.965 531.23L723.403 533.759L724.035 531.899Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "M747.379 537.853L739.648 535.224L738.991 537.157L746.722 539.786L747.379 537.853Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "M775.117 544.556L766.982 541.789L766.29 543.825L774.425 546.592L775.117 544.556Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "M797.816 551.02L789.497 548.19L788.789 550.271L797.108 553.1L797.816 551.02Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "M814.171 556.782L805.88 553.962L805.175 556.035L813.466 558.855L814.171 556.782Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "M830.098 562.457L821.846 559.65L821.145 561.712L829.397 564.519L830.098 562.457Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "M849.708 568.687L841.392 565.858L840.683 567.941L849 570.77L849.708 568.687Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "M867.943 574.732L859.6 571.895L858.891 573.98L867.234 576.818L867.943 574.732Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "M876.156 579.031L868.039 576.27L867.348 578.301L875.465 581.062L876.156 579.031Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "M877.471 581.903L869.712 579.264L869.051 581.207L876.81 583.846L877.471 581.903Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "M880.614 584.911L873.143 582.37L872.507 584.24L879.978 586.781L880.614 584.911Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "M882.284 587.453L875.106 585.011L874.495 586.807L881.674 589.248L882.284 587.453Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "M878.918 588.809L872.108 586.492L871.528 588.197L878.338 590.513L878.918 588.809Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "M877.58 590.388L871.065 588.172L870.512 589.799L877.026 592.014L877.58 590.388Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "M885.448 593.779L879.042 591.6L878.497 593.203L884.902 595.382L885.448 593.779Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "M892.323 596.899L886.032 594.759L885.497 596.331L891.788 598.471L892.323 596.899Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "M157.874 354.938L150.058 352.28L149.392 354.236L157.209 356.894L157.874 354.938Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "M153.863 351.658L145.613 348.852L144.912 350.915L153.161 353.72L153.863 351.658Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "M159.09 352.247L150.571 349.349L149.847 351.479L158.366 354.376L159.09 352.247Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "M173.935 356.997L165.348 354.077L164.618 356.225L173.204 359.145L173.935 356.997Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "M189.474 362.028L180.833 359.089L180.098 361.25L188.739 364.188L189.474 362.028Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "M198.817 364.204L189.95 361.188L189.196 363.406L198.062 366.422L198.817 364.204Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "M204.646 364.65L195.431 361.516L194.647 363.822L203.861 366.956L204.646 364.65Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "M217.424 368.168L208.023 364.971L207.223 367.323L216.623 370.521L217.424 368.168Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "M238.916 375.736L229.575 372.559L228.781 374.893L238.122 378.07L238.916 375.736Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "M260.898 383.585L251.637 380.435L250.849 382.752L260.11 385.902L260.898 383.585Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "M276.317 388.219L266.921 385.023L266.123 387.371L275.519 390.566L276.317 388.219Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "M288.442 391.072L278.761 387.779L277.937 390.202L287.618 393.495L288.442 391.072Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "M307.979 397.601L298.272 394.3L297.446 396.728L307.153 400.029L307.979 397.601Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "M335.03 408.188L325.634 404.992L324.836 407.34L334.232 410.536L335.03 408.188Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "M360.152 417.974L351.036 414.874L350.261 417.154L359.376 420.254L360.152 417.974Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "M378.065 423.797L368.89 420.677L368.11 422.97L377.286 426.091L378.065 423.797Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "M394.368 428.541L385.011 425.358L384.216 427.695L393.573 430.878L394.368 428.541Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "M412.087 433.991L402.601 430.765L401.793 433.138L411.28 436.365L412.087 433.991Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "M429.773 439.199L420.106 435.911L419.283 438.329L428.951 441.617L429.773 439.199Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "M448.094 444.574L438.232 441.219L437.393 443.686L447.255 447.041L448.094 444.574Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "M468.54 451.47L458.664 448.111L457.825 450.58L467.7 453.939L468.54 451.47Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "M489.408 458.813L479.588 455.473L478.753 457.927L488.574 461.267L489.408 458.813Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "M509.873 465.788L500.057 462.45L499.223 464.904L509.039 468.242L509.873 465.788Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "M530.237 472.353L520.341 468.987L519.5 471.462L529.396 474.827L530.237 472.353Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "M550.868 479.309L540.956 475.938L540.113 478.415L550.025 481.786L550.868 479.309Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "M570.747 487.17L561.085 483.883L560.262 486.301L569.925 489.587L570.747 487.17Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "M588.135 495.434L579.001 492.327L578.225 494.61L587.359 497.716L588.135 495.434Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "M602.953 503.043L594.4 500.135L593.672 502.275L602.225 505.184L602.953 503.043Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "M616.711 509.653L608.591 506.891L607.9 508.923L616.02 511.684L616.711 509.653Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "M630.984 515.538L623.095 512.855L622.424 514.829L630.313 517.512L630.984 515.538Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "M646.316 521.109L638.508 518.453L637.843 520.406L645.652 523.062L646.316 521.109Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "M662.052 526.614L654.278 523.97L653.616 525.916L661.391 528.56L662.052 526.614Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "M677.459 532.051L669.731 529.423L669.073 531.358L676.801 533.986L677.459 532.051Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "M690.158 537.137L682.601 534.567L681.959 536.455L689.516 539.026L690.158 537.137Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "M698.969 541.543L691.728 539.081L691.112 540.891L698.353 543.354L698.969 541.543Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "M712.4 546.415L705.23 543.977L704.62 545.769L711.791 548.208L712.4 546.415Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "M735.044 552.803L727.577 550.264L726.942 552.131L734.408 554.671L735.044 552.803Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "M763.031 560.357L755.119 557.666L754.445 559.645L762.358 562.336L763.031 560.357Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "M789.186 567.828L780.957 565.03L780.257 567.087L788.486 569.885L789.186 567.828Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "M810.534 574.51L802.173 571.667L801.461 573.76L809.822 576.604L810.534 574.51Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "M828.786 580.614L820.402 577.762L819.689 579.859L828.074 582.71L828.786 580.614Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "M845.528 586.395L837.162 583.55L836.451 585.641L844.817 588.486L845.528 586.395Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "M858.115 591.235L849.876 588.432L849.175 590.492L857.414 593.294L858.115 591.235Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "M861.67 593.932L853.769 591.244L853.096 593.221L860.998 595.908L861.67 593.932Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "M857.428 594.639L850.011 592.116L849.381 593.971L856.798 596.494L857.428 594.639Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "M857.681 596.236L850.604 593.829L850.001 595.6L857.078 598.007L857.681 596.236Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "M862.039 598.702L855.179 596.369L854.596 598.083L861.455 600.416L862.039 598.702Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "M864.276 600.554L857.666 598.306L857.103 599.961L863.713 602.209L864.276 600.554Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "M866.507 602.323L860.122 600.151L859.579 601.749L865.963 603.921L866.507 602.323Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "M874.593 605.507L868.307 603.369L867.772 604.941L874.058 607.079L874.593 605.507Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "M881.088 608.246L874.921 606.148L874.397 607.692L880.564 609.789L881.088 608.246Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "M168.369 377.366L160.875 374.817L160.237 376.693L167.732 379.242L168.369 377.366Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "M162.387 374.377L154.439 371.673L153.763 373.66L161.712 376.364L162.387 374.377Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "M162.38 373.599L154.068 370.772L153.361 372.852L161.672 375.679L162.38 373.599Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "M170.85 376.054L162.333 373.157L161.609 375.287L170.126 378.184L170.85 376.054Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "M182.657 379.763L173.998 376.818L173.262 378.984L181.921 381.929L182.657 379.763Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "M196.063 384.074L187.285 381.088L186.537 383.285L195.316 386.271L196.063 384.074Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "M211.315 389.087L202.457 386.074L201.703 388.29L210.562 391.303L211.315 389.087Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "M225.865 393.802L216.895 390.751L216.132 392.995L225.102 396.046L225.865 393.802Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "M237.514 397.315L228.331 394.192L227.549 396.49L236.732 399.613L237.514 397.315Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "M251.345 401.651L241.991 398.47L241.195 400.81L250.549 403.991L251.345 401.651Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "M268.595 407.359L259.163 404.151L258.361 406.509L267.793 409.717L268.595 407.359Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    d: "M285.227 412.773L275.681 409.526L274.87 411.913L284.416 415.16L285.227 412.773Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    d: "M306.211 420.008L296.709 416.777L295.901 419.153L305.403 422.385L306.211 420.008Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    d: "M332.13 429.397L322.903 426.259L322.118 428.567L331.345 431.706L332.13 429.397Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    d: "M356.043 438.016L347.039 434.954L346.273 437.206L355.277 440.268L356.043 438.016Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "M373.98 444.019L364.934 440.942L364.165 443.204L373.211 446.281L373.98 444.019Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "M391.331 449.729L382.197 446.622L381.42 448.908L390.553 452.014L391.331 449.729Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    d: "M409.74 455.898L400.562 452.776L399.783 455.069L408.96 458.191L409.74 455.898Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "M428.344 462.135L419.122 458.999L418.337 461.305L427.559 464.441L428.344 462.135Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "M447.031 468.381L437.755 465.226L436.966 467.545L446.242 470.7L447.031 468.381Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "M466.277 474.907L456.993 471.749L456.203 474.071L465.487 477.228L466.277 474.907Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "M485.438 481.36L476.122 478.192L475.331 480.519L484.646 483.687L485.438 481.36Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "M504.506 487.651L495.103 484.453L494.302 486.806L503.706 490.004L504.506 487.651Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "M523.725 493.745L514.114 490.477L513.296 492.881L522.907 496.15L523.725 493.745Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "M543.802 500.235L534.028 496.911L533.197 499.354L542.971 502.679L543.802 500.235Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "M563.593 507.473L554.057 504.23L553.247 506.614L562.782 509.857L563.593 507.473Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "M580.546 514.616L571.661 511.595L570.905 513.818L579.79 516.84L580.546 514.616Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "M594.374 520.824L586.202 518.045L585.507 520.089L593.678 522.869L594.374 520.824Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "M607.09 526.209L599.419 523.6L598.766 525.519L606.437 528.128L607.09 526.209Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "M620.41 531.263L612.986 528.738L612.355 530.593L619.78 533.118L620.41 531.263Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "M634.741 536.325L627.404 533.83L626.781 535.664L634.117 538.159L634.741 536.325Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "M648.717 541.264L641.469 538.799L640.852 540.612L648.1 543.077L648.717 541.264Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "M662.285 546.067L655.127 543.632L654.519 545.422L661.676 547.857L662.285 546.067Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "M675.854 550.832L668.766 548.422L668.164 550.194L675.251 552.604L675.854 550.832Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    d: "M689.903 555.683L682.849 553.284L682.249 555.051L689.302 557.45L689.903 555.683Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "M705.835 560.989L698.729 558.572L698.125 560.349L705.23 562.766L705.835 560.989Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "M726.758 567.593L719.411 565.094L718.787 566.931L726.134 569.429L726.758 567.593Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "M753.037 575.688L745.285 573.052L744.626 574.99L752.377 577.626L753.037 575.688Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    d: "M781.859 584.58L773.677 581.797L772.981 583.844L781.163 586.626L781.859 584.58Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    d: "M808.817 593.083L800.324 590.194L799.603 592.316L808.096 595.205L808.817 593.083Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "M829.965 600.058L821.368 597.135L820.637 599.282L829.234 602.206L829.965 600.058Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "M843.269 604.855L834.801 601.976L834.081 604.092L842.549 606.972L843.269 604.855Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "M849.728 607.675L841.559 604.896L840.864 606.94L849.033 609.719L849.728 607.675Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    d: "M849.758 608.591L842.014 605.957L841.356 607.892L849.1 610.526L849.758 608.591Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    d: "M839.837 606.53L832.711 604.107L832.106 605.886L839.232 608.31L839.837 606.53Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "M836.891 606.379L830.172 604.094L829.6 605.775L836.32 608.06L836.891 606.379Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    d: "M845.249 609.479L838.651 607.235L838.089 608.888L844.687 611.132L845.249 609.479Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    d: "M855.058 612.989L848.541 610.773L847.986 612.405L854.503 614.621L855.058 612.989Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "M860.713 615.248L854.354 613.086L853.814 614.673L860.173 616.836L860.713 615.248Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    d: "M866.897 617.635L860.673 615.518L860.144 617.075L866.368 619.192L866.897 617.635Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "M871.556 619.547L865.485 617.482L864.969 619L871.04 621.065L871.556 619.547Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "M177.374 397.797L170.162 395.344L169.549 397.147L176.761 399.6L177.374 397.797Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    d: "M171.055 395.74L163.402 393.137L162.752 395.049L170.405 397.652L171.055 395.74Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    d: "M169.382 395.249L161.348 392.517L160.665 394.524L168.699 397.257L169.382 395.249Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    d: "M176.151 397.601L167.891 394.791L167.189 396.856L175.448 399.666L176.151 397.601Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "M186.472 401.146L178.049 398.281L177.332 400.387L185.756 403.252L186.472 401.146Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "M199.315 405.537L190.775 402.632L190.048 404.77L198.588 407.674L199.315 405.537Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    d: "M214.939 410.862L206.342 407.939L205.61 410.089L214.207 413.013L214.939 410.862Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "M228.798 415.599L220.09 412.638L219.35 414.814L228.058 417.776L228.798 415.599Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    d: "M237.956 418.772L228.978 415.718L228.214 417.965L237.192 421.018L237.956 418.772Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "M249.95 422.895L240.761 419.77L239.98 422.068L249.168 425.193L249.95 422.895Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    d: "M267.511 428.879L258.268 425.736L257.482 428.047L266.725 431.19L267.511 428.879Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    d: "M284.908 434.808L275.598 431.641L274.807 433.968L284.117 437.135L284.908 434.808Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    d: "M305.922 441.946L296.674 438.801L295.887 441.115L305.135 444.26L305.922 441.946Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "M330.936 450.399L321.935 447.337L321.169 449.589L330.17 452.651L330.936 450.399Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    d: "M353.886 458.164L345.085 455.171L344.336 457.373L353.137 460.367L353.886 458.164Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    d: "M371.508 464.166L362.667 461.159L361.916 463.37L370.756 466.376L371.508 464.166Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    d: "M388.929 470.103L380.031 467.077L379.274 469.302L388.172 472.329L388.929 470.103Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    d: "M407.135 476.301L398.217 473.268L397.458 475.498L406.376 478.532L407.135 476.301Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    d: "M425.57 482.574L416.641 479.537L415.882 481.771L424.81 484.807L425.57 482.574Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "M444.009 488.845L435.062 485.802L434.301 488.038L443.248 491.081L444.009 488.845Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "M462.56 495.158L453.606 492.112L452.844 494.351L461.799 497.397L462.56 495.158Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "M480.824 501.381L471.81 498.315L471.043 500.57L480.058 503.635L480.824 501.381Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    d: "M499.116 507.626L489.992 504.523L489.217 506.803L498.34 509.906L499.116 507.626Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    d: "M517.629 513.966L508.306 510.795L507.513 513.127L516.836 516.298L517.629 513.966Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    d: "M536.999 520.58L527.536 517.361L526.731 519.727L536.194 522.945L536.999 520.58Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    d: "M556.298 527.094L547.081 523.959L546.297 526.266L555.513 529.4L556.298 527.094Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    d: "M573.081 532.669L564.505 529.752L563.775 531.898L572.351 534.815L573.081 532.669Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    d: "M586.788 537.181L578.925 534.507L578.256 536.473L586.119 539.147L586.788 537.181Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    d: "M598.995 541.223L591.656 538.727L591.032 540.561L598.371 543.057L598.995 541.223Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    d: "M611.433 545.392L604.379 542.993L603.779 544.757L610.833 547.156L611.433 545.392Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    d: "M624.883 549.947L617.93 547.582L617.339 549.32L624.292 551.685L624.883 549.947Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    d: "M637.977 554.38L631.123 552.049L630.54 553.763L637.394 556.095L637.977 554.38Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    d: "M650.804 558.725L644.041 556.425L643.466 558.116L650.229 560.417L650.804 558.725Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    d: "M664.369 563.333L657.634 561.042L657.062 562.726L663.796 565.016L664.369 563.333Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    d: "M679.369 568.443L672.585 566.136L672.008 567.83L678.793 570.137L679.369 568.443Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    d: "M695.788 574.051L688.903 571.709L688.317 573.432L695.202 575.773L695.788 574.051Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    d: "M716.262 581.066L709.13 578.641L708.523 580.426L715.655 582.851L716.262 581.066Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    d: "M741.879 589.863L734.34 587.299L733.699 589.185L741.238 591.749L741.879 589.863Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    d: "M770.699 599.758L762.706 597.04L762.027 599.037L770.02 601.755L770.699 599.758Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    d: "M798.222 609.194L789.877 606.356L789.167 608.444L797.512 611.283L798.222 609.194Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    d: "M819.511 616.461L811.049 613.583L810.329 615.7L818.791 618.578L819.511 616.461Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    d: "M832.126 620.723L823.804 617.892L823.095 619.975L831.417 622.806L832.126 620.723Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    d: "M837.864 622.608L829.859 619.885L829.178 621.888L837.183 624.61L837.864 622.608Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    d: "M838.259 622.655L830.666 620.073L830.02 621.971L837.613 624.554L838.259 622.655Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    d: "M829.662 619.604L822.66 617.222L822.065 618.971L829.067 621.352L829.662 619.604Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    d: "M827.932 618.94L821.306 616.687L820.742 618.344L827.368 620.598L827.932 618.94Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    d: "M837.321 622.113L830.793 619.893L830.238 621.525L836.766 623.745L837.321 622.113Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    d: "M848.349 625.852L841.876 623.651L841.325 625.27L847.798 627.471L848.349 625.852Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    d: "M855.302 628.189L848.964 626.033L848.425 627.618L854.763 629.773L855.302 628.189Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    d: "M862.52 630.617L856.296 628.5L855.766 630.057L861.99 632.174L862.52 630.617Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    d: "M868.282 632.551L862.191 630.479L861.673 632.002L867.764 634.074L868.282 632.551Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    d: "M177.556 414.361L170.451 411.944L169.846 413.721L176.952 416.138L177.556 414.361Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    d: "M178.162 415.302L170.766 412.787L170.138 414.634L177.534 417.149L178.162 415.302Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    d: "M179.174 416.419L171.469 413.799L170.814 415.726L178.518 418.347L179.174 416.419Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    d: "M190.299 420.484L182.486 417.826L181.821 419.78L189.635 422.437L190.299 420.484Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    d: "M202.568 424.897L194.661 422.207L193.988 424.184L201.895 426.873L202.568 424.897Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    d: "M210.938 428.247L202.834 425.491L202.146 427.514L210.25 430.271L210.938 428.247Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    d: "M218.93 431.547L210.595 428.712L209.886 430.798L218.221 433.633L218.93 431.547Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    d: "M228.665 435.388L220.122 432.482L219.395 434.62L227.938 437.525L228.665 435.388Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    d: "M238.088 439.209L229.299 436.22L228.551 438.42L237.339 441.409L238.088 439.209Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    d: "M251.261 444.092L242.311 441.048L241.551 443.284L250.5 446.328L251.261 444.092Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    d: "M268.805 450.151L259.824 447.097L259.06 449.343L268.041 452.398L268.805 450.151Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    d: "M285.823 456.09L276.783 453.015L276.014 455.277L285.054 458.352L285.823 456.09Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    d: "M306.025 462.834L297.032 459.775L296.267 462.024L305.26 465.083L306.025 462.834Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    d: "M326.979 469.723L318.079 466.696L317.322 468.922L326.222 471.949L326.979 469.723Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    d: "M346.209 476.185L337.34 473.169L336.586 475.384L345.456 478.401L346.209 476.185Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    d: "M364.38 482.4L355.496 479.379L354.74 481.599L363.625 484.621L364.38 482.4Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    d: "M384.027 488.923L375.207 485.924L374.457 488.129L383.277 491.128L384.027 488.923Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    d: "M402.888 495.26L394.1 492.271L393.351 494.471L402.14 497.46L402.888 495.26Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    d: "M421.649 501.554L412.897 498.577L412.152 500.767L420.904 503.744L421.649 501.554Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    d: "M440.477 507.828L431.777 504.869L431.037 507.045L439.737 510.004L440.477 507.828Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    d: "M458.395 513.98L449.669 511.012L448.927 513.194L457.653 516.162L458.395 513.98Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    d: "M475.351 520.169L466.459 517.145L465.703 519.368L474.595 522.393L475.351 520.169Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    d: "M493.147 526.569L484.12 523.499L483.351 525.759L492.379 528.829L493.147 526.569Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    d: "M512.062 532.921L503.063 529.861L502.297 532.112L511.296 535.173L512.062 532.921Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    d: "M531.029 538.863L522.232 535.871L521.484 538.071L530.281 541.063L531.029 538.863Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    d: "M549.079 544.285L540.566 541.389L539.841 543.519L548.355 546.414L549.079 544.285Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    d: "M565.789 549.123L557.612 546.342L556.916 548.388L565.093 551.17L565.789 549.123Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    d: "M580.422 552.913L572.709 550.29L572.054 552.217L579.766 554.841L580.422 552.913Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    d: "M592.011 555.283L584.921 552.872L584.317 554.646L591.407 557.057L592.011 555.283Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    d: "M601.971 557.363L595.397 555.127L594.838 556.771L601.412 559.007L601.971 557.363Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    d: "M613.672 560.9L607.272 558.723L606.728 560.323L613.128 562.5L613.672 560.9Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    d: "M625.63 564.703L619.331 562.561L618.795 564.135L625.095 566.278L625.63 564.703Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    d: "M637.753 568.667L631.521 566.548L630.991 568.107L637.223 570.226L637.753 568.667Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    d: "M651.252 573.334L644.992 571.205L644.46 572.769L650.72 574.898L651.252 573.334Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    d: "M666.077 578.601L659.723 576.44L659.183 578.028L665.537 580.189L666.077 578.601Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    d: "M682.174 584.407L675.69 582.201L675.139 583.823L681.622 586.028L682.174 584.407Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    d: "M701.768 591.719L695.031 589.428L694.458 591.114L701.195 593.405L701.768 591.719Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    d: "M725.332 600.659L718.224 598.242L717.619 600.019L724.727 602.436L725.332 600.659Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    d: "M750.791 610.288L743.306 607.743L742.669 609.615L750.154 612.161L750.791 610.288Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    d: "M775.099 619.282L767.325 616.638L766.664 618.581L774.439 621.225L775.099 619.282Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    d: "M794.429 626.106L786.556 623.428L785.887 625.394L793.761 628.072L794.429 626.106Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    d: "M807.573 630.336L799.796 627.691L799.135 629.634L806.912 632.279L807.573 630.336Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    d: "M816.018 632.67L808.455 630.098L807.812 631.989L815.374 634.561L816.018 632.67Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    d: "M821.68 633.927L814.38 631.444L813.759 633.27L821.059 635.753L821.68 633.927Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    d: "M827.057 635.142L819.998 632.741L819.397 634.508L826.456 636.909L827.057 635.142Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    d: "M834.704 637.326L827.811 634.982L827.225 636.704L834.118 639.049L834.704 637.326Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    d: "M841.103 639.048L834.389 636.765L833.818 638.443L840.532 640.727L841.103 639.048Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    d: "M844.605 639.675L838.114 637.467L837.562 639.089L844.054 641.296L844.605 639.675Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    d: "M849.659 640.954L843.341 638.805L842.805 640.382L849.122 642.531L849.659 640.954Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    d: "M860.678 644.598L854.402 642.463L853.869 644.033L860.145 646.167L860.678 644.598Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    d: "M870.584 647.816L864.37 645.703L863.842 647.257L870.056 649.37L870.584 647.816Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    d: "M179.8 430.964L172.834 428.595L172.242 430.335L179.208 432.704L179.8 430.964Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    d: "M187.423 434.231L180.318 431.814L179.713 433.591L186.819 436.008L187.423 434.231Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    d: "M192.468 436.94L185.157 434.453L184.535 436.282L191.846 438.768L192.468 436.94Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    d: "M208.443 442.295L201.151 439.815L200.531 441.638L207.823 444.118L208.443 442.295Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    d: "M222.631 447.233L215.318 444.746L214.695 446.577L222.008 449.065L222.631 447.233Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    d: "M226.53 449.891L218.939 447.309L218.294 449.205L225.885 451.787L226.53 449.891Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    d: "M226.415 451.819L218.42 449.1L217.74 451.098L225.736 453.817L226.415 451.819Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    d: "M230.407 454.833L222.072 451.998L221.363 454.084L229.698 456.918L230.407 454.833Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    d: "M238.112 458.788L229.5 455.858L228.768 458.011L237.38 460.941L238.112 458.788Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    d: "M251.413 463.994L242.663 461.018L241.918 463.208L250.668 466.184L251.413 463.994Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    d: "M268.957 470.063L260.186 467.08L259.44 469.274L268.21 472.257L268.957 470.063Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    d: "M285.426 475.974L276.588 472.968L275.837 475.175L284.675 478.181L285.426 475.974Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    d: "M304.621 482.36L295.814 479.365L295.065 481.567L303.872 484.563L304.621 482.36Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    d: "M322.056 488.467L313.213 485.459L312.461 487.672L321.304 490.68L322.056 488.467Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    d: "M338.206 494.449L329.262 491.407L328.502 493.64L337.447 496.682L338.206 494.449Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    d: "M356.885 500.79L347.943 497.749L347.182 499.985L356.124 503.026L356.885 500.79Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    d: "M378.354 507.346L369.565 504.356L368.817 506.556L377.606 509.545L378.354 507.346Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    d: "M397.725 513.615L389.001 510.648L388.259 512.83L396.983 515.797L397.725 513.615Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    d: "M416.764 519.796L408.102 516.85L407.366 519.016L416.027 521.962L416.764 519.796Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    d: "M436.005 525.868L427.439 522.955L426.712 525.095L435.277 528.008L436.005 525.868Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    d: "M453.562 531.976L444.97 529.054L444.24 531.202L452.831 534.124L453.562 531.976Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    d: "M469.717 538.521L460.91 535.526L460.16 537.731L468.967 540.726L469.717 538.521Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    d: "M487.388 545.084L478.467 542.05L477.709 544.278L486.63 547.312L487.388 545.084Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    d: "M506.976 550.502L498.309 547.554L497.573 549.72L506.24 552.668L506.976 550.502Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    d: "M525.918 554.562L517.744 551.782L517.049 553.826L525.223 556.606L525.918 554.562Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    d: "M542.871 558.788L535.01 556.115L534.341 558.081L542.202 560.755L542.871 558.788Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    d: "M559.025 563.837L551.258 561.195L550.598 563.138L558.365 565.78L559.025 563.837Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    d: "M574.036 567.657L566.531 565.105L565.892 566.983L573.397 569.536L574.036 567.657Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    d: "M585.31 568.248L578.474 565.923L577.892 567.632L584.728 569.957L585.31 568.248Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    d: "M593.713 567.812L587.556 565.718L587.032 567.259L593.189 569.353L593.713 567.812Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    d: "M604.112 570.243L598.183 568.227L597.68 569.708L603.608 571.724L604.112 570.243Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    d: "M615.369 573.649L609.526 571.662L609.029 573.123L614.872 575.11L615.369 573.649Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    d: "M627.44 577.723L621.605 575.738L621.109 577.196L626.944 579.181L627.44 577.723Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    d: "M641.562 583.091L635.611 581.066L635.104 582.555L641.056 584.58L641.562 583.091Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    d: "M656.897 589.053L650.79 586.976L650.271 588.501L656.378 590.578L656.897 589.053Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    d: "M673.055 595.344L666.784 593.212L666.251 594.778L672.522 596.911L673.055 595.344Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    d: "M691.289 602.626L684.798 600.418L684.245 602.042L690.736 604.249L691.289 602.626Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    d: "M711.484 610.782L704.729 608.485L704.154 610.173L710.91 612.471L711.484 610.782Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    d: "M731.95 618.877L724.961 616.5L724.367 618.246L731.356 620.623L731.95 618.877Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    d: "M751.649 626.42L744.484 623.983L743.874 625.775L751.039 628.212L751.649 626.42Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    d: "M768.442 632.424L761.22 629.967L760.607 631.77L767.829 634.227L768.442 632.424Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    d: "M782.513 637.068L775.319 634.621L774.708 636.418L781.901 638.865L782.513 637.068Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    d: "M794.992 640.97L787.869 638.547L787.262 640.33L794.386 642.752L794.992 640.97Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    d: "M807.472 644.908L800.41 642.506L799.808 644.275L806.87 646.677L807.472 644.908Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    d: "M825.786 651.58L818.636 649.148L818.028 650.935L825.178 653.367L825.786 651.58Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    d: "M841.742 657.126L834.564 654.684L833.954 656.479L841.132 658.921L841.742 657.126Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    d: "M845.884 657.342L838.953 654.984L838.363 656.717L845.295 659.075L845.884 657.342Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    d: "M842.771 654.434L836.22 652.206L835.663 653.842L842.214 656.07L842.771 654.434Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    d: "M844.784 653.943L838.474 651.797L837.938 653.374L844.247 655.52L844.784 653.943Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    d: "M857.191 658.091L850.895 655.949L850.359 657.524L856.656 659.666L857.191 658.091Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    d: "M869.652 662.271L863.371 660.135L862.837 661.704L869.118 663.84L869.652 662.271Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    d: "M193.337 449.237L186.722 446.987L186.159 448.642L192.774 450.892L193.337 449.237Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    d: "M203 453.111L196.304 450.834L195.734 452.51L202.43 454.787L203 453.111Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    d: "M210.192 456.559L203.356 454.234L202.773 455.946L209.609 458.271L210.192 456.559Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    d: "M222.588 461.064L215.713 458.726L215.128 460.446L222.003 462.784L222.588 461.064Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    d: "M233.04 465.244L226.077 462.876L225.485 464.617L232.448 466.985L233.04 465.244Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    d: "M236.327 468.281L229.097 465.822L228.483 467.627L235.713 470.087L236.327 468.281Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    d: "M235.058 470.778L227.421 468.181L226.771 470.09L234.409 472.688L235.058 470.778Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    d: "M234.601 473.723L226.533 470.979L225.847 472.997L233.914 475.741L234.601 473.723Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    d: "M236.957 477.421L228.484 474.539L227.764 476.658L236.236 479.54L236.957 477.421Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    d: "M247.563 482.527L238.883 479.575L238.145 481.744L246.825 484.696L247.563 482.527Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    d: "M266.114 488.732L257.444 485.784L256.706 487.952L265.376 490.901L266.114 488.732Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    d: "M284.275 494.883L275.613 491.937L274.876 494.103L283.538 497.049L284.275 494.883Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    d: "M303.414 501.109L294.792 498.177L294.058 500.332L302.681 503.265L303.414 501.109Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    d: "M321.62 507.232L313.005 504.302L312.273 506.455L320.888 509.385L321.62 507.232Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    d: "M338.737 513.305L330.088 510.364L329.352 512.527L338.001 515.469L338.737 513.305Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    d: "M356.127 519.437L347.447 516.485L346.709 518.653L355.389 521.606L356.127 519.437Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    d: "M374.032 525.591L365.345 522.636L364.606 524.807L373.294 527.762L374.032 525.591Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    d: "M391.757 531.775L383.048 528.813L382.308 530.99L391.016 533.952L391.757 531.775Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    d: "M411.423 537.738L402.816 534.81L402.083 536.963L410.69 539.891L411.423 537.738Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    d: "M431.444 543.387L423.001 540.515L422.282 542.627L430.726 545.498L431.444 543.387Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    d: "M448.836 549.444L440.369 546.564L439.649 548.681L448.116 551.561L448.836 549.444Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    d: "M464.699 556.295L456.027 553.345L455.29 555.511L463.962 558.461L464.699 556.295Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1451 || (_path1451 = /*#__PURE__*/React.createElement("path", {
    d: "M482.443 562.668L473.727 559.704L472.986 561.883L481.702 564.847L482.443 562.668Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1452 || (_path1452 = /*#__PURE__*/React.createElement("path", {
    d: "M502.035 567.098L493.627 564.238L492.913 566.339L501.32 569.199L502.035 567.098Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1453 || (_path1453 = /*#__PURE__*/React.createElement("path", {
    d: "M520.771 569.994L512.848 567.299L512.175 569.279L520.097 571.973L520.771 569.994Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1454 || (_path1454 = /*#__PURE__*/React.createElement("path", {
    d: "M537.417 573.231L529.835 570.652L529.19 572.548L536.772 575.127L537.417 573.231Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1455 || (_path1455 = /*#__PURE__*/React.createElement("path", {
    d: "M552.814 576.682L545.477 574.186L544.853 576.02L552.19 578.515L552.814 576.682Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1456 || (_path1456 = /*#__PURE__*/React.createElement("path", {
    d: "M566.749 578.831L559.773 576.458L559.18 578.201L566.156 580.574L566.749 578.831Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1457 || (_path1457 = /*#__PURE__*/React.createElement("path", {
    d: "M577.811 578.301L571.434 576.132L570.891 577.727L577.268 579.896L577.811 578.301Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1458 || (_path1458 = /*#__PURE__*/React.createElement("path", {
    d: "M586.543 577.127L580.744 575.154L580.25 576.607L586.049 578.579L586.543 577.127Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1459 || (_path1459 = /*#__PURE__*/React.createElement("path", {
    d: "M596.641 579.134L591.039 577.229L590.563 578.63L596.164 580.535L596.641 579.134Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1460 || (_path1460 = /*#__PURE__*/React.createElement("path", {
    d: "M608.184 582.982L602.593 581.08L602.117 582.479L607.709 584.38L608.184 582.982Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1461 || (_path1461 = /*#__PURE__*/React.createElement("path", {
    d: "M621.318 588.202L615.621 586.264L615.136 587.688L620.834 589.626L621.318 588.202Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1462 || (_path1462 = /*#__PURE__*/React.createElement("path", {
    d: "M636.491 594.827L630.592 592.82L630.09 594.296L635.989 596.303L636.491 594.827Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1463 || (_path1463 = /*#__PURE__*/React.createElement("path", {
    d: "M652.663 601.852L646.553 599.774L646.033 601.302L652.143 603.38L652.663 601.852Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1464 || (_path1464 = /*#__PURE__*/React.createElement("path", {
    d: "M669.202 608.815L662.903 606.672L662.368 608.247L668.667 610.389L669.202 608.815Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1465 || (_path1465 = /*#__PURE__*/React.createElement("path", {
    d: "M685.769 615.555L679.314 613.359L678.765 614.973L685.22 617.168L685.769 615.555Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1466 || (_path1466 = /*#__PURE__*/React.createElement("path", {
    d: "M702.04 621.911L695.474 619.677L694.915 621.32L701.482 623.553L702.04 621.911Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1467 || (_path1467 = /*#__PURE__*/React.createElement("path", {
    d: "M717.546 627.677L710.91 625.419L710.345 627.08L716.982 629.337L717.546 627.677Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1468 || (_path1468 = /*#__PURE__*/React.createElement("path", {
    d: "M732.595 633.102L725.915 630.83L725.346 632.5L732.027 634.772L732.595 633.102Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1469 || (_path1469 = /*#__PURE__*/React.createElement("path", {
    d: "M746.968 638.097L740.275 635.821L739.706 637.494L746.399 639.771L746.968 638.097Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1470 || (_path1470 = /*#__PURE__*/React.createElement("path", {
    d: "M763.114 644.075L756.353 641.776L755.779 643.464L762.54 645.764L763.114 644.075Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1471 || (_path1471 = /*#__PURE__*/React.createElement("path", {
    d: "M781.313 651.11L774.436 648.771L773.851 650.491L780.728 652.83L781.313 651.11Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1472 || (_path1472 = /*#__PURE__*/React.createElement("path", {
    d: "M799.353 657.966L792.374 655.593L791.781 657.336L798.76 659.709L799.353 657.966Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1473 || (_path1473 = /*#__PURE__*/React.createElement("path", {
    d: "M820.02 666.116L812.886 663.689L812.279 665.474L819.413 667.9L820.02 666.116Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1474 || (_path1474 = /*#__PURE__*/React.createElement("path", {
    d: "M836.948 672.235L829.764 669.791L829.153 671.589L836.336 674.032L836.948 672.235Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1475 || (_path1475 = /*#__PURE__*/React.createElement("path", {
    d: "M843.072 672.85L836.093 670.477L835.501 672.22L842.479 674.593L843.072 672.85Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1476 || (_path1476 = /*#__PURE__*/React.createElement("path", {
    d: "M841.547 669.788L834.921 667.534L834.358 669.192L840.983 671.445L841.547 669.788Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1477 || (_path1477 = /*#__PURE__*/React.createElement("path", {
    d: "M841.614 667.729L835.278 665.575L834.739 667.159L841.075 669.314L841.614 667.729Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1478 || (_path1478 = /*#__PURE__*/React.createElement("path", {
    d: "M848.607 669.211L842.396 667.098L841.866 668.654L848.077 670.767L848.607 669.211Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1479 || (_path1479 = /*#__PURE__*/React.createElement("path", {
    d: "M858.017 671.919L851.874 669.83L851.352 671.363L857.496 673.452L858.017 671.919Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1480 || (_path1480 = /*#__PURE__*/React.createElement("path", {
    d: "M207.482 466.065L201.222 463.935L200.69 465.5L206.95 467.629L207.482 466.065Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1481 || (_path1481 = /*#__PURE__*/React.createElement("path", {
    d: "M217.596 470.049L211.276 467.899L210.739 469.479L217.059 471.629L217.596 470.049Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1482 || (_path1482 = /*#__PURE__*/React.createElement("path", {
    d: "M224.854 473.66L218.415 471.47L217.867 473.081L224.306 475.271L224.854 473.66Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1483 || (_path1483 = /*#__PURE__*/React.createElement("path", {
    d: "M226.142 476.553L219.446 474.275L218.877 475.948L225.573 478.226L226.142 476.553Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1484 || (_path1484 = /*#__PURE__*/React.createElement("path", {
    d: "M228.267 479.779L221.31 477.413L220.718 479.153L227.675 481.52L228.267 479.779Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1485 || (_path1485 = /*#__PURE__*/React.createElement("path", {
    d: "M234.302 483.713L227.144 481.278L226.535 483.068L233.693 485.503L234.302 483.713Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1486 || (_path1486 = /*#__PURE__*/React.createElement("path", {
    d: "M237.926 487.579L230.488 485.049L229.856 486.907L237.294 489.436L237.926 487.579Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1487 || (_path1487 = /*#__PURE__*/React.createElement("path", {
    d: "M235.876 491.197L227.987 488.514L227.316 490.488L235.205 493.171L235.876 491.197Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1488 || (_path1488 = /*#__PURE__*/React.createElement("path", {
    d: "M232.625 495.211L224.199 492.345L223.483 494.451L231.908 497.317L232.625 495.211Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1489 || (_path1489 = /*#__PURE__*/React.createElement("path", {
    d: "M239.855 500.521L231.128 497.553L230.387 499.732L239.113 502.7L239.855 500.521Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1490 || (_path1490 = /*#__PURE__*/React.createElement("path", {
    d: "M260.731 506.831L252.087 503.891L251.352 506.052L259.996 508.992L260.731 506.831Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1491 || (_path1491 = /*#__PURE__*/React.createElement("path", {
    d: "M283.609 513.081L275.126 510.196L274.404 512.318L282.887 515.203L283.609 513.081Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1492 || (_path1492 = /*#__PURE__*/React.createElement("path", {
    d: "M304.043 519.099L295.659 516.247L294.945 518.346L303.329 521.198L304.043 519.099Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1493 || (_path1493 = /*#__PURE__*/React.createElement("path", {
    d: "M325.298 524.951L317.056 522.147L316.356 524.207L324.597 527.01L325.298 524.951Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1494 || (_path1494 = /*#__PURE__*/React.createElement("path", {
    d: "M345.429 530.625L337.315 527.866L336.624 529.897L344.738 532.657L345.429 530.625Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1495 || (_path1495 = /*#__PURE__*/React.createElement("path", {
    d: "M360.127 536.582L351.911 533.788L351.211 535.845L359.427 538.639L360.127 536.582Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1496 || (_path1496 = /*#__PURE__*/React.createElement("path", {
    d: "M370.245 543.369L361.677 540.455L360.948 542.598L369.516 545.512L370.245 543.369Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1497 || (_path1497 = /*#__PURE__*/React.createElement("path", {
    d: "M384.724 550.097L375.966 547.118L375.221 549.308L383.979 552.286L384.724 550.097Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1498 || (_path1498 = /*#__PURE__*/React.createElement("path", {
    d: "M406.217 555.442L397.667 552.534L396.939 554.674L405.489 557.582L406.217 555.442Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1499 || (_path1499 = /*#__PURE__*/React.createElement("path", {
    d: "M428.246 559.997L420.002 557.193L419.3 559.255L427.544 562.059L428.246 559.997Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1500 || (_path1500 = /*#__PURE__*/React.createElement("path", {
    d: "M445.293 565.902L437.038 563.094L436.337 565.156L444.591 567.964L445.293 565.902Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1501 || (_path1501 = /*#__PURE__*/React.createElement("path", {
    d: "M460.047 573.368L451.535 570.473L450.812 572.6L459.323 575.495L460.047 573.368Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1502 || (_path1502 = /*#__PURE__*/React.createElement("path", {
    d: "M477.47 579.69L468.919 576.782L468.192 578.922L476.742 581.831L477.47 579.69Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1503 || (_path1503 = /*#__PURE__*/React.createElement("path", {
    d: "M496.785 583.589L488.512 580.775L487.809 582.842L496.082 585.656L496.785 583.589Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1504 || (_path1504 = /*#__PURE__*/React.createElement("path", {
    d: "M515.204 586.369L507.3 583.68L506.627 585.657L514.532 588.345L515.204 586.369Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1505 || (_path1505 = /*#__PURE__*/React.createElement("path", {
    d: "M532.093 588.648L524.551 586.083L523.91 587.969L531.451 590.534L532.093 588.648Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1506 || (_path1506 = /*#__PURE__*/React.createElement("path", {
    d: "M547.228 587.959L540.301 585.603L539.713 587.333L546.639 589.689L547.228 587.959Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1507 || (_path1507 = /*#__PURE__*/React.createElement("path", {
    d: "M559.776 586.282L553.475 584.139L552.939 585.713L559.241 587.857L559.776 586.282Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1508 || (_path1508 = /*#__PURE__*/React.createElement("path", {
    d: "M570.368 585.152L564.562 583.178L564.068 584.63L569.874 586.605L570.368 585.152Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1509 || (_path1509 = /*#__PURE__*/React.createElement("path", {
    d: "M579.654 584.597L574.241 582.757L573.781 584.111L579.193 585.951L579.654 584.597Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1510 || (_path1510 = /*#__PURE__*/React.createElement("path", {
    d: "M589.614 586.625L584.342 584.832L583.894 586.15L589.166 587.943L589.614 586.625Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1511 || (_path1511 = /*#__PURE__*/React.createElement("path", {
    d: "M601.645 591.594L596.281 589.77L595.825 591.111L601.188 592.935L601.645 591.594Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1512 || (_path1512 = /*#__PURE__*/React.createElement("path", {
    d: "M615.887 598.614L610.294 596.712L609.818 598.11L615.412 600.012L615.887 598.614Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1513 || (_path1513 = /*#__PURE__*/React.createElement("path", {
    d: "M631.484 606.335L625.638 604.347L625.141 605.81L630.986 607.798L631.484 606.335Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1514 || (_path1514 = /*#__PURE__*/React.createElement("path", {
    d: "M647.69 614.021L641.614 611.954L641.098 613.472L647.174 615.539L647.69 614.021Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1515 || (_path1515 = /*#__PURE__*/React.createElement("path", {
    d: "M664.099 621.413L657.831 619.282L657.298 620.848L663.566 622.98L664.099 621.413Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1516 || (_path1516 = /*#__PURE__*/React.createElement("path", {
    d: "M678.978 627.27L672.627 625.11L672.087 626.697L678.438 628.857L678.978 627.27Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1517 || (_path1517 = /*#__PURE__*/React.createElement("path", {
    d: "M691.989 631.608L685.648 629.452L685.109 631.037L691.45 633.193L691.989 631.608Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1518 || (_path1518 = /*#__PURE__*/React.createElement("path", {
    d: "M703.902 635.186L697.611 633.046L697.076 634.618L703.367 636.758L703.902 635.186Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1519 || (_path1519 = /*#__PURE__*/React.createElement("path", {
    d: "M715.359 638.524L709.129 636.405L708.599 637.964L714.828 640.083L715.359 638.524Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1520 || (_path1520 = /*#__PURE__*/React.createElement("path", {
    d: "M727.737 642.546L721.526 640.433L720.997 641.987L727.208 644.099L727.737 642.546Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1521 || (_path1521 = /*#__PURE__*/React.createElement("path", {
    d: "M746.73 650.794L740.329 648.617L739.785 650.218L746.185 652.394L746.73 650.794Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1522 || (_path1522 = /*#__PURE__*/React.createElement("path", {
    d: "M771.168 662.182L764.443 659.895L763.871 661.576L770.596 663.863L771.168 662.182Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1523 || (_path1523 = /*#__PURE__*/React.createElement("path", {
    d: "M792.535 671.377L785.611 669.022L785.021 670.755L791.946 673.11L792.535 671.377Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1524 || (_path1524 = /*#__PURE__*/React.createElement("path", {
    d: "M810.362 678.28L803.347 675.894L802.751 677.647L809.766 680.033L810.362 678.28Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1525 || (_path1525 = /*#__PURE__*/React.createElement("path", {
    d: "M825.002 683.267L817.987 680.882L817.39 682.635L824.405 685.021L825.002 683.267Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1526 || (_path1526 = /*#__PURE__*/React.createElement("path", {
    d: "M834.927 685.595L828.023 683.247L827.436 684.975L834.339 687.323L834.927 685.595Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1527 || (_path1527 = /*#__PURE__*/React.createElement("path", {
    d: "M839.091 684.835L832.413 682.564L831.845 684.235L838.523 686.506L839.091 684.835Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1528 || (_path1528 = /*#__PURE__*/React.createElement("path", {
    d: "M838.822 681.858L832.45 679.691L831.908 681.287L838.279 683.454L838.822 681.858Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1529 || (_path1529 = /*#__PURE__*/React.createElement("path", {
    d: "M837.563 678.602L831.484 676.535L830.967 678.055L837.046 680.123L837.563 678.602Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1530 || (_path1530 = /*#__PURE__*/React.createElement("path", {
    d: "M841.103 678.105L835.205 676.099L834.704 677.572L840.602 679.578L841.103 678.105Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1531 || (_path1531 = /*#__PURE__*/React.createElement("path", {
    d: "M203.936 479.222L197.691 477.098L197.16 478.66L203.405 480.784L203.936 479.222Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1532 || (_path1532 = /*#__PURE__*/React.createElement("path", {
    d: "M214.014 483.313L207.712 481.169L207.177 482.744L213.478 484.887L214.014 483.313Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1533 || (_path1533 = /*#__PURE__*/React.createElement("path", {
    d: "M221.59 487.212L215.177 485.031L214.632 486.634L221.045 488.815L221.59 487.212Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1534 || (_path1534 = /*#__PURE__*/React.createElement("path", {
    d: "M220.461 490.422L213.744 488.138L213.172 489.819L219.889 492.103L220.461 490.422Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1535 || (_path1535 = /*#__PURE__*/React.createElement("path", {
    d: "M220.969 494.091L213.957 491.706L213.36 493.46L220.373 495.845L220.969 494.091Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1536 || (_path1536 = /*#__PURE__*/React.createElement("path", {
    d: "M228.278 498.566L221.097 496.123L220.486 497.918L227.667 500.361L228.278 498.566Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1537 || (_path1537 = /*#__PURE__*/React.createElement("path", {
    d: "M233.752 503.133L226.346 500.614L225.716 502.467L233.122 504.986L233.752 503.133Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1538 || (_path1538 = /*#__PURE__*/React.createElement("path", {
    d: "M231.853 507.697L224.005 505.028L223.338 506.992L231.185 509.661L231.853 507.697Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1539 || (_path1539 = /*#__PURE__*/React.createElement("path", {
    d: "M227.876 512.804L219.479 509.948L218.765 512.047L227.163 514.903L227.876 512.804Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1540 || (_path1540 = /*#__PURE__*/React.createElement("path", {
    d: "M234.889 518.709L226.199 515.753L225.461 517.924L234.151 520.88L234.889 518.709Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1541 || (_path1541 = /*#__PURE__*/React.createElement("path", {
    d: "M256.954 524.798L248.383 521.883L247.654 524.029L256.225 526.944L256.954 524.798Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1542 || (_path1542 = /*#__PURE__*/React.createElement("path", {
    d: "M281.805 530.582L273.458 527.743L272.747 529.831L281.095 532.67L281.805 530.582Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1543 || (_path1543 = /*#__PURE__*/React.createElement("path", {
    d: "M303.023 536.236L294.81 533.442L294.111 535.497L302.324 538.29L303.023 536.236Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1544 || (_path1544 = /*#__PURE__*/React.createElement("path", {
    d: "M325.146 541.552L317.117 538.821L316.435 540.826L324.464 543.557L325.146 541.552Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1545 || (_path1545 = /*#__PURE__*/React.createElement("path", {
    d: "M346.014 546.67L338.151 543.995L337.483 545.959L345.346 548.633L346.014 546.67Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1546 || (_path1546 = /*#__PURE__*/React.createElement("path", {
    d: "M359.986 552.675L352.019 549.965L351.341 551.958L359.308 554.667L359.986 552.675Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1547 || (_path1547 = /*#__PURE__*/React.createElement("path", {
    d: "M367.949 560.344L359.565 557.493L358.852 559.589L367.237 562.44L367.949 560.344Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1548 || (_path1548 = /*#__PURE__*/React.createElement("path", {
    d: "M381.348 567.5L372.743 564.573L372.012 566.724L380.616 569.65L381.348 567.5Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1549 || (_path1549 = /*#__PURE__*/React.createElement("path", {
    d: "M403.133 572.131L394.765 569.285L394.053 571.378L402.421 574.225L403.133 572.131Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1550 || (_path1550 = /*#__PURE__*/React.createElement("path", {
    d: "M425.502 575.679L417.473 572.948L416.79 574.956L424.819 577.686L425.502 575.679Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1551 || (_path1551 = /*#__PURE__*/React.createElement("path", {
    d: "M442.13 581.427L434.094 578.693L433.411 580.701L441.447 583.435L442.13 581.427Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1552 || (_path1552 = /*#__PURE__*/React.createElement("path", {
    d: "M456.173 589.334L447.872 586.511L447.167 588.584L455.468 591.407L456.173 589.334Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1553 || (_path1553 = /*#__PURE__*/React.createElement("path", {
    d: "M473.154 595.561L464.816 592.726L464.107 594.811L472.444 597.647L473.154 595.561Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1554 || (_path1554 = /*#__PURE__*/React.createElement("path", {
    d: "M492.137 598.854L484.064 596.109L483.377 598.127L491.45 600.873L492.137 598.854Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1555 || (_path1555 = /*#__PURE__*/React.createElement("path", {
    d: "M510.253 601.106L502.511 598.473L501.853 600.408L509.594 603.041L510.253 601.106Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1556 || (_path1556 = /*#__PURE__*/React.createElement("path", {
    d: "M527.072 602.424L519.701 599.918L519.075 601.759L526.445 604.266L527.072 602.424Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1557 || (_path1557 = /*#__PURE__*/React.createElement("path", {
    d: "M542.259 599.165L535.602 596.901L535.035 598.566L541.693 600.83L542.259 599.165Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1558 || (_path1558 = /*#__PURE__*/React.createElement("path", {
    d: "M554.522 595.096L548.562 593.069L548.055 594.561L554.014 596.588L554.522 595.096Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1559 || (_path1559 = /*#__PURE__*/React.createElement("path", {
    d: "M564.86 593.009L559.37 591.142L558.904 592.514L564.394 594.382L564.86 593.009Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1560 || (_path1560 = /*#__PURE__*/React.createElement("path", {
    d: "M574.063 592.085L568.921 590.336L568.483 591.622L573.626 593.371L574.063 592.085Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1561 || (_path1561 = /*#__PURE__*/React.createElement("path", {
    d: "M583.658 593.785L578.645 592.08L578.219 593.333L583.232 595.038L583.658 593.785Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1562 || (_path1562 = /*#__PURE__*/React.createElement("path", {
    d: "M595.293 599.065L590.168 597.322L589.732 598.604L594.857 600.347L595.293 599.065Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1563 || (_path1563 = /*#__PURE__*/React.createElement("path", {
    d: "M609.161 606.754L603.785 604.925L603.328 606.269L608.704 608.098L609.161 606.754Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1564 || (_path1564 = /*#__PURE__*/React.createElement("path", {
    d: "M624.149 614.885L618.519 612.97L618.04 614.379L623.67 616.293L624.149 614.885Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1565 || (_path1565 = /*#__PURE__*/React.createElement("path", {
    d: "M639.689 622.839L633.833 620.847L633.336 622.31L639.191 624.302L639.689 622.839Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1566 || (_path1566 = /*#__PURE__*/React.createElement("path", {
    d: "M655.427 630.397L649.385 628.342L648.871 629.851L654.914 631.906L655.427 630.397Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1567 || (_path1567 = /*#__PURE__*/React.createElement("path", {
    d: "M669.38 635.906L663.273 633.829L662.754 635.354L668.861 637.432L669.38 635.906Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1568 || (_path1568 = /*#__PURE__*/React.createElement("path", {
    d: "M681.225 639.489L675.156 637.425L674.64 638.943L680.708 641.007L681.225 639.489Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1569 || (_path1569 = /*#__PURE__*/React.createElement("path", {
    d: "M691.934 642.217L685.941 640.179L685.431 641.678L691.424 643.716L691.934 642.217Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1570 || (_path1570 = /*#__PURE__*/React.createElement("path", {
    d: "M702.281 644.81L696.365 642.798L695.862 644.277L701.778 646.289L702.281 644.81Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1571 || (_path1571 = /*#__PURE__*/React.createElement("path", {
    d: "M713.828 648.425L707.939 646.422L707.438 647.893L713.328 649.896L713.828 648.425Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1572 || (_path1572 = /*#__PURE__*/React.createElement("path", {
    d: "M732.817 657.416L726.715 655.34L726.196 656.866L732.299 658.941L732.817 657.416Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1573 || (_path1573 = /*#__PURE__*/React.createElement("path", {
    d: "M757.973 670.359L751.5 668.158L750.95 669.776L757.423 671.978L757.973 670.359Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1574 || (_path1574 = /*#__PURE__*/React.createElement("path", {
    d: "M779.779 680.537L773.075 678.257L772.504 679.935L779.208 682.215L779.779 680.537Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1575 || (_path1575 = /*#__PURE__*/React.createElement("path", {
    d: "M796.849 687.318L790.06 685.009L789.483 686.705L796.272 689.015L796.849 687.318Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1576 || (_path1576 = /*#__PURE__*/React.createElement("path", {
    d: "M811.13 692.213L804.338 689.903L803.761 691.599L810.552 693.909L811.13 692.213Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1577 || (_path1577 = /*#__PURE__*/React.createElement("path", {
    d: "M822.796 695.477L816.064 693.187L815.491 694.871L822.223 697.161L822.796 695.477Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1578 || (_path1578 = /*#__PURE__*/React.createElement("path", {
    d: "M829.644 695.879L823.075 693.645L822.517 695.287L829.086 697.521L829.644 695.879Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1579 || (_path1579 = /*#__PURE__*/React.createElement("path", {
    d: "M830.54 692.896L824.249 690.756L823.714 692.328L830.005 694.468L830.54 692.896Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1580 || (_path1580 = /*#__PURE__*/React.createElement("path", {
    d: "M828.203 688.301L822.233 686.27L821.725 687.765L827.694 689.795L828.203 688.301Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1581 || (_path1581 = /*#__PURE__*/React.createElement("path", {
    d: "M831.227 687.115L825.444 685.149L824.952 686.593L830.736 688.56L831.227 687.115Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1582 || (_path1582 = /*#__PURE__*/React.createElement("path", {
    d: "M185.067 491.061L178.555 488.846L178.002 490.472L184.514 492.687L185.067 491.061Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1583 || (_path1583 = /*#__PURE__*/React.createElement("path", {
    d: "M191.64 495.178L184.999 492.919L184.434 494.579L191.076 496.838L191.64 495.178Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1584 || (_path1584 = /*#__PURE__*/React.createElement("path", {
    d: "M201.503 499.646L194.784 497.361L194.212 499.042L200.931 501.327L201.503 499.646Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1585 || (_path1585 = /*#__PURE__*/React.createElement("path", {
    d: "M209.408 504.118L202.562 501.79L201.979 503.504L208.825 505.833L209.408 504.118Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1586 || (_path1586 = /*#__PURE__*/React.createElement("path", {
    d: "M216.447 508.723L209.442 506.341L208.848 508.089L215.852 510.471L216.447 508.723Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1587 || (_path1587 = /*#__PURE__*/React.createElement("path", {
    d: "M222.654 513.511L215.462 511.065L214.851 512.863L222.042 515.309L222.654 513.511Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1588 || (_path1588 = /*#__PURE__*/React.createElement("path", {
    d: "M224.694 518.555L217.194 516.004L216.556 517.88L224.056 520.43L224.694 518.555Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1589 || (_path1589 = /*#__PURE__*/React.createElement("path", {
    d: "M223.618 524.09L215.701 521.397L215.028 523.377L222.945 526.069L223.618 524.09Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1590 || (_path1590 = /*#__PURE__*/React.createElement("path", {
    d: "M225.984 530.159L217.695 527.34L216.99 529.413L225.279 532.232L225.984 530.159Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1591 || (_path1591 = /*#__PURE__*/React.createElement("path", {
    d: "M238.038 536.317L229.607 533.449L228.89 535.558L237.321 538.426L238.038 536.317Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1592 || (_path1592 = /*#__PURE__*/React.createElement("path", {
    d: "M260.903 541.874L252.628 539.059L251.924 541.129L260.199 543.944L260.903 541.874Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1593 || (_path1593 = /*#__PURE__*/React.createElement("path", {
    d: "M287.047 546.792L279.051 544.073L278.371 546.073L286.366 548.792L287.047 546.792Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1594 || (_path1594 = /*#__PURE__*/React.createElement("path", {
    d: "M309.111 551.718L301.297 549.06L300.634 551.011L308.448 553.669L309.111 551.718Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1595 || (_path1595 = /*#__PURE__*/React.createElement("path", {
    d: "M326.565 557.046L318.793 554.403L318.132 556.346L325.904 558.989L326.565 557.046Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1596 || (_path1596 = /*#__PURE__*/React.createElement("path", {
    d: "M342.31 562.647L334.522 559.999L333.86 561.944L341.648 564.593L342.31 562.647Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1597 || (_path1597 = /*#__PURE__*/React.createElement("path", {
    d: "M357.76 568.371L349.939 565.711L349.274 567.664L357.096 570.325L357.76 568.371Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1598 || (_path1598 = /*#__PURE__*/React.createElement("path", {
    d: "M371.583 574.714L363.645 572.014L362.969 574.001L370.907 576.701L371.583 574.714Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1599 || (_path1599 = /*#__PURE__*/React.createElement("path", {
    d: "M386.75 580.879L378.742 578.156L378.062 580.156L386.07 582.879L386.75 580.879Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1600 || (_path1600 = /*#__PURE__*/React.createElement("path", {
    d: "M405.798 585.401L397.928 582.724L397.258 584.693L405.129 587.37L405.798 585.401Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1601 || (_path1601 = /*#__PURE__*/React.createElement("path", {
    d: "M425.26 589.141L417.594 586.534L416.943 588.448L424.609 591.055L425.26 589.141Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1602 || (_path1602 = /*#__PURE__*/React.createElement("path", {
    d: "M441.25 594.556L433.584 591.949L432.931 593.868L440.597 596.476L441.25 594.556Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1603 || (_path1603 = /*#__PURE__*/React.createElement("path", {
    d: "M455.879 601.265L448.094 598.618L447.432 600.563L455.217 603.211L455.879 601.265Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1604 || (_path1604 = /*#__PURE__*/React.createElement("path", {
    d: "M472.26 606.585L464.491 603.943L463.83 605.886L471.599 608.528L472.26 606.585Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1605 || (_path1605 = /*#__PURE__*/React.createElement("path", {
    d: "M489.951 609.439L482.407 606.873L481.766 608.759L489.31 611.325L489.951 609.439Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1606 || (_path1606 = /*#__PURE__*/React.createElement("path", {
    d: "M507.103 610.92L499.865 608.458L499.249 610.269L506.487 612.73L507.103 610.92Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1607 || (_path1607 = /*#__PURE__*/React.createElement("path", {
    d: "M523.056 611.527L516.157 609.18L515.571 610.905L522.469 613.252L523.056 611.527Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1608 || (_path1608 = /*#__PURE__*/React.createElement("path", {
    d: "M537.685 608.94L531.32 606.775L530.78 608.365L537.144 610.53L537.685 608.94Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1609 || (_path1609 = /*#__PURE__*/React.createElement("path", {
    d: "M550.073 605.463L544.251 603.483L543.756 604.939L549.578 606.919L550.073 605.463Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1610 || (_path1610 = /*#__PURE__*/React.createElement("path", {
    d: "M560.546 602.676L555.172 600.848L554.715 602.192L560.089 604.019L560.546 602.676Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1611 || (_path1611 = /*#__PURE__*/React.createElement("path", {
    d: "M569.733 600.886L564.707 599.177L564.28 600.432L569.306 602.142L569.733 600.886Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1612 || (_path1612 = /*#__PURE__*/React.createElement("path", {
    d: "M579.073 602.034L574.192 600.374L573.777 601.596L578.657 603.256L579.073 602.034Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1613 || (_path1613 = /*#__PURE__*/React.createElement("path", {
    d: "M589.803 606.477L584.868 604.798L584.448 606.033L589.384 607.711L589.803 606.477Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1614 || (_path1614 = /*#__PURE__*/React.createElement("path", {
    d: "M602.107 613.032L597.001 611.295L596.566 612.574L601.672 614.311L602.107 613.032Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1615 || (_path1615 = /*#__PURE__*/React.createElement("path", {
    d: "M615.442 620.282L610.144 618.48L609.693 619.805L614.991 621.607L615.442 620.282Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1616 || (_path1616 = /*#__PURE__*/React.createElement("path", {
    d: "M629.799 628.065L624.296 626.193L623.828 627.568L629.331 629.439L629.799 628.065Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1617 || (_path1617 = /*#__PURE__*/React.createElement("path", {
    d: "M644.304 635.36L638.635 633.432L638.153 634.848L643.822 636.776L644.304 635.36Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1618 || (_path1618 = /*#__PURE__*/React.createElement("path", {
    d: "M657.713 641.038L651.967 639.083L651.478 640.52L657.225 642.475L657.713 641.038Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1619 || (_path1619 = /*#__PURE__*/React.createElement("path", {
    d: "M669.517 644.945L663.781 642.994L663.293 644.429L669.029 646.38L669.517 644.945Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1620 || (_path1620 = /*#__PURE__*/React.createElement("path", {
    d: "M680.093 647.741L674.411 645.808L673.928 647.23L679.61 649.162L680.093 647.741Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1621 || (_path1621 = /*#__PURE__*/React.createElement("path", {
    d: "M691.484 651.374L685.817 649.447L685.336 650.864L691.002 652.791L691.484 651.374Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1622 || (_path1622 = /*#__PURE__*/React.createElement("path", {
    d: "M703.344 655.44L697.675 653.512L697.193 654.928L702.862 656.856L703.344 655.44Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1623 || (_path1623 = /*#__PURE__*/React.createElement("path", {
    d: "M718.283 661.962L712.513 660L712.022 661.442L717.792 663.405L718.283 661.962Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1624 || (_path1624 = /*#__PURE__*/React.createElement("path", {
    d: "M737.531 671.62L731.541 669.583L731.031 671.082L737.021 673.12L737.531 671.62Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1625 || (_path1625 = /*#__PURE__*/React.createElement("path", {
    d: "M758.569 682.245L752.332 680.124L751.801 681.683L758.038 683.804L758.569 682.245Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1626 || (_path1626 = /*#__PURE__*/React.createElement("path", {
    d: "M778.782 691.881L772.353 689.695L771.806 691.303L778.235 693.49L778.782 691.881Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1627 || (_path1627 = /*#__PURE__*/React.createElement("path", {
    d: "M795.715 698.923L789.192 696.704L788.638 698.333L795.16 700.552L795.715 698.923Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1628 || (_path1628 = /*#__PURE__*/React.createElement("path", {
    d: "M810.284 704.217L803.741 701.991L803.186 703.626L809.729 705.851L810.284 704.217Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1629 || (_path1629 = /*#__PURE__*/React.createElement("path", {
    d: "M822.102 707.642L815.6 705.431L815.047 707.058L821.548 709.269L822.102 707.642Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1630 || (_path1630 = /*#__PURE__*/React.createElement("path", {
    d: "M826.65 706.374L820.343 704.228L819.807 705.806L826.114 707.951L826.65 706.374Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1631 || (_path1631 = /*#__PURE__*/React.createElement("path", {
    d: "M826.427 702.318L820.402 700.269L819.89 701.776L825.914 703.825L826.427 702.318Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1632 || (_path1632 = /*#__PURE__*/React.createElement("path", {
    d: "M831.103 701.654L825.239 699.66L824.741 701.125L830.604 703.12L831.103 701.654Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1633 || (_path1633 = /*#__PURE__*/React.createElement("path", {
    d: "M159.347 503.73L152.457 501.386L151.87 503.111L158.76 505.455L159.347 503.73Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1634 || (_path1634 = /*#__PURE__*/React.createElement("path", {
    d: "M163.872 508.308L156.797 505.902L156.196 507.671L163.27 510.077L163.872 508.308Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1635 || (_path1635 = /*#__PURE__*/React.createElement("path", {
    d: "M177.496 513.303L170.401 510.89L169.797 512.664L176.892 515.078L177.496 513.303Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1636 || (_path1636 = /*#__PURE__*/React.createElement("path", {
    d: "M195.513 518.346L188.483 515.955L187.885 517.713L194.915 520.105L195.513 518.346Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1637 || (_path1637 = /*#__PURE__*/React.createElement("path", {
    d: "M209.955 523.327L202.919 520.934L202.32 522.696L209.356 525.089L209.955 523.327Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1638 || (_path1638 = /*#__PURE__*/React.createElement("path", {
    d: "M216.072 528.542L208.847 526.085L208.233 527.89L215.458 530.347L216.072 528.542Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1639 || (_path1639 = /*#__PURE__*/React.createElement("path", {
    d: "M215.976 534.335L208.398 531.758L207.754 533.652L215.332 536.229L215.976 534.335Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1640 || (_path1640 = /*#__PURE__*/React.createElement("path", {
    d: "M216.81 540.662L208.867 537.96L208.191 539.947L216.134 542.649L216.81 540.662Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1641 || (_path1641 = /*#__PURE__*/React.createElement("path", {
    d: "M226.073 546.918L217.938 544.151L217.246 546.187L225.381 548.954L226.073 546.918Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1642 || (_path1642 = /*#__PURE__*/React.createElement("path", {
    d: "M243.27 552.657L235.142 549.892L234.45 551.926L242.578 554.69L243.27 552.657Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1643 || (_path1643 = /*#__PURE__*/React.createElement("path", {
    d: "M266.98 557.48L259.05 554.782L258.375 556.767L266.305 559.464L266.98 557.48Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1644 || (_path1644 = /*#__PURE__*/React.createElement("path", {
    d: "M294.942 561.178L287.364 558.601L286.72 560.495L294.298 563.072L294.942 561.178Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1645 || (_path1645 = /*#__PURE__*/React.createElement("path", {
    d: "M318.563 564.955L311.242 562.465L310.619 564.297L317.94 566.787L318.563 564.955Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1646 || (_path1646 = /*#__PURE__*/React.createElement("path", {
    d: "M331.935 570.597L324.55 568.085L323.921 569.932L331.307 572.444L331.935 570.597Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1647 || (_path1647 = /*#__PURE__*/React.createElement("path", {
    d: "M342.655 577.183L335.092 574.611L334.449 576.503L342.011 579.075L342.655 577.183Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1648 || (_path1648 = /*#__PURE__*/React.createElement("path", {
    d: "M359.13 582.292L351.594 579.729L350.954 581.612L358.49 584.176L359.13 582.292Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1649 || (_path1649 = /*#__PURE__*/React.createElement("path", {
    d: "M378.402 586.175L371.029 583.668L370.402 585.509L377.775 588.017L378.402 586.175Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1650 || (_path1650 = /*#__PURE__*/React.createElement("path", {
    d: "M395.076 590.752L387.773 588.269L387.152 590.095L394.454 592.579L395.076 590.752Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1651 || (_path1651 = /*#__PURE__*/React.createElement("path", {
    d: "M411.166 595.421L403.913 592.954L403.295 594.769L410.548 597.236L411.166 595.421Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1652 || (_path1652 = /*#__PURE__*/React.createElement("path", {
    d: "M427.46 599.738L420.276 597.295L419.666 599.09L426.849 601.533L427.46 599.738Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1653 || (_path1653 = /*#__PURE__*/React.createElement("path", {
    d: "M442.499 604.757L435.323 602.317L434.714 604.109L441.889 606.55L442.499 604.757Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1654 || (_path1654 = /*#__PURE__*/React.createElement("path", {
    d: "M457.203 610.109L450.006 607.661L449.394 609.461L456.59 611.909L457.203 610.109Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1655 || (_path1655 = /*#__PURE__*/React.createElement("path", {
    d: "M472.388 614.946L465.209 612.505L464.6 614.297L471.778 616.739L472.388 614.946Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1656 || (_path1656 = /*#__PURE__*/React.createElement("path", {
    d: "M488.309 618.217L481.26 615.819L480.66 617.583L487.709 619.981L488.309 618.217Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1657 || (_path1657 = /*#__PURE__*/React.createElement("path", {
    d: "M504.302 619.622L497.5 617.308L496.922 619.008L503.724 621.321L504.302 619.622Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1658 || (_path1658 = /*#__PURE__*/React.createElement("path", {
    d: "M519.428 619.971L512.917 617.756L512.362 619.385L518.874 621.6L519.428 619.971Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1659 || (_path1659 = /*#__PURE__*/React.createElement("path", {
    d: "M533.396 619.176L527.221 617.076L526.696 618.62L532.871 620.72L533.396 619.176Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1660 || (_path1660 = /*#__PURE__*/React.createElement("path", {
    d: "M545.943 617.511L540.126 615.532L539.632 616.988L545.448 618.966L545.943 617.511Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1661 || (_path1661 = /*#__PURE__*/React.createElement("path", {
    d: "M556.917 614.919L551.484 613.072L551.022 614.428L556.455 616.276L556.917 614.919Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1662 || (_path1662 = /*#__PURE__*/React.createElement("path", {
    d: "M566.588 612.846L561.482 611.109L561.047 612.388L566.153 614.125L566.588 612.846Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1663 || (_path1663 = /*#__PURE__*/React.createElement("path", {
    d: "M576.157 613.626L571.199 611.94L570.778 613.177L575.736 614.864L576.157 613.626Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1664 || (_path1664 = /*#__PURE__*/React.createElement("path", {
    d: "M586.225 616.599L581.297 614.923L580.878 616.155L585.806 617.831L586.225 616.599Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1665 || (_path1665 = /*#__PURE__*/React.createElement("path", {
    d: "M596.826 620.682L591.868 618.995L591.446 620.235L596.404 621.922L596.826 620.682Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1666 || (_path1666 = /*#__PURE__*/React.createElement("path", {
    d: "M607.938 625.422L602.923 623.717L602.497 624.969L607.512 626.675L607.938 625.422Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1667 || (_path1667 = /*#__PURE__*/React.createElement("path", {
    d: "M620.314 631.681L615.174 629.932L614.737 631.219L619.877 632.967L620.314 631.681Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1668 || (_path1668 = /*#__PURE__*/React.createElement("path", {
    d: "M632.984 637.83L627.733 636.044L627.286 637.357L632.538 639.143L632.984 637.83Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1669 || (_path1669 = /*#__PURE__*/React.createElement("path", {
    d: "M645.354 643.239L640.027 641.427L639.574 642.76L644.9 644.572L645.354 643.239Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1670 || (_path1670 = /*#__PURE__*/React.createElement("path", {
    d: "M656.728 647.321L651.388 645.505L650.934 646.841L656.273 648.657L656.728 647.321Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1671 || (_path1671 = /*#__PURE__*/React.createElement("path", {
    d: "M666.944 650.171L661.646 648.369L661.195 649.695L666.493 651.497L666.944 650.171Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1672 || (_path1672 = /*#__PURE__*/React.createElement("path", {
    d: "M679.092 655.006L673.747 653.188L673.293 654.524L678.638 656.342L679.092 655.006Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1673 || (_path1673 = /*#__PURE__*/React.createElement("path", {
    d: "M691.048 659.555L685.674 657.728L685.217 659.072L690.591 660.899L691.048 659.555Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1674 || (_path1674 = /*#__PURE__*/React.createElement("path", {
    d: "M702.208 663.331L696.835 661.503L696.378 662.847L701.751 664.675L702.208 663.331Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1675 || (_path1675 = /*#__PURE__*/React.createElement("path", {
    d: "M716.075 669.422L710.619 667.566L710.156 668.928L715.612 670.784L716.075 669.422Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1676 || (_path1676 = /*#__PURE__*/React.createElement("path", {
    d: "M736.416 680.667L730.7 678.723L730.215 680.15L735.931 682.094L736.416 680.667Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1677 || (_path1677 = /*#__PURE__*/React.createElement("path", {
    d: "M759.597 693.665L753.568 691.615L753.055 693.122L759.085 695.173L759.597 693.665Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1678 || (_path1678 = /*#__PURE__*/React.createElement("path", {
    d: "M779.26 703.407L773.049 701.294L772.52 702.848L778.731 704.96L779.26 703.407Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1679 || (_path1679 = /*#__PURE__*/React.createElement("path", {
    d: "M797.205 711.544L790.87 709.39L790.331 710.975L796.666 713.129L797.205 711.544Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1680 || (_path1680 = /*#__PURE__*/React.createElement("path", {
    d: "M814.788 719.226L808.349 717.036L807.801 718.647L814.24 720.837L814.788 719.226Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1681 || (_path1681 = /*#__PURE__*/React.createElement("path", {
    d: "M824.19 720.939L817.839 718.779L817.299 720.367L823.65 722.527L824.19 720.939Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1682 || (_path1682 = /*#__PURE__*/React.createElement("path", {
    d: "M827.235 718.378L821.101 716.291L820.58 717.825L826.713 719.911L827.235 718.378Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1683 || (_path1683 = /*#__PURE__*/React.createElement("path", {
    d: "M834.099 718.721L828.088 716.677L827.576 718.181L833.588 720.226L834.099 718.721Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1684 || (_path1684 = /*#__PURE__*/React.createElement("path", {
    d: "M129.719 517.972L122.388 515.479L121.765 517.31L129.096 519.804L129.719 517.972Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1685 || (_path1685 = /*#__PURE__*/React.createElement("path", {
    d: "M141.378 523.2L133.979 520.683L133.35 522.533L140.749 525.049L141.378 523.2Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1686 || (_path1686 = /*#__PURE__*/React.createElement("path", {
    d: "M159.889 528.373L152.55 525.876L151.926 527.711L159.265 530.207L159.889 528.373Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1687 || (_path1687 = /*#__PURE__*/React.createElement("path", {
    d: "M180.856 533.359L173.631 530.902L173.017 532.707L180.242 535.165L180.856 533.359Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1688 || (_path1688 = /*#__PURE__*/React.createElement("path", {
    d: "M197.971 538.367L190.79 535.925L190.18 537.72L197.361 540.162L197.971 538.367Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1689 || (_path1689 = /*#__PURE__*/React.createElement("path", {
    d: "M206.601 543.907L199.28 541.417L198.657 543.249L205.978 545.739L206.601 543.907Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1690 || (_path1690 = /*#__PURE__*/React.createElement("path", {
    d: "M208.751 550.296L201.132 547.705L200.484 549.609L208.103 552.2L208.751 550.296Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1691 || (_path1691 = /*#__PURE__*/React.createElement("path", {
    d: "M212.696 557.047L204.791 554.359L204.119 556.335L212.023 559.024L212.696 557.047Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1692 || (_path1692 = /*#__PURE__*/React.createElement("path", {
    d: "M225.266 563.183L217.26 560.461L216.579 562.463L224.585 565.186L225.266 563.183Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1693 || (_path1693 = /*#__PURE__*/React.createElement("path", {
    d: "M244.479 568.445L236.538 565.744L235.863 567.731L243.803 570.432L244.479 568.445Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1694 || (_path1694 = /*#__PURE__*/React.createElement("path", {
    d: "M269.365 572.458L261.663 569.838L261.008 571.766L268.71 574.385L269.365 572.458Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1695 || (_path1695 = /*#__PURE__*/React.createElement("path", {
    d: "M299.896 574.617L292.63 572.145L292.011 573.964L299.278 576.435L299.896 574.617Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1696 || (_path1696 = /*#__PURE__*/React.createElement("path", {
    d: "M325.842 576.9L318.923 574.547L318.335 576.277L325.254 578.631L325.842 576.9Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1697 || (_path1697 = /*#__PURE__*/React.createElement("path", {
    d: "M340.482 581.732L333.571 579.382L332.984 581.109L339.895 583.46L340.482 581.732Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1698 || (_path1698 = /*#__PURE__*/React.createElement("path", {
    d: "M351.147 587.967L344.096 585.569L343.496 587.333L350.548 589.731L351.147 587.967Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1699 || (_path1699 = /*#__PURE__*/React.createElement("path", {
    d: "M366.365 592.743L359.337 590.353L358.739 592.112L365.767 594.502L366.365 592.743Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1700 || (_path1700 = /*#__PURE__*/React.createElement("path", {
    d: "M383.954 596.28L377.056 593.934L376.469 595.659L383.367 598.005L383.954 596.28Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1701 || (_path1701 = /*#__PURE__*/React.createElement("path", {
    d: "M399.452 600.521L392.611 598.194L392.029 599.906L398.87 602.233L399.452 600.521Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1702 || (_path1702 = /*#__PURE__*/React.createElement("path", {
    d: "M414.278 604.987L407.467 602.671L406.888 604.376L413.698 606.692L414.278 604.987Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1703 || (_path1703 = /*#__PURE__*/React.createElement("path", {
    d: "M429.211 609.221L422.445 606.92L421.87 608.612L428.635 610.913L429.211 609.221Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1704 || (_path1704 = /*#__PURE__*/React.createElement("path", {
    d: "M443.393 613.938L436.632 611.638L436.057 613.33L442.817 615.629L443.393 613.938Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1705 || (_path1705 = /*#__PURE__*/React.createElement("path", {
    d: "M457.277 618.967L450.498 616.661L449.922 618.355L456.701 620.661L457.277 618.967Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1706 || (_path1706 = /*#__PURE__*/React.createElement("path", {
    d: "M470.913 624.49L464.089 622.17L463.508 623.879L470.331 626.2L470.913 624.49Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1707 || (_path1707 = /*#__PURE__*/React.createElement("path", {
    d: "M485.062 629.462L478.226 627.137L477.645 628.846L484.481 631.171L485.062 629.462Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1708 || (_path1708 = /*#__PURE__*/React.createElement("path", {
    d: "M500.025 632.299L493.311 630.016L492.74 631.694L499.454 633.978L500.025 632.299Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1709 || (_path1709 = /*#__PURE__*/React.createElement("path", {
    d: "M514.928 633.041L508.445 630.836L507.893 632.458L514.377 634.663L514.928 633.041Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1710 || (_path1710 = /*#__PURE__*/React.createElement("path", {
    d: "M528.847 633.672L522.582 631.541L522.049 633.107L528.315 635.238L528.847 633.672Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1711 || (_path1711 = /*#__PURE__*/React.createElement("path", {
    d: "M541.864 633.749L535.83 631.697L535.316 633.206L541.351 635.259L541.864 633.749Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1712 || (_path1712 = /*#__PURE__*/React.createElement("path", {
    d: "M553.7 631.726L547.987 629.783L547.502 631.209L553.215 633.152L553.7 631.726Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1713 || (_path1713 = /*#__PURE__*/React.createElement("path", {
    d: "M564.167 629.084L558.783 627.253L558.326 628.599L563.709 630.43L564.167 629.084Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1714 || (_path1714 = /*#__PURE__*/React.createElement("path", {
    d: "M574.342 629.503L569.119 627.726L568.675 629.034L573.898 630.81L574.342 629.503Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1715 || (_path1715 = /*#__PURE__*/React.createElement("path", {
    d: "M584.711 631.903L579.551 630.148L579.111 631.44L584.272 633.195L584.711 631.903Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1716 || (_path1716 = /*#__PURE__*/React.createElement("path", {
    d: "M594.673 633.902L589.588 632.173L589.154 633.446L594.24 635.176L594.673 633.902Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1717 || (_path1717 = /*#__PURE__*/React.createElement("path", {
    d: "M603.422 634.126L598.479 632.444L598.058 633.682L603.001 635.363L603.422 634.126Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1718 || (_path1718 = /*#__PURE__*/React.createElement("path", {
    d: "M612.092 635.014L607.258 633.37L606.848 634.576L611.682 636.22L612.092 635.014Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1719 || (_path1719 = /*#__PURE__*/React.createElement("path", {
    d: "M621.863 638.007L617.05 636.37L616.64 637.574L621.454 639.211L621.863 638.007Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1720 || (_path1720 = /*#__PURE__*/React.createElement("path", {
    d: "M631.779 641.264L626.971 639.629L626.562 640.83L631.37 642.465L631.779 641.264Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1721 || (_path1721 = /*#__PURE__*/React.createElement("path", {
    d: "M640.922 643.595L636.158 641.975L635.753 643.165L640.517 644.786L640.922 643.595Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1722 || (_path1722 = /*#__PURE__*/React.createElement("path", {
    d: "M649.546 645.469L644.836 643.867L644.436 645.045L649.145 646.647L649.546 645.469Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1723 || (_path1723 = /*#__PURE__*/React.createElement("path", {
    d: "M659.909 649.402L655.176 647.792L654.774 648.975L659.506 650.585L659.909 649.402Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1724 || (_path1724 = /*#__PURE__*/React.createElement("path", {
    d: "M670.337 653.339L665.586 651.723L665.182 652.911L669.933 654.527L670.337 653.339Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1725 || (_path1725 = /*#__PURE__*/React.createElement("path", {
    d: "M682.121 658.563L677.305 656.925L676.896 658.128L681.712 659.766L682.121 658.563Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1726 || (_path1726 = /*#__PURE__*/React.createElement("path", {
    d: "M697.926 667.388L692.926 665.688L692.502 666.935L697.502 668.636L697.926 667.388Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1727 || (_path1727 = /*#__PURE__*/React.createElement("path", {
    d: "M718.331 679.931L713.033 678.129L712.582 679.455L717.88 681.257L718.331 679.931Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1728 || (_path1728 = /*#__PURE__*/React.createElement("path", {
    d: "M740.331 693.205L734.727 691.299L734.25 692.702L739.854 694.608L740.331 693.205Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1729 || (_path1729 = /*#__PURE__*/React.createElement("path", {
    d: "M760.058 703.931L754.238 701.952L753.743 703.407L759.563 705.387L760.058 703.931Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1730 || (_path1730 = /*#__PURE__*/React.createElement("path", {
    d: "M780.255 714.618L774.231 712.569L773.719 714.074L779.744 716.123L780.255 714.618Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1731 || (_path1731 = /*#__PURE__*/React.createElement("path", {
    d: "M801.354 725.641L795.128 723.523L794.598 725.079L800.825 727.197L801.354 725.641Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1732 || (_path1732 = /*#__PURE__*/React.createElement("path", {
    d: "M815.341 730.829L809.091 728.703L808.559 730.268L814.809 732.393L815.341 730.829Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1733 || (_path1733 = /*#__PURE__*/React.createElement("path", {
    d: "M822.384 730.785L816.266 728.704L815.747 730.232L821.864 732.313L822.384 730.785Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1734 || (_path1734 = /*#__PURE__*/React.createElement("path", {
    d: "M831.877 732.74L825.827 730.682L825.313 732.195L831.363 734.252L831.877 732.74Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1735 || (_path1735 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4817 534.087L90.6913 531.438L90.0287 533.386L97.8191 536.035L98.4817 534.087Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1736 || (_path1736 = /*#__PURE__*/React.createElement("path", {
    d: "M124.406 539.157L116.795 536.568L116.147 538.472L123.758 541.061L124.406 539.157Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1737 || (_path1737 = /*#__PURE__*/React.createElement("path", {
    d: "M148.337 544.055L140.879 541.518L140.245 543.383L147.703 545.92L148.337 544.055Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1738 || (_path1738 = /*#__PURE__*/React.createElement("path", {
    d: "M168.469 548.98L161.104 546.475L160.477 548.319L167.842 550.824L168.469 548.98Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1739 || (_path1739 = /*#__PURE__*/React.createElement("path", {
    d: "M185.886 554.001L178.56 551.509L177.937 553.341L185.263 555.832L185.886 554.001Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1740 || (_path1740 = /*#__PURE__*/React.createElement("path", {
    d: "M196.344 559.748L188.914 557.221L188.282 559.079L195.712 561.606L196.344 559.748Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1741 || (_path1741 = /*#__PURE__*/React.createElement("path", {
    d: "M198.879 566.79L191.159 564.164L190.502 566.097L198.222 568.722L198.879 566.79Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1742 || (_path1742 = /*#__PURE__*/React.createElement("path", {
    d: "M205.442 573.788L197.496 571.086L196.819 573.076L204.765 575.778L205.442 573.788Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1743 || (_path1743 = /*#__PURE__*/React.createElement("path", {
    d: "M221.781 579.462L213.83 576.757L213.153 578.747L221.104 581.451L221.781 579.462Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1744 || (_path1744 = /*#__PURE__*/React.createElement("path", {
    d: "M243.482 583.992L235.663 581.332L234.999 583.286L242.818 585.945L243.482 583.992Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1745 || (_path1745 = /*#__PURE__*/React.createElement("path", {
    d: "M269.908 587.017L262.372 584.454L261.73 586.34L269.266 588.903L269.908 587.017Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1746 || (_path1746 = /*#__PURE__*/React.createElement("path", {
    d: "M303.616 587.244L296.611 584.862L296.016 586.613L303.02 588.995L303.616 587.244Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1747 || (_path1747 = /*#__PURE__*/React.createElement("path", {
    d: "M331.699 587.821L325.12 585.583L324.56 587.228L331.14 589.466L331.699 587.821Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1748 || (_path1748 = /*#__PURE__*/React.createElement("path", {
    d: "M347.852 591.573L341.356 589.363L340.804 590.987L347.3 593.196L347.852 591.573Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1749 || (_path1749 = /*#__PURE__*/React.createElement("path", {
    d: "M358.972 597.204L352.387 594.964L351.828 596.609L358.412 598.849L358.972 597.204Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1750 || (_path1750 = /*#__PURE__*/React.createElement("path", {
    d: "M372.262 602.074L365.662 599.83L365.101 601.479L371.701 603.724L372.262 602.074Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1751 || (_path1751 = /*#__PURE__*/React.createElement("path", {
    d: "M385.842 606.85L379.234 604.602L378.672 606.254L385.28 608.502L385.842 606.85Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1752 || (_path1752 = /*#__PURE__*/React.createElement("path", {
    d: "M399.387 611.679L392.769 609.428L392.205 611.086L398.823 613.337L399.387 611.679Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1753 || (_path1753 = /*#__PURE__*/React.createElement("path", {
    d: "M412.722 616.707L406.08 614.448L405.515 616.11L412.156 618.369L412.722 616.707Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1754 || (_path1754 = /*#__PURE__*/React.createElement("path", {
    d: "M426.04 621.879L419.365 619.608L418.798 621.276L425.473 623.547L426.04 621.879Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1755 || (_path1755 = /*#__PURE__*/React.createElement("path", {
    d: "M440.297 626.23L433.65 623.969L433.085 625.632L439.731 627.893L440.297 626.23Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1756 || (_path1756 = /*#__PURE__*/React.createElement("path", {
    d: "M455.679 628.981L449.147 626.759L448.592 628.391L455.124 630.613L455.679 628.981Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1757 || (_path1757 = /*#__PURE__*/React.createElement("path", {
    d: "M469.035 634.001L462.481 631.772L461.924 633.412L468.477 635.641L469.035 634.001Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1758 || (_path1758 = /*#__PURE__*/React.createElement("path", {
    d: "M481.273 641.547L474.559 639.264L473.988 640.942L480.702 643.225L481.273 641.547Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1759 || (_path1759 = /*#__PURE__*/React.createElement("path", {
    d: "M494.906 647.292L488.14 644.991L487.564 646.682L494.33 648.983L494.906 647.292Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1760 || (_path1760 = /*#__PURE__*/React.createElement("path", {
    d: "M509.685 649.257L503.061 647.004L502.498 648.662L509.121 650.914L509.685 649.257Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1761 || (_path1761 = /*#__PURE__*/React.createElement("path", {
    d: "M523.574 653.217L516.99 650.977L516.43 652.622L523.015 654.861L523.574 653.217Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1762 || (_path1762 = /*#__PURE__*/React.createElement("path", {
    d: "M537.324 656.55L530.801 654.332L530.247 655.961L536.77 658.179L537.324 656.55Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1763 || (_path1763 = /*#__PURE__*/React.createElement("path", {
    d: "M550.412 654.18L544.211 652.071L543.684 653.623L549.884 655.731L550.412 654.18Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1764 || (_path1764 = /*#__PURE__*/React.createElement("path", {
    d: "M561.694 648.545L555.942 646.589L555.453 648.028L561.205 649.985L561.694 648.545Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1765 || (_path1765 = /*#__PURE__*/React.createElement("path", {
    d: "M572.548 648.075L566.993 646.185L566.52 647.576L572.075 649.465L572.548 648.075Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1766 || (_path1766 = /*#__PURE__*/React.createElement("path", {
    d: "M584.204 652.271L578.639 650.378L578.165 651.771L583.731 653.664L584.204 652.271Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1767 || (_path1767 = /*#__PURE__*/React.createElement("path", {
    d: "M595.105 654.488L589.609 652.619L589.143 653.991L594.638 655.86L595.105 654.488Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1768 || (_path1768 = /*#__PURE__*/React.createElement("path", {
    d: "M602.042 648.891L596.923 647.15L596.488 648.429L601.608 650.17L602.042 648.891Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1769 || (_path1769 = /*#__PURE__*/React.createElement("path", {
    d: "M605.944 640.057L601.307 638.48L600.914 639.637L605.551 641.214L605.944 640.057Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1770 || (_path1770 = /*#__PURE__*/React.createElement("path", {
    d: "M612.214 637.744L607.784 636.237L607.408 637.342L611.838 638.849L612.214 637.744Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1771 || (_path1771 = /*#__PURE__*/React.createElement("path", {
    d: "M618.798 636.93L614.516 635.474L614.152 636.545L618.433 638.001L618.798 636.93Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1772 || (_path1772 = /*#__PURE__*/React.createElement("path", {
    d: "M624.362 635.32L620.244 633.92L619.894 634.95L624.012 636.35L624.362 635.32Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1773 || (_path1773 = /*#__PURE__*/React.createElement("path", {
    d: "M630.436 635.028L626.432 633.666L626.092 634.667L630.096 636.029L630.436 635.028Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1774 || (_path1774 = /*#__PURE__*/React.createElement("path", {
    d: "M637.391 636.198L633.443 634.855L633.108 635.841L637.055 637.183L637.391 636.198Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1775 || (_path1775 = /*#__PURE__*/React.createElement("path", {
    d: "M645.297 638.626L641.36 637.287L641.026 638.27L644.962 639.609L645.297 638.626Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1776 || (_path1776 = /*#__PURE__*/React.createElement("path", {
    d: "M660.692 649.173L656.504 647.749L656.149 648.794L660.337 650.219L660.692 649.173Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1777 || (_path1777 = /*#__PURE__*/React.createElement("path", {
    d: "M683.4 666.517L678.758 664.938L678.364 666.097L683.006 667.676L683.4 666.517Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1778 || (_path1778 = /*#__PURE__*/React.createElement("path", {
    d: "M704.445 680.997L699.459 679.301L699.034 680.548L704.021 682.245L704.445 680.997Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1779 || (_path1779 = /*#__PURE__*/React.createElement("path", {
    d: "M722.341 691.63L717.139 689.861L716.696 691.163L721.898 692.932L722.341 691.63Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1780 || (_path1780 = /*#__PURE__*/React.createElement("path", {
    d: "M740.128 701.653L734.737 699.82L734.279 701.166L739.67 703L740.128 701.653Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1781 || (_path1781 = /*#__PURE__*/React.createElement("path", {
    d: "M762.087 714.919L756.421 712.992L755.939 714.408L761.606 716.335L762.087 714.919Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1782 || (_path1782 = /*#__PURE__*/React.createElement("path", {
    d: "M785.547 728.886L779.598 726.863L779.091 728.351L785.04 730.375L785.547 728.886Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1783 || (_path1783 = /*#__PURE__*/React.createElement("path", {
    d: "M803.083 737.368L797.014 735.304L796.498 736.822L802.567 738.886L803.083 737.368Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1784 || (_path1784 = /*#__PURE__*/React.createElement("path", {
    d: "M812.73 739.246L806.729 737.205L806.218 738.707L812.219 740.748L812.73 739.246Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1785 || (_path1785 = /*#__PURE__*/React.createElement("path", {
    d: "M823.751 742.332L817.779 740.3L817.271 741.794L823.243 743.826L823.751 742.332Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1786 || (_path1786 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1816 551.527L67.0827 548.772L66.3945 550.796L74.4934 553.55L75.1816 551.527Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1787 || (_path1787 = /*#__PURE__*/React.createElement("path", {
    d: "M107.379 555.992L99.5548 553.331L98.8896 555.287L106.714 557.948L107.379 555.992Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1788 || (_path1788 = /*#__PURE__*/React.createElement("path", {
    d: "M134.943 560.409L127.331 557.82L126.685 559.722L134.296 562.311L134.943 560.409Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1789 || (_path1789 = /*#__PURE__*/React.createElement("path", {
    d: "M156.862 565.089L149.37 562.541L148.733 564.413L156.225 566.962L156.862 565.089Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1790 || (_path1790 = /*#__PURE__*/React.createElement("path", {
    d: "M176.66 569.822L169.253 567.303L168.623 569.155L176.03 571.675L176.66 569.822Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1791 || (_path1791 = /*#__PURE__*/React.createElement("path", {
    d: "M189.766 575.438L182.311 572.902L181.676 574.767L189.132 577.303L189.766 575.438Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1792 || (_path1792 = /*#__PURE__*/React.createElement("path", {
    d: "M194.051 582.764L186.343 580.143L185.687 582.073L193.394 584.694L194.051 582.764Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1793 || (_path1793 = /*#__PURE__*/React.createElement("path", {
    d: "M202.804 589.735L194.929 587.057L194.259 589.026L202.135 591.704L202.804 589.735Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1794 || (_path1794 = /*#__PURE__*/React.createElement("path", {
    d: "M221.488 594.785L213.664 592.124L212.999 594.08L220.823 596.741L221.488 594.785Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1795 || (_path1795 = /*#__PURE__*/React.createElement("path", {
    d: "M244.643 598.504L236.997 595.904L236.347 597.816L243.992 600.416L244.643 598.504Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1796 || (_path1796 = /*#__PURE__*/React.createElement("path", {
    d: "M271.659 600.593L264.317 598.096L263.692 599.933L271.034 602.43L271.659 600.593Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1797 || (_path1797 = /*#__PURE__*/React.createElement("path", {
    d: "M306.275 599.256L299.491 596.949L298.915 598.643L305.699 600.95L306.275 599.256Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1798 || (_path1798 = /*#__PURE__*/React.createElement("path", {
    d: "M334.821 598.555L328.483 596.4L327.944 597.984L334.282 600.14L334.821 598.555Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1799 || (_path1799 = /*#__PURE__*/React.createElement("path", {
    d: "M351.228 601.664L344.997 599.544L344.466 601.103L350.698 603.223L351.228 601.664Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1800 || (_path1800 = /*#__PURE__*/React.createElement("path", {
    d: "M362.13 607.099L355.823 604.954L355.287 606.532L361.594 608.677L362.13 607.099Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1801 || (_path1801 = /*#__PURE__*/React.createElement("path", {
    d: "M374.282 612.121L367.936 609.963L367.396 611.55L373.742 613.708L374.282 612.121Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1802 || (_path1802 = /*#__PURE__*/React.createElement("path", {
    d: "M385.97 617.584L379.559 615.403L379.014 617.007L385.425 619.187L385.97 617.584Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1803 || (_path1803 = /*#__PURE__*/React.createElement("path", {
    d: "M398.407 622.786L391.96 620.594L391.411 622.207L397.858 624.4L398.407 622.786Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1804 || (_path1804 = /*#__PURE__*/React.createElement("path", {
    d: "M410.892 628.153L404.396 625.943L403.843 627.567L410.34 629.777L410.892 628.153Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1805 || (_path1805 = /*#__PURE__*/React.createElement("path", {
    d: "M423.373 633.778L416.817 631.548L416.259 633.188L422.815 635.418L423.373 633.778Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1806 || (_path1806 = /*#__PURE__*/React.createElement("path", {
    d: "M437.489 637.905L430.962 635.685L430.407 637.316L436.934 639.537L437.489 637.905Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1807 || (_path1807 = /*#__PURE__*/React.createElement("path", {
    d: "M453.269 639.547L446.9 637.381L446.357 638.976L452.726 641.143L453.269 639.547Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1808 || (_path1808 = /*#__PURE__*/React.createElement("path", {
    d: "M466.236 644.568L459.844 642.394L459.299 643.995L465.692 646.169L466.236 644.568Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1809 || (_path1809 = /*#__PURE__*/React.createElement("path", {
    d: "M477.327 653.83L470.696 651.575L470.132 653.233L476.763 655.488L477.327 653.83Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1810 || (_path1810 = /*#__PURE__*/React.createElement("path", {
    d: "M490.062 661.516L483.291 659.213L482.715 660.907L489.486 663.21L490.062 661.516Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1811 || (_path1811 = /*#__PURE__*/React.createElement("path", {
    d: "M504.628 664.499L497.94 662.225L497.371 663.898L504.059 666.173L504.628 664.499Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1812 || (_path1812 = /*#__PURE__*/React.createElement("path", {
    d: "M518.373 670.5L511.628 668.206L511.054 669.892L517.8 672.186L518.373 670.5Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1813 || (_path1813 = /*#__PURE__*/React.createElement("path", {
    d: "M532.402 675.7L525.641 673.4L525.066 675.092L531.827 677.391L532.402 675.7Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1814 || (_path1814 = /*#__PURE__*/React.createElement("path", {
    d: "M546.238 673.222L539.781 671.026L539.231 672.642L545.689 674.839L546.238 673.222Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1815 || (_path1815 = /*#__PURE__*/React.createElement("path", {
    d: "M558.284 666.058L552.306 664.025L551.798 665.519L557.776 667.552L558.284 666.058Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1816 || (_path1816 = /*#__PURE__*/React.createElement("path", {
    d: "M569.677 664.996L563.91 663.034L563.419 664.476L569.187 666.438L569.677 664.996Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1817 || (_path1817 = /*#__PURE__*/React.createElement("path", {
    d: "M581.806 669.497L576.025 667.531L575.533 668.979L581.313 670.945L581.806 669.497Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1818 || (_path1818 = /*#__PURE__*/React.createElement("path", {
    d: "M592.908 670.856L587.229 668.925L586.746 670.344L592.425 672.275L592.908 670.856Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1819 || (_path1819 = /*#__PURE__*/React.createElement("path", {
    d: "M599.079 661.168L593.903 659.407L593.463 660.702L598.639 662.462L599.079 661.168Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1820 || (_path1820 = /*#__PURE__*/React.createElement("path", {
    d: "M600.975 646.193L596.463 644.658L596.079 645.786L600.592 647.321L600.975 646.193Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1821 || (_path1821 = /*#__PURE__*/React.createElement("path", {
    d: "M605.127 639.626L600.957 638.207L600.603 639.248L604.773 640.666L605.127 639.626Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1822 || (_path1822 = /*#__PURE__*/React.createElement("path", {
    d: "M609.281 634.966L605.37 633.636L605.038 634.614L608.949 635.944L609.281 634.966Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1823 || (_path1823 = /*#__PURE__*/React.createElement("path", {
    d: "M612.173 629.655L608.526 628.415L608.217 629.326L611.863 630.566L612.173 629.655Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1824 || (_path1824 = /*#__PURE__*/React.createElement("path", {
    d: "M615.924 626.775L612.459 625.597L612.165 626.463L615.629 627.642L615.924 626.775Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1825 || (_path1825 = /*#__PURE__*/React.createElement("path", {
    d: "M620.524 625.755L617.168 624.614L616.882 625.454L620.238 626.596L620.524 625.755Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1826 || (_path1826 = /*#__PURE__*/React.createElement("path", {
    d: "M626.711 627.13L623.386 625.999L623.104 626.83L626.429 627.96L626.711 627.13Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1827 || (_path1827 = /*#__PURE__*/React.createElement("path", {
    d: "M642.773 640.263L639.119 639.02L638.808 639.933L642.462 641.176L642.773 640.263Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1828 || (_path1828 = /*#__PURE__*/React.createElement("path", {
    d: "M667.619 662.188L663.392 660.751L663.032 661.809L667.259 663.247L667.619 662.188Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1829 || (_path1829 = /*#__PURE__*/React.createElement("path", {
    d: "M689.18 678.838L684.556 677.265L684.163 678.419L688.787 679.992L689.18 678.838Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1830 || (_path1830 = /*#__PURE__*/React.createElement("path", {
    d: "M706.462 689.963L701.615 688.314L701.203 689.526L706.05 691.174L706.462 689.963Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1831 || (_path1831 = /*#__PURE__*/React.createElement("path", {
    d: "M724.69 701.421L719.618 699.696L719.187 700.962L724.26 702.687L724.69 701.421Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1832 || (_path1832 = /*#__PURE__*/React.createElement("path", {
    d: "M748.321 717.452L742.909 715.611L742.449 716.965L747.861 718.806L748.321 717.452Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1833 || (_path1833 = /*#__PURE__*/React.createElement("path", {
    d: "M773.507 734.084L767.748 732.125L767.257 733.568L773.017 735.527L773.507 734.084Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1834 || (_path1834 = /*#__PURE__*/React.createElement("path", {
    d: "M793.513 745.311L787.569 743.289L787.063 744.775L793.007 746.797L793.513 745.311Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1835 || (_path1835 = /*#__PURE__*/React.createElement("path", {
    d: "M805.525 749.2L799.589 747.181L799.084 748.667L805.02 750.686L805.525 749.2Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1836 || (_path1836 = /*#__PURE__*/React.createElement("path", {
    d: "M818.194 753.662L812.25 751.64L811.744 753.126L817.688 755.148L818.194 753.662Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1837 || (_path1837 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4929 568.917L56.3083 566.134L55.6122 568.18L63.7967 570.964L64.4929 568.917Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1838 || (_path1838 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5048 574.241L77.3929 571.482L76.7021 573.513L84.814 576.272L85.5048 574.241Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1839 || (_path1839 = /*#__PURE__*/React.createElement("path", {
    d: "M112.25 578.64L104.317 575.942L103.642 577.926L111.575 580.624L112.25 578.64Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1840 || (_path1840 = /*#__PURE__*/React.createElement("path", {
    d: "M141.361 582.295L133.672 579.68L133.018 581.602L140.707 584.217L141.361 582.295Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1841 || (_path1841 = /*#__PURE__*/React.createElement("path", {
    d: "M167.933 585.877L160.454 583.334L159.818 585.204L167.297 587.748L167.933 585.877Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1842 || (_path1842 = /*#__PURE__*/React.createElement("path", {
    d: "M184.828 590.912L177.377 588.377L176.743 590.243L184.193 592.777L184.828 590.912Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1843 || (_path1843 = /*#__PURE__*/React.createElement("path", {
    d: "M193.242 597.782L185.636 595.195L184.989 597.096L192.596 599.683L193.242 597.782Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1844 || (_path1844 = /*#__PURE__*/React.createElement("path", {
    d: "M205.281 604.128L197.587 601.511L196.932 603.436L204.627 606.053L205.281 604.128Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1845 || (_path1845 = /*#__PURE__*/React.createElement("path", {
    d: "M226.874 608.017L219.314 605.446L218.671 607.337L226.231 609.908L226.874 608.017Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1846 || (_path1846 = /*#__PURE__*/React.createElement("path", {
    d: "M251.665 610.533L244.333 608.039L243.71 609.873L251.041 612.367L251.665 610.533Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1847 || (_path1847 = /*#__PURE__*/React.createElement("path", {
    d: "M275.511 612.728L268.411 610.313L267.806 612.09L274.907 614.505L275.511 612.728Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1848 || (_path1848 = /*#__PURE__*/React.createElement("path", {
    d: "M301.781 613.269L295.004 610.965L294.429 612.656L301.205 614.961L301.781 613.269Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1849 || (_path1849 = /*#__PURE__*/React.createElement("path", {
    d: "M327.439 613.03L321.013 610.844L320.467 612.45L326.893 614.636L327.439 613.03Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1850 || (_path1850 = /*#__PURE__*/React.createElement("path", {
    d: "M346.81 614.655L340.578 612.535L340.048 614.094L346.28 616.214L346.81 614.655Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1851 || (_path1851 = /*#__PURE__*/React.createElement("path", {
    d: "M360.559 618.66L354.351 616.548L353.823 618.102L360.031 620.214L360.559 618.66Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1852 || (_path1852 = /*#__PURE__*/React.createElement("path", {
    d: "M373.194 623.238L366.975 621.123L366.446 622.679L372.665 624.794L373.194 623.238Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1853 || (_path1853 = /*#__PURE__*/React.createElement("path", {
    d: "M386.877 627.142L380.687 625.037L380.16 626.585L386.35 628.691L386.877 627.142Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1854 || (_path1854 = /*#__PURE__*/React.createElement("path", {
    d: "M399.639 631.633L393.444 629.526L392.917 631.075L399.113 633.182L399.639 631.633Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1855 || (_path1855 = /*#__PURE__*/React.createElement("path", {
    d: "M412.484 636.08L406.286 633.972L405.758 635.523L411.956 637.631L412.484 636.08Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1856 || (_path1856 = /*#__PURE__*/React.createElement("path", {
    d: "M425.636 640.226L419.448 638.121L418.921 639.67L425.109 641.775L425.636 640.226Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1857 || (_path1857 = /*#__PURE__*/React.createElement("path", {
    d: "M438.818 644.241L432.651 642.143L432.126 643.687L438.293 645.784L438.818 644.241Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1858 || (_path1858 = /*#__PURE__*/React.createElement("path", {
    d: "M452.426 647.521L446.311 645.441L445.791 646.971L451.906 649.051L452.426 647.521Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1859 || (_path1859 = /*#__PURE__*/React.createElement("path", {
    d: "M464.099 653.719L457.896 651.609L457.368 653.16L463.571 655.27L464.099 653.719Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1860 || (_path1860 = /*#__PURE__*/React.createElement("path", {
    d: "M474.416 663.757L467.962 661.562L467.413 663.176L473.868 665.371L474.416 663.757Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1861 || (_path1861 = /*#__PURE__*/React.createElement("path", {
    d: "M486.256 672.843L479.604 670.581L479.038 672.246L485.689 674.508L486.256 672.843Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1862 || (_path1862 = /*#__PURE__*/React.createElement("path", {
    d: "M500.365 676.591L493.754 674.343L493.192 675.998L499.802 678.246L500.365 676.591Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1863 || (_path1863 = /*#__PURE__*/React.createElement("path", {
    d: "M513.866 682.891L507.189 680.62L506.62 682.29L513.298 684.562L513.866 682.891Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1864 || (_path1864 = /*#__PURE__*/React.createElement("path", {
    d: "M527.688 688.81L520.964 686.523L520.392 688.204L527.116 690.491L527.688 688.81Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1865 || (_path1865 = /*#__PURE__*/React.createElement("path", {
    d: "M541.674 689.561L535.105 687.327L534.546 688.969L541.115 691.204L541.674 689.561Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1866 || (_path1866 = /*#__PURE__*/React.createElement("path", {
    d: "M554.8 687.549L548.482 685.4L547.945 686.98L554.262 689.128L554.8 687.549Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1867 || (_path1867 = /*#__PURE__*/React.createElement("path", {
    d: "M567.231 687.424L561.082 685.333L560.56 686.869L566.709 688.96L567.231 687.424Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1868 || (_path1868 = /*#__PURE__*/React.createElement("path", {
    d: "M578.555 685.247L572.637 683.234L572.134 684.713L578.052 686.726L578.555 685.247Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1869 || (_path1869 = /*#__PURE__*/React.createElement("path", {
    d: "M587.777 678.943L582.227 677.055L581.755 678.443L587.305 680.331L587.777 678.943Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1870 || (_path1870 = /*#__PURE__*/React.createElement("path", {
    d: "M593.654 667.073L588.644 665.369L588.217 666.622L593.228 668.326L593.654 667.073Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1871 || (_path1871 = /*#__PURE__*/React.createElement("path", {
    d: "M596.559 652.687L592.142 651.185L591.768 652.288L596.184 653.79L596.559 652.687Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1872 || (_path1872 = /*#__PURE__*/React.createElement("path", {
    d: "M600.249 644.296L596.206 642.921L595.862 643.933L599.905 645.308L600.249 644.296Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1873 || (_path1873 = /*#__PURE__*/React.createElement("path", {
    d: "M602.51 635.624L598.835 634.374L598.523 635.293L602.198 636.543L602.51 635.624Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1874 || (_path1874 = /*#__PURE__*/React.createElement("path", {
    d: "M603.222 626.394L599.915 625.269L599.635 626.094L602.941 627.219L603.222 626.394Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1875 || (_path1875 = /*#__PURE__*/React.createElement("path", {
    d: "M605.643 621.724L602.552 620.673L602.289 621.446L605.38 622.497L605.643 621.724Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1876 || (_path1876 = /*#__PURE__*/React.createElement("path", {
    d: "M611.136 622.522L608.081 621.482L607.821 622.245L610.876 623.284L611.136 622.522Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1877 || (_path1877 = /*#__PURE__*/React.createElement("path", {
    d: "M617.71 624.977L614.647 623.936L614.387 624.701L617.45 625.743L617.71 624.977Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1878 || (_path1878 = /*#__PURE__*/React.createElement("path", {
    d: "M631.645 636.877L628.307 635.742L628.023 636.577L631.361 637.712L631.645 636.877Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1879 || (_path1879 = /*#__PURE__*/React.createElement("path", {
    d: "M653.977 658.003L650.111 656.688L649.782 657.653L653.649 658.968L653.977 658.003Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1880 || (_path1880 = /*#__PURE__*/React.createElement("path", {
    d: "M676.719 677.806L672.388 676.333L672.019 677.418L676.35 678.891L676.719 677.806Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1881 || (_path1881 = /*#__PURE__*/React.createElement("path", {
    d: "M699.374 696.009L694.636 694.397L694.233 695.583L698.971 697.194L699.374 696.009Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1882 || (_path1882 = /*#__PURE__*/React.createElement("path", {
    d: "M722.2 713.167L717.096 711.431L716.662 712.707L721.766 714.443L722.2 713.167Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1883 || (_path1883 = /*#__PURE__*/React.createElement("path", {
    d: "M743.126 727.343L737.747 725.514L737.29 726.857L742.669 728.687L743.126 727.343Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1884 || (_path1884 = /*#__PURE__*/React.createElement("path", {
    d: "M761.02 737.767L755.473 735.88L755.001 737.268L760.548 739.155L761.02 737.767Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1885 || (_path1885 = /*#__PURE__*/React.createElement("path", {
    d: "M780.876 749.646L775.134 747.693L774.645 749.13L780.387 751.083L780.876 749.646Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1886 || (_path1886 = /*#__PURE__*/React.createElement("path", {
    d: "M802.465 762.638L796.503 760.61L795.995 762.105L801.957 764.132L802.465 762.638Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1887 || (_path1887 = /*#__PURE__*/React.createElement("path", {
    d: "M823.347 774.487L817.198 772.395L816.675 773.931L822.824 776.022L823.347 774.487Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1888 || (_path1888 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1301 585.777L51.9689 583.001L51.2746 585.043L59.4358 587.818L60.1301 585.777Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1889 || (_path1889 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6873 593.325L57.3265 590.481L56.6154 592.572L64.9762 595.416L65.6873 593.325Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1890 || (_path1890 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4235 598.326L80.1586 595.515L79.4554 597.582L87.7203 600.393L88.4235 598.326Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1891 || (_path1891 = /*#__PURE__*/React.createElement("path", {
    d: "M123.258 600.77L115.328 598.073L114.653 600.058L122.583 602.755L123.258 600.77Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1892 || (_path1892 = /*#__PURE__*/React.createElement("path", {
    d: "M156.114 602.863L148.508 600.276L147.861 602.178L155.468 604.765L156.114 602.863Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1893 || (_path1893 = /*#__PURE__*/React.createElement("path", {
    d: "M176.955 607.058L169.452 604.506L168.814 606.384L176.316 608.936L176.955 607.058Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1894 || (_path1894 = /*#__PURE__*/React.createElement("path", {
    d: "M190.359 612.962L182.807 610.394L182.165 612.282L189.717 614.851L190.359 612.962Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1895 || (_path1895 = /*#__PURE__*/React.createElement("path", {
    d: "M206.745 618.124L199.206 615.56L198.564 617.446L206.103 620.01L206.745 618.124Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1896 || (_path1896 = /*#__PURE__*/React.createElement("path", {
    d: "M232.17 620.298L224.864 617.813L224.243 619.639L231.549 622.124L232.17 620.298Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1897 || (_path1897 = /*#__PURE__*/React.createElement("path", {
    d: "M259.018 621.291L252 618.904L251.404 620.657L258.421 623.044L259.018 621.291Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1898 || (_path1898 = /*#__PURE__*/React.createElement("path", {
    d: "M278.97 624.141L272.095 621.802L271.51 623.522L278.385 625.861L278.97 624.141Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1899 || (_path1899 = /*#__PURE__*/React.createElement("path", {
    d: "M295.093 628.221L288.267 625.899L287.687 627.606L294.512 629.927L295.093 628.221Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1900 || (_path1900 = /*#__PURE__*/React.createElement("path", {
    d: "M316.978 629.309L310.378 627.064L309.817 628.714L316.417 630.958L316.978 629.309Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1901 || (_path1901 = /*#__PURE__*/React.createElement("path", {
    d: "M339.646 629.141L333.327 626.991L332.789 628.571L339.109 630.72L339.646 629.141Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1902 || (_path1902 = /*#__PURE__*/React.createElement("path", {
    d: "M356.798 631.209L350.61 629.104L350.083 630.653L356.271 632.757L356.798 631.209Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1903 || (_path1903 = /*#__PURE__*/React.createElement("path", {
    d: "M370.234 635.226L364.067 633.128L363.542 634.672L369.709 636.769L370.234 635.226Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1904 || (_path1904 = /*#__PURE__*/React.createElement("path", {
    d: "M386.444 637.04L380.409 634.988L379.896 636.498L385.931 638.55L386.444 637.04Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1905 || (_path1905 = /*#__PURE__*/React.createElement("path", {
    d: "M399.729 640.702L393.725 638.66L393.215 640.162L399.218 642.204L399.729 640.702Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1906 || (_path1906 = /*#__PURE__*/React.createElement("path", {
    d: "M413.156 644.065L407.196 642.038L406.689 643.53L412.649 645.556L413.156 644.065Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1907 || (_path1907 = /*#__PURE__*/React.createElement("path", {
    d: "M427.348 646.319L421.479 644.323L420.98 645.791L426.848 647.787L427.348 646.319Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1908 || (_path1908 = /*#__PURE__*/React.createElement("path", {
    d: "M439.742 650.268L433.881 648.275L433.383 649.74L439.244 651.734L439.742 650.268Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1909 || (_path1909 = /*#__PURE__*/React.createElement("path", {
    d: "M451.29 655.42L445.385 653.412L444.883 654.888L450.788 656.896L451.29 655.42Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1910 || (_path1910 = /*#__PURE__*/React.createElement("path", {
    d: "M462.09 662.332L456.068 660.284L455.556 661.788L461.578 663.836L462.09 662.332Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1911 || (_path1911 = /*#__PURE__*/React.createElement("path", {
    d: "M472.076 672.254L465.824 670.128L465.292 671.692L471.544 673.819L472.076 672.254Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1912 || (_path1912 = /*#__PURE__*/React.createElement("path", {
    d: "M483.099 682.321L476.623 680.119L476.072 681.74L482.547 683.943L483.099 682.321Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1913 || (_path1913 = /*#__PURE__*/React.createElement("path", {
    d: "M496.622 686.805L490.149 684.603L489.598 686.222L496.071 688.424L496.622 686.805Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1914 || (_path1914 = /*#__PURE__*/React.createElement("path", {
    d: "M509.703 693.636L503.147 691.406L502.589 693.046L509.145 695.275L509.703 693.636Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1915 || (_path1915 = /*#__PURE__*/React.createElement("path", {
    d: "M523.091 701.052L516.434 698.788L515.867 700.453L522.524 702.717L523.091 701.052Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1916 || (_path1916 = /*#__PURE__*/React.createElement("path", {
    d: "M536.944 706.904L530.243 704.625L529.673 706.3L536.374 708.58L536.944 706.904Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1917 || (_path1917 = /*#__PURE__*/React.createElement("path", {
    d: "M550.945 712.424L544.218 710.136L543.646 711.817L550.373 714.105L550.945 712.424Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1918 || (_path1918 = /*#__PURE__*/React.createElement("path", {
    d: "M564.537 713.771L557.927 711.522L557.364 713.177L563.974 715.426L564.537 713.771Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1919 || (_path1919 = /*#__PURE__*/React.createElement("path", {
    d: "M575.388 703.025L569.291 700.951L568.773 702.474L574.87 704.548L575.388 703.025Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1920 || (_path1920 = /*#__PURE__*/React.createElement("path", {
    d: "M582.977 687.075L577.538 685.225L577.076 686.585L582.514 688.434L582.977 687.075Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1921 || (_path1921 = /*#__PURE__*/React.createElement("path", {
    d: "M588.701 673.043L583.833 671.388L583.419 672.607L588.286 674.262L588.701 673.043Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1922 || (_path1922 = /*#__PURE__*/React.createElement("path", {
    d: "M592.85 660.325L588.485 658.841L588.114 659.933L592.479 661.417L592.85 660.325Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1923 || (_path1923 = /*#__PURE__*/React.createElement("path", {
    d: "M596.465 650.566L592.489 649.213L592.151 650.207L596.127 651.559L596.465 650.566Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1924 || (_path1924 = /*#__PURE__*/React.createElement("path", {
    d: "M597.259 637.757L593.751 636.564L593.452 637.441L596.961 638.634L597.259 637.757Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1925 || (_path1925 = /*#__PURE__*/React.createElement("path", {
    d: "M596.238 624.528L593.186 623.49L592.926 624.253L595.979 625.291L596.238 624.528Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1926 || (_path1926 = /*#__PURE__*/React.createElement("path", {
    d: "M597.791 618.397L594.978 617.44L594.738 618.145L597.551 619.102L597.791 618.397Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1927 || (_path1927 = /*#__PURE__*/React.createElement("path", {
    d: "M604.706 622.065L601.845 621.092L601.602 621.808L604.462 622.781L604.706 622.065Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1928 || (_path1928 = /*#__PURE__*/React.createElement("path", {
    d: "M612.055 626.157L609.135 625.163L608.886 625.895L611.806 626.888L612.055 626.157Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1929 || (_path1929 = /*#__PURE__*/React.createElement("path", {
    d: "M624.067 636.537L620.927 635.469L620.658 636.258L623.799 637.326L624.067 636.537Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1930 || (_path1930 = /*#__PURE__*/React.createElement("path", {
    d: "M644.116 656.626L640.501 655.396L640.193 656.302L643.809 657.531L644.116 656.626Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1931 || (_path1931 = /*#__PURE__*/React.createElement("path", {
    d: "M668.521 680.387L664.356 678.97L664.003 680.01L668.167 681.427L668.521 680.387Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1932 || (_path1932 = /*#__PURE__*/React.createElement("path", {
    d: "M697.184 707.289L692.41 705.665L692.004 706.859L696.778 708.482L697.184 707.289Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1933 || (_path1933 = /*#__PURE__*/React.createElement("path", {
    d: "M724.88 731.02L719.595 729.223L719.146 730.543L724.431 732.341L724.88 731.02Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1934 || (_path1934 = /*#__PURE__*/React.createElement("path", {
    d: "M742.2 741.719L736.747 739.864L736.284 741.226L741.737 743.081L742.2 741.719Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1935 || (_path1935 = /*#__PURE__*/React.createElement("path", {
    d: "M750.861 742.719L745.475 740.888L745.017 742.234L750.403 744.066L750.861 742.719Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1936 || (_path1936 = /*#__PURE__*/React.createElement("path", {
    d: "M768.935 753.55L763.383 751.661L762.91 753.052L768.463 754.94L768.935 753.55Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1937 || (_path1937 = /*#__PURE__*/React.createElement("path", {
    d: "M799.505 776.319L793.511 774.281L793.001 775.78L798.995 777.818L799.505 776.319Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1938 || (_path1938 = /*#__PURE__*/React.createElement("path", {
    d: "M828.486 796.424L822.129 794.262L821.589 795.853L827.945 798.014L828.486 796.424Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1939 || (_path1939 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7064 603.395L42.4882 600.6L41.7885 602.657L50.0068 605.452L50.7064 603.395Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1940 || (_path1940 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2435 611.979L44.7685 609.097L44.0477 611.216L52.5227 614.099L53.2435 611.979Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1941 || (_path1941 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9024 617.773L63.4456 614.897L62.7266 617.011L71.1834 619.887L71.9024 617.773Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1942 || (_path1942 = /*#__PURE__*/React.createElement("path", {
    d: "M103.233 620.609L95.033 617.82L94.3351 619.872L102.535 622.661L103.233 620.609Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1943 || (_path1943 = /*#__PURE__*/React.createElement("path", {
    d: "M136.066 622.431L128.175 619.747L127.503 621.721L135.395 624.405L136.066 622.431Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1944 || (_path1944 = /*#__PURE__*/React.createElement("path", {
    d: "M162.184 625.323L154.487 622.705L153.832 624.632L161.529 627.25L162.184 625.323Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1945 || (_path1945 = /*#__PURE__*/React.createElement("path", {
    d: "M183.741 629.086L176.163 626.509L175.519 628.403L183.097 630.98L183.741 629.086Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1946 || (_path1946 = /*#__PURE__*/React.createElement("path", {
    d: "M205.241 632.541L197.79 630.007L197.158 631.867L204.608 634.401L205.241 632.541Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1947 || (_path1947 = /*#__PURE__*/React.createElement("path", {
    d: "M231.274 633.948L224.064 631.496L223.452 633.297L230.661 635.749L231.274 633.948Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1948 || (_path1948 = /*#__PURE__*/React.createElement("path", {
    d: "M257.462 634.532L250.53 632.174L249.941 633.907L256.873 636.265L257.462 634.532Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1949 || (_path1949 = /*#__PURE__*/React.createElement("path", {
    d: "M278.399 636.556L271.635 634.256L271.06 635.947L277.823 638.247L278.399 636.556Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1950 || (_path1950 = /*#__PURE__*/React.createElement("path", {
    d: "M296.385 639.444L289.728 637.18L289.162 638.845L295.819 641.109L296.385 639.444Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1951 || (_path1951 = /*#__PURE__*/React.createElement("path", {
    d: "M317.975 640.006L311.538 637.816L310.99 639.427L317.427 641.617L317.975 640.006Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1952 || (_path1952 = /*#__PURE__*/React.createElement("path", {
    d: "M339.548 639.706L333.361 637.601L332.834 639.15L339.022 641.254L339.548 639.706Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1953 || (_path1953 = /*#__PURE__*/React.createElement("path", {
    d: "M355.903 641.801L349.832 639.736L349.316 641.254L355.387 643.319L355.903 641.801Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1954 || (_path1954 = /*#__PURE__*/React.createElement("path", {
    d: "M368.383 646.231L362.304 644.163L361.787 645.683L367.866 647.751L368.383 646.231Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1955 || (_path1955 = /*#__PURE__*/React.createElement("path", {
    d: "M382.686 649.188L376.672 647.143L376.16 648.647L382.174 650.693L382.686 649.188Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1956 || (_path1956 = /*#__PURE__*/React.createElement("path", {
    d: "M394.819 653.819L388.787 651.767L388.275 653.274L394.307 655.326L394.819 653.819Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1957 || (_path1957 = /*#__PURE__*/React.createElement("path", {
    d: "M407.983 657.471L401.979 655.429L401.469 656.931L407.472 658.973L407.983 657.471Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1958 || (_path1958 = /*#__PURE__*/React.createElement("path", {
    d: "M422.21 659.708L416.289 657.694L415.786 659.173L421.707 661.186L422.21 659.708Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1959 || (_path1959 = /*#__PURE__*/React.createElement("path", {
    d: "M434.718 663.661L428.805 661.65L428.303 663.126L434.216 665.137L434.718 663.661Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1960 || (_path1960 = /*#__PURE__*/React.createElement("path", {
    d: "M446.575 668.562L440.636 666.542L440.13 668.028L446.069 670.048L446.575 668.562Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1961 || (_path1961 = /*#__PURE__*/React.createElement("path", {
    d: "M458.048 674.452L452.045 672.411L451.534 673.913L457.537 675.954L458.048 674.452Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1962 || (_path1962 = /*#__PURE__*/React.createElement("path", {
    d: "M468.542 683.249L462.368 681.149L461.842 682.695L468.017 684.795L468.542 683.249Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1963 || (_path1963 = /*#__PURE__*/React.createElement("path", {
    d: "M479.468 693.097L473.091 690.928L472.548 692.526L478.925 694.695L479.468 693.097Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1964 || (_path1964 = /*#__PURE__*/React.createElement("path", {
    d: "M492.609 698.16L486.214 695.985L485.67 697.586L492.065 699.761L492.609 698.16Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1965 || (_path1965 = /*#__PURE__*/React.createElement("path", {
    d: "M505.259 706.242L498.739 704.025L498.185 705.654L504.705 707.871L505.259 706.242Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1966 || (_path1966 = /*#__PURE__*/React.createElement("path", {
    d: "M518.243 716.062L511.547 713.784L510.978 715.458L517.674 717.735L518.243 716.062Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1967 || (_path1967 = /*#__PURE__*/React.createElement("path", {
    d: "M532.036 724.55L525.216 722.23L524.635 723.937L531.456 726.257L532.036 724.55Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1968 || (_path1968 = /*#__PURE__*/React.createElement("path", {
    d: "M546.295 731.038L539.42 728.7L538.835 730.42L545.71 732.758L546.295 731.038Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1969 || (_path1969 = /*#__PURE__*/React.createElement("path", {
    d: "M560.286 732.274L553.526 729.975L552.951 731.664L559.712 733.963L560.286 732.274Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1970 || (_path1970 = /*#__PURE__*/React.createElement("path", {
    d: "M571.762 720.184L565.525 718.063L564.995 719.622L571.232 721.743L571.762 720.184Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1971 || (_path1971 = /*#__PURE__*/React.createElement("path", {
    d: "M579.811 701.615L574.274 699.732L573.803 701.117L579.34 703L579.811 701.615Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1972 || (_path1972 = /*#__PURE__*/React.createElement("path", {
    d: "M585.509 684.145L580.611 682.479L580.194 683.703L585.093 685.37L585.509 684.145Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1973 || (_path1973 = /*#__PURE__*/React.createElement("path", {
    d: "M589.4 668.341L585.064 666.866L584.696 667.951L589.032 669.425L589.4 668.341Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1974 || (_path1974 = /*#__PURE__*/React.createElement("path", {
    d: "M592.405 655.578L588.522 654.257L588.193 655.228L592.075 656.548L592.405 655.578Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1975 || (_path1975 = /*#__PURE__*/React.createElement("path", {
    d: "M592.997 640.964L589.603 639.81L589.314 640.658L592.709 641.813L592.997 640.964Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1976 || (_path1976 = /*#__PURE__*/React.createElement("path", {
    d: "M591.929 626.42L589.001 625.424L588.752 626.155L591.68 627.151L591.929 626.42Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1977 || (_path1977 = /*#__PURE__*/React.createElement("path", {
    d: "M592.497 617.997L589.849 617.096L589.624 617.758L592.272 618.658L592.497 617.997Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1978 || (_path1978 = /*#__PURE__*/React.createElement("path", {
    d: "M597.833 619.575L595.193 618.677L594.969 619.336L597.609 620.233L597.833 619.575Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1979 || (_path1979 = /*#__PURE__*/React.createElement("path", {
    d: "M604.156 622.779L601.483 621.869L601.256 622.536L603.93 623.445L604.156 622.779Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1980 || (_path1980 = /*#__PURE__*/React.createElement("path", {
    d: "M615.678 633.724L612.774 632.737L612.528 633.46L615.432 634.448L615.678 633.724Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1981 || (_path1981 = /*#__PURE__*/React.createElement("path", {
    d: "M635.774 655.881L632.366 654.722L632.076 655.575L635.483 656.734L635.774 655.881Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1982 || (_path1982 = /*#__PURE__*/React.createElement("path", {
    d: "M661.349 683.345L657.324 681.976L656.982 682.983L661.007 684.352L661.349 683.345Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1983 || (_path1983 = /*#__PURE__*/React.createElement("path", {
    d: "M691.47 714.231L686.771 712.632L686.37 713.81L691.069 715.408L691.47 714.231Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1984 || (_path1984 = /*#__PURE__*/React.createElement("path", {
    d: "M720.552 741.313L715.285 739.522L714.836 740.839L720.103 742.631L720.552 741.313Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1985 || (_path1985 = /*#__PURE__*/React.createElement("path", {
    d: "M738.359 753.115L732.903 751.259L732.439 752.623L737.895 754.479L738.359 753.115Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1986 || (_path1986 = /*#__PURE__*/React.createElement("path", {
    d: "M746.098 752.87L740.738 751.047L740.282 752.388L745.642 754.211L746.098 752.87Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1987 || (_path1987 = /*#__PURE__*/React.createElement("path", {
    d: "M762.795 762.713L757.297 760.844L756.83 762.218L762.327 764.088L762.795 762.713Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1988 || (_path1988 = /*#__PURE__*/React.createElement("path", {
    d: "M792.591 785.987L786.66 783.97L786.154 785.456L792.085 787.473L792.591 785.987Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1989 || (_path1989 = /*#__PURE__*/React.createElement("path", {
    d: "M821.529 807.163L815.227 805.019L814.692 806.594L820.994 808.737L821.529 807.163Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1990 || (_path1990 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6771 622.805L25.2696 619.946L24.5549 622.047L32.9625 624.906L33.6771 622.805Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1991 || (_path1991 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6226 631.112L32.0361 628.192L31.3056 630.34L39.8921 633.26L40.6226 631.112Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1992 || (_path1992 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3529 637.724L47.7275 634.79L46.9943 636.946L55.6197 639.88L56.3529 637.724Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1993 || (_path1993 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3081 642.775L69.7579 639.867L69.03 642.007L77.5802 644.915L78.3081 642.775Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1994 || (_path1994 = /*#__PURE__*/React.createElement("path", {
    d: "M106.495 645.829L98.1416 642.988L97.4304 645.079L105.784 647.92L106.495 645.829Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1995 || (_path1995 = /*#__PURE__*/React.createElement("path", {
    d: "M142.219 645.955L134.232 643.238L133.552 645.236L141.54 647.952L142.219 645.955Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1996 || (_path1996 = /*#__PURE__*/React.createElement("path", {
    d: "M181.218 643.897L173.7 641.34L173.06 643.221L180.578 645.778L181.218 643.897Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1997 || (_path1997 = /*#__PURE__*/React.createElement("path", {
    d: "M208.569 644.832L201.305 642.362L200.686 644.18L207.95 646.651L208.569 644.832Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1998 || (_path1998 = /*#__PURE__*/React.createElement("path", {
    d: "M226 649.03L218.79 646.578L218.177 648.381L225.386 650.833L226 649.03Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path1999 || (_path1999 = /*#__PURE__*/React.createElement("path", {
    d: "M244.207 652.714L237.076 650.288L236.468 652.073L243.6 654.499L244.207 652.714Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2000 || (_path2000 = /*#__PURE__*/React.createElement("path", {
    d: "M270.597 652.127L263.753 649.8L263.171 651.512L270.015 653.839L270.597 652.127Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2001 || (_path2001 = /*#__PURE__*/React.createElement("path", {
    d: "M301.924 647.828L295.539 645.656L294.996 647.254L301.381 649.426L301.924 647.828Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2002 || (_path2002 = /*#__PURE__*/React.createElement("path", {
    d: "M327.102 645.376L321.052 643.318L320.538 644.831L326.588 646.889L327.102 645.376Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2003 || (_path2003 = /*#__PURE__*/React.createElement("path", {
    d: "M346.269 645.424L340.418 643.434L339.921 644.897L345.771 646.887L346.269 645.424Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2004 || (_path2004 = /*#__PURE__*/React.createElement("path", {
    d: "M360.453 648.153L354.664 646.184L354.172 647.631L359.96 649.6L360.453 648.153Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2005 || (_path2005 = /*#__PURE__*/React.createElement("path", {
    d: "M370.219 654.062L364.35 652.066L363.851 653.534L369.719 655.53L370.219 654.062Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2006 || (_path2006 = /*#__PURE__*/React.createElement("path", {
    d: "M377.619 662.427L371.574 660.371L371.06 661.881L377.105 663.937L377.619 662.427Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2007 || (_path2007 = /*#__PURE__*/React.createElement("path", {
    d: "M386.69 670.149L380.502 668.045L379.976 669.593L386.163 671.698L386.69 670.149Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2008 || (_path2008 = /*#__PURE__*/React.createElement("path", {
    d: "M399.727 674.369L393.55 672.268L393.024 673.814L399.201 675.915L399.727 674.369Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2009 || (_path2009 = /*#__PURE__*/React.createElement("path", {
    d: "M414.02 676.99L407.91 674.912L407.39 676.44L413.5 678.518L414.02 676.99Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2010 || (_path2010 = /*#__PURE__*/React.createElement("path", {
    d: "M426.743 681.332L420.631 679.253L420.111 680.781L426.224 682.86L426.743 681.332Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2011 || (_path2011 = /*#__PURE__*/React.createElement("path", {
    d: "M438.451 687.343L432.276 685.243L431.75 686.789L437.925 688.889L438.451 687.343Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2012 || (_path2012 = /*#__PURE__*/React.createElement("path", {
    d: "M450.542 693.197L444.315 691.08L443.786 692.636L450.012 694.754L450.542 693.197Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2013 || (_path2013 = /*#__PURE__*/React.createElement("path", {
    d: "M462.049 700.995L455.703 698.837L455.164 700.422L461.51 702.58L462.049 700.995Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2014 || (_path2014 = /*#__PURE__*/React.createElement("path", {
    d: "M473.487 710.547L466.968 708.329L466.414 709.958L472.933 712.176L473.487 710.547Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2015 || (_path2015 = /*#__PURE__*/React.createElement("path", {
    d: "M486.91 715.734L480.372 713.51L479.816 715.145L486.354 717.368L486.91 715.734Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2016 || (_path2016 = /*#__PURE__*/React.createElement("path", {
    d: "M500.17 722.157L493.575 719.914L493.013 721.566L499.608 723.809L500.17 722.157Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2017 || (_path2017 = /*#__PURE__*/React.createElement("path", {
    d: "M513.251 731.905L506.493 729.607L505.918 731.295L512.676 733.594L513.251 731.905Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2018 || (_path2018 = /*#__PURE__*/React.createElement("path", {
    d: "M527.138 739.809L520.284 737.478L519.701 739.193L526.555 741.524L527.138 739.809Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2019 || (_path2019 = /*#__PURE__*/React.createElement("path", {
    d: "M541.407 740.917L534.667 738.625L534.094 740.311L540.834 742.604L541.407 740.917Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2020 || (_path2020 = /*#__PURE__*/React.createElement("path", {
    d: "M555.107 740.373L548.525 738.135L547.966 739.779L554.548 742.018L555.107 740.373Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2021 || (_path2021 = /*#__PURE__*/React.createElement("path", {
    d: "M567.138 731.577L560.95 729.473L560.423 731.021L566.611 733.126L567.138 731.577Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2022 || (_path2022 = /*#__PURE__*/React.createElement("path", {
    d: "M576.244 715.113L570.65 713.21L570.175 714.609L575.769 716.511L576.244 715.113Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2023 || (_path2023 = /*#__PURE__*/React.createElement("path", {
    d: "M582.166 694.877L577.254 693.206L576.836 694.436L581.748 696.106L582.166 694.877Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2024 || (_path2024 = /*#__PURE__*/React.createElement("path", {
    d: "M586.018 676.313L581.713 674.849L581.347 675.925L585.652 677.389L586.018 676.313Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2025 || (_path2025 = /*#__PURE__*/React.createElement("path", {
    d: "M588.845 661.29L585.025 659.991L584.699 660.948L588.519 662.247L588.845 661.29Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2026 || (_path2026 = /*#__PURE__*/React.createElement("path", {
    d: "M591.442 650.224L587.991 649.05L587.697 649.913L591.149 651.087L591.442 650.224Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2027 || (_path2027 = /*#__PURE__*/React.createElement("path", {
    d: "M593.313 640.47L590.178 639.403L589.912 640.184L593.048 641.251L593.313 640.47Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2028 || (_path2028 = /*#__PURE__*/React.createElement("path", {
    d: "M593.586 629.672L590.783 628.718L590.544 629.421L593.347 630.375L593.586 629.672Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2029 || (_path2029 = /*#__PURE__*/React.createElement("path", {
    d: "M595.763 624.682L593.134 623.788L592.911 624.444L595.54 625.338L595.763 624.682Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2030 || (_path2030 = /*#__PURE__*/React.createElement("path", {
    d: "M600.231 624.766L597.646 623.887L597.425 624.535L600.011 625.415L600.231 624.766Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2031 || (_path2031 = /*#__PURE__*/React.createElement("path", {
    d: "M611.104 635.63L608.301 634.676L608.061 635.379L610.865 636.333L611.104 635.63Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2032 || (_path2032 = /*#__PURE__*/React.createElement("path", {
    d: "M630.568 658.68L627.265 657.557L626.984 658.381L630.288 659.505L630.568 658.68Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2033 || (_path2033 = /*#__PURE__*/React.createElement("path", {
    d: "M656.453 688.75L652.498 687.405L652.162 688.393L656.117 689.738L656.453 688.75Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2034 || (_path2034 = /*#__PURE__*/React.createElement("path", {
    d: "M685.869 720.89L681.24 719.315L680.847 720.469L685.476 722.044L685.869 720.89Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2035 || (_path2035 = /*#__PURE__*/React.createElement("path", {
    d: "M714.584 749.34L709.384 747.572L708.941 748.874L714.141 750.643L714.584 749.34Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2036 || (_path2036 = /*#__PURE__*/React.createElement("path", {
    d: "M733.069 762.689L727.654 760.848L727.194 762.199L732.609 764.041L733.069 762.689Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2037 || (_path2037 = /*#__PURE__*/React.createElement("path", {
    d: "M741.152 762.648L735.823 760.836L735.369 762.169L740.699 763.982L741.152 762.648Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2038 || (_path2038 = /*#__PURE__*/React.createElement("path", {
    d: "M756.734 771.644L751.291 769.793L750.828 771.152L756.272 773.004L756.734 771.644Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2039 || (_path2039 = /*#__PURE__*/React.createElement("path", {
    d: "M784.633 794.122L778.793 792.136L778.296 793.596L784.137 795.583L784.633 794.122Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2040 || (_path2040 = /*#__PURE__*/React.createElement("path", {
    d: "M812.426 815.247L806.23 813.14L805.703 814.691L811.898 816.798L812.426 815.247Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2041 || (_path2041 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2667 641.603L13.771 638.713L13.0484 640.838L21.5441 643.728L22.2667 641.603Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2042 || (_path2042 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8079 649.704L23.1747 646.768L22.4398 648.929L31.0729 651.865L31.8079 649.704Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2043 || (_path2043 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5759 656.713L37.8831 653.756L37.1437 655.93L45.8365 658.886L46.5759 656.713Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2044 || (_path2044 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1982 663.019L55.5002 660.06L54.7609 662.234L63.4589 665.193L64.1982 663.019Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2045 || (_path2045 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0708 666.658L81.5206 663.75L80.7927 665.89L89.3429 668.798L90.0708 666.658Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2046 || (_path2046 = /*#__PURE__*/React.createElement("path", {
    d: "M130.328 664.797L122.218 662.039L121.529 664.068L129.638 666.826L130.328 664.797Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2047 || (_path2047 = /*#__PURE__*/React.createElement("path", {
    d: "M177.688 658.878L170.204 656.332L169.567 658.205L177.051 660.751L177.688 658.878Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2048 || (_path2048 = /*#__PURE__*/React.createElement("path", {
    d: "M207.533 658.256L200.357 655.816L199.747 657.611L206.922 660.052L207.533 658.256Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2049 || (_path2049 = /*#__PURE__*/React.createElement("path", {
    d: "M220.287 664.328L213.062 661.871L212.448 663.676L219.673 666.133L220.287 664.328Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2050 || (_path2050 = /*#__PURE__*/React.createElement("path", {
    d: "M234.328 669.945L227.079 667.48L226.463 669.293L233.711 671.759L234.328 669.945Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2051 || (_path2051 = /*#__PURE__*/React.createElement("path", {
    d: "M263.553 667.554L256.658 665.208L256.071 666.933L262.967 669.279L263.553 667.554Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2052 || (_path2052 = /*#__PURE__*/React.createElement("path", {
    d: "M301.818 658.57L295.55 656.438L295.016 658.007L301.284 660.139L301.818 658.57Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2053 || (_path2053 = /*#__PURE__*/React.createElement("path", {
    d: "M329.072 654.022L323.195 652.024L322.696 653.492L328.572 655.491L329.072 654.022Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2054 || (_path2054 = /*#__PURE__*/React.createElement("path", {
    d: "M347.262 654.056L341.562 652.118L341.077 653.544L346.777 655.483L347.262 654.056Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2055 || (_path2055 = /*#__PURE__*/React.createElement("path", {
    d: "M360.497 657.064L354.839 655.14L354.358 656.554L360.016 658.478L360.497 657.064Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2056 || (_path2056 = /*#__PURE__*/React.createElement("path", {
    d: "M368.927 663.882L363.157 661.919L362.666 663.362L368.437 665.324L368.927 663.882Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2057 || (_path2057 = /*#__PURE__*/React.createElement("path", {
    d: "M372.877 675.45L366.814 673.388L366.297 674.906L372.361 676.968L372.877 675.45Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2058 || (_path2058 = /*#__PURE__*/React.createElement("path", {
    d: "M380.409 684.993L374.149 682.864L373.616 684.43L379.876 686.56L380.409 684.993Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2059 || (_path2059 = /*#__PURE__*/React.createElement("path", {
    d: "M393.398 689.489L387.135 687.359L386.603 688.926L392.865 691.056L393.398 689.489Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2060 || (_path2060 = /*#__PURE__*/React.createElement("path", {
    d: "M407.738 692.253L401.537 690.144L401.01 691.695L407.21 693.804L407.738 692.253Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2061 || (_path2061 = /*#__PURE__*/React.createElement("path", {
    d: "M420.538 696.83L414.327 694.717L413.798 696.271L420.009 698.384L420.538 696.83Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2062 || (_path2062 = /*#__PURE__*/React.createElement("path", {
    d: "M432.044 703.646L425.75 701.505L425.215 703.077L431.509 705.218L432.044 703.646Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2063 || (_path2063 = /*#__PURE__*/React.createElement("path", {
    d: "M444.324 709.744L437.975 707.585L437.436 709.17L443.785 711.329L444.324 709.744Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2064 || (_path2064 = /*#__PURE__*/React.createElement("path", {
    d: "M456.237 717.284L449.79 715.091L449.242 716.704L455.689 718.897L456.237 717.284Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2065 || (_path2065 = /*#__PURE__*/React.createElement("path", {
    d: "M467.884 726.911L461.278 724.665L460.716 726.32L467.321 728.566L467.884 726.911Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2066 || (_path2066 = /*#__PURE__*/React.createElement("path", {
    d: "M481.51 732.096L474.887 729.843L474.323 731.501L480.946 733.753L481.51 732.096Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2067 || (_path2067 = /*#__PURE__*/React.createElement("path", {
    d: "M495.181 737.385L488.543 735.127L487.978 736.788L494.617 739.046L495.181 737.385Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2068 || (_path2068 = /*#__PURE__*/React.createElement("path", {
    d: "M508.34 746.862L501.554 744.554L500.977 746.248L507.764 748.556L508.34 746.862Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2069 || (_path2069 = /*#__PURE__*/React.createElement("path", {
    d: "M522.278 754.117L515.421 751.785L514.838 753.5L521.695 755.832L522.278 754.117Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2070 || (_path2070 = /*#__PURE__*/React.createElement("path", {
    d: "M536.685 751.877L530.035 749.616L529.469 751.281L536.118 753.543L536.685 751.877Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2071 || (_path2071 = /*#__PURE__*/React.createElement("path", {
    d: "M550.279 750.163L543.806 747.961L543.255 749.58L549.728 751.782L550.279 750.163Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2072 || (_path2072 = /*#__PURE__*/React.createElement("path", {
    d: "M562.6 742.895L556.453 740.805L555.932 742.338L562.078 744.429L562.6 742.895Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2073 || (_path2073 = /*#__PURE__*/React.createElement("path", {
    d: "M572.352 727.238L566.747 725.332L566.271 726.733L571.875 728.639L572.352 727.238Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2074 || (_path2074 = /*#__PURE__*/React.createElement("path", {
    d: "M578.696 705.172L573.785 703.502L573.366 704.731L578.278 706.402L578.696 705.172Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2075 || (_path2075 = /*#__PURE__*/React.createElement("path", {
    d: "M582.868 684.885L578.571 683.423L578.206 684.497L582.503 685.959L582.868 684.885Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2076 || (_path2076 = /*#__PURE__*/React.createElement("path", {
    d: "M585.905 668.486L582.109 667.195L581.785 668.147L585.581 669.438L585.905 668.486Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2077 || (_path2077 = /*#__PURE__*/React.createElement("path", {
    d: "M589.643 659.266L586.144 658.076L585.847 658.951L589.345 660.14L589.643 659.266Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2078 || (_path2078 = /*#__PURE__*/React.createElement("path", {
    d: "M593.084 652.032L589.827 650.924L589.55 651.739L592.807 652.847L593.084 652.032Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2079 || (_path2079 = /*#__PURE__*/React.createElement("path", {
    d: "M593.503 639.843L590.594 638.853L590.347 639.579L593.256 640.569L593.503 639.843Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2080 || (_path2080 = /*#__PURE__*/React.createElement("path", {
    d: "M594.447 631.299L591.792 630.396L591.567 631.057L594.222 631.961L594.447 631.299Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2081 || (_path2081 = /*#__PURE__*/React.createElement("path", {
    d: "M598.18 629.732L595.605 628.857L595.386 629.5L597.961 630.376L598.18 629.732Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2082 || (_path2082 = /*#__PURE__*/React.createElement("path", {
    d: "M608.682 640.693L605.894 639.745L605.657 640.442L608.444 641.391L608.682 640.693Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2083 || (_path2083 = /*#__PURE__*/React.createElement("path", {
    d: "M627.579 664.476L624.298 663.36L624.019 664.18L627.3 665.296L627.579 664.476Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2084 || (_path2084 = /*#__PURE__*/React.createElement("path", {
    d: "M653.156 696.213L649.22 694.874L648.885 695.857L652.822 697.196L653.156 696.213Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2085 || (_path2085 = /*#__PURE__*/React.createElement("path", {
    d: "M681.732 729.268L677.131 727.703L676.741 728.852L681.341 730.417L681.732 729.268Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2086 || (_path2086 = /*#__PURE__*/React.createElement("path", {
    d: "M709.842 758.679L704.674 756.921L704.234 758.216L709.402 759.974L709.842 758.679Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2087 || (_path2087 = /*#__PURE__*/React.createElement("path", {
    d: "M728.497 772.974L723.103 771.14L722.644 772.489L728.038 774.323L728.497 772.974Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2088 || (_path2088 = /*#__PURE__*/React.createElement("path", {
    d: "M736.874 773.109L731.56 771.301L731.108 772.632L736.421 774.439L736.874 773.109Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2089 || (_path2089 = /*#__PURE__*/React.createElement("path", {
    d: "M752.041 781.954L746.621 780.111L746.16 781.468L751.58 783.311L752.041 781.954Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2090 || (_path2090 = /*#__PURE__*/React.createElement("path", {
    d: "M779.002 804.513L773.201 802.539L772.707 803.992L778.508 805.965L779.002 804.513Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2091 || (_path2091 = /*#__PURE__*/React.createElement("path", {
    d: "M806.133 825.965L799.982 823.873L799.458 825.414L805.609 827.506L806.133 825.965Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2092 || (_path2092 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1128 659.608L6.59893 656.713L5.87545 658.84L14.3893 661.735L15.1128 659.608Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2093 || (_path2093 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4564 667.481L17.8335 664.548L17.1004 666.703L25.7232 669.636L26.4564 667.481Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2094 || (_path2094 = /*#__PURE__*/React.createElement("path", {
    d: "M41.972 674.341L33.3103 671.395L32.5736 673.561L41.2353 676.507L41.972 674.341Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2095 || (_path2095 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2411 680.076L52.6001 677.137L51.8652 679.297L60.5062 682.236L61.2411 680.076Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2096 || (_path2096 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8539 683.096L79.3737 680.211L78.6529 682.331L87.133 685.215L87.8539 683.096Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2097 || (_path2097 = /*#__PURE__*/React.createElement("path", {
    d: "M127.121 680.707L119.061 677.965L118.377 679.979L126.437 682.72L127.121 680.707Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2098 || (_path2098 = /*#__PURE__*/React.createElement("path", {
    d: "M173.28 674.092L165.817 671.554L165.182 673.419L172.646 675.957L173.28 674.092Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2099 || (_path2099 = /*#__PURE__*/React.createElement("path", {
    d: "M202.485 673.192L195.312 670.753L194.701 672.548L201.874 674.987L202.485 673.192Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2100 || (_path2100 = /*#__PURE__*/React.createElement("path", {
    d: "M215.038 679.447L207.81 676.989L207.196 678.795L214.424 681.253L215.038 679.447Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2101 || (_path2101 = /*#__PURE__*/React.createElement("path", {
    d: "M229.072 685.109L221.824 682.644L221.206 684.46L228.454 686.925L229.072 685.109Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2102 || (_path2102 = /*#__PURE__*/React.createElement("path", {
    d: "M255.939 683.492L248.976 681.124L248.384 682.865L255.347 685.233L255.939 683.492Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2103 || (_path2103 = /*#__PURE__*/React.createElement("path", {
    d: "M288.09 677.427L281.578 675.212L281.025 676.839L287.537 679.054L288.09 677.427Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2104 || (_path2104 = /*#__PURE__*/React.createElement("path", {
    d: "M313.539 673.974L307.352 671.869L306.826 673.415L313.014 675.52L313.539 673.974Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2105 || (_path2105 = /*#__PURE__*/React.createElement("path", {
    d: "M333.013 673.483L327.018 671.444L326.508 672.943L332.503 674.983L333.013 673.483Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2106 || (_path2106 = /*#__PURE__*/React.createElement("path", {
    d: "M347.66 675.982L341.732 673.965L341.228 675.447L347.156 677.463L347.66 675.982Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2107 || (_path2107 = /*#__PURE__*/React.createElement("path", {
    d: "M358.303 681.703L352.318 679.667L351.809 681.164L357.794 683.2L358.303 681.703Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2108 || (_path2108 = /*#__PURE__*/React.createElement("path", {
    d: "M367.634 689.003L361.539 686.93L361.021 688.453L367.116 690.526L367.634 689.003Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2109 || (_path2109 = /*#__PURE__*/React.createElement("path", {
    d: "M377.179 696.736L370.963 694.621L370.434 696.175L376.65 698.289L377.179 696.736Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2110 || (_path2110 = /*#__PURE__*/React.createElement("path", {
    d: "M387.588 704.192L381.268 702.042L380.73 703.622L387.05 705.771L387.588 704.192Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2111 || (_path2111 = /*#__PURE__*/React.createElement("path", {
    d: "M399.121 710.867L392.729 708.693L392.184 710.293L398.577 712.467L399.121 710.867Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2112 || (_path2112 = /*#__PURE__*/React.createElement("path", {
    d: "M412.178 715.803L405.773 713.624L405.227 715.227L411.633 717.406L412.178 715.803Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2113 || (_path2113 = /*#__PURE__*/React.createElement("path", {
    d: "M425.238 720.832L418.817 718.648L418.271 720.254L424.692 722.438L425.238 720.832Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2114 || (_path2114 = /*#__PURE__*/React.createElement("path", {
    d: "M438.763 725.099L432.349 722.918L431.803 724.523L438.216 726.705L438.763 725.099Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2115 || (_path2115 = /*#__PURE__*/React.createElement("path", {
    d: "M451.567 730.965L445.112 728.769L444.563 730.383L451.018 732.578L451.567 730.965Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2116 || (_path2116 = /*#__PURE__*/React.createElement("path", {
    d: "M463.867 738.789L457.316 736.561L456.759 738.2L463.309 740.428L463.867 738.789Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2117 || (_path2117 = /*#__PURE__*/React.createElement("path", {
    d: "M477.477 743.554L470.924 741.325L470.366 742.965L476.919 745.193L477.477 743.554Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2118 || (_path2118 = /*#__PURE__*/React.createElement("path", {
    d: "M490.737 750.02L484.131 747.774L483.569 749.429L490.174 751.675L490.737 750.02Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2119 || (_path2119 = /*#__PURE__*/React.createElement("path", {
    d: "M503.607 760.472L496.838 758.17L496.263 759.862L503.032 762.164L503.607 760.472Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2120 || (_path2120 = /*#__PURE__*/React.createElement("path", {
    d: "M517.516 767.359L510.691 765.038L510.11 766.745L516.936 769.066L517.516 767.359Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2121 || (_path2121 = /*#__PURE__*/React.createElement("path", {
    d: "M532.024 764.329L525.409 762.079L524.846 763.734L531.461 765.984L532.024 764.329Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2122 || (_path2122 = /*#__PURE__*/React.createElement("path", {
    d: "M545.659 762.02L539.23 759.834L538.683 761.442L545.112 763.629L545.659 762.02Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2123 || (_path2123 = /*#__PURE__*/React.createElement("path", {
    d: "M558.009 752.555L551.949 750.494L551.433 752.011L557.493 754.072L558.009 752.555Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2124 || (_path2124 = /*#__PURE__*/React.createElement("path", {
    d: "M567.852 734.743L562.354 732.873L561.887 734.246L567.385 736.116L567.852 734.743Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2125 || (_path2125 = /*#__PURE__*/React.createElement("path", {
    d: "M574.785 712.973L569.93 711.322L569.518 712.533L574.373 714.184L574.785 712.973Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2126 || (_path2126 = /*#__PURE__*/React.createElement("path", {
    d: "M580.009 694.67L575.693 693.202L575.326 694.281L579.642 695.749L580.009 694.67Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2127 || (_path2127 = /*#__PURE__*/React.createElement("path", {
    d: "M583.855 678.767L580.002 677.456L579.673 678.421L583.527 679.732L583.855 678.767Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2128 || (_path2128 = /*#__PURE__*/React.createElement("path", {
    d: "M587.322 667.067L583.814 665.874L583.515 666.75L587.024 667.944L587.322 667.067Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2129 || (_path2129 = /*#__PURE__*/React.createElement("path", {
    d: "M590.306 657.512L587.077 656.414L586.802 657.223L590.031 658.321L590.306 657.512Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2130 || (_path2130 = /*#__PURE__*/React.createElement("path", {
    d: "M591.655 646.435L588.735 645.442L588.486 646.173L591.406 647.166L591.655 646.435Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2131 || (_path2131 = /*#__PURE__*/React.createElement("path", {
    d: "M594.053 640.183L591.32 639.253L591.087 639.938L593.82 640.868L594.053 640.183Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2132 || (_path2132 = /*#__PURE__*/React.createElement("path", {
    d: "M598.568 639.684L595.889 638.773L595.662 639.442L598.341 640.354L598.568 639.684Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2133 || (_path2133 = /*#__PURE__*/React.createElement("path", {
    d: "M609.516 651.893L606.612 650.906L606.365 651.632L609.269 652.62L609.516 651.893Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2134 || (_path2134 = /*#__PURE__*/React.createElement("path", {
    d: "M628.419 676.987L625.016 675.83L624.726 676.683L628.129 677.84L628.419 676.987Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2135 || (_path2135 = /*#__PURE__*/React.createElement("path", {
    d: "M651.803 706.837L647.817 705.482L647.478 706.478L651.464 707.833L651.803 706.837Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2136 || (_path2136 = /*#__PURE__*/React.createElement("path", {
    d: "M675.136 733.545L670.647 732.018L670.265 733.141L674.754 734.668L675.136 733.545Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2137 || (_path2137 = /*#__PURE__*/React.createElement("path", {
    d: "M699.53 759.421L694.572 757.734L694.15 758.974L699.108 760.66L699.53 759.421Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2138 || (_path2138 = /*#__PURE__*/React.createElement("path", {
    d: "M721.236 779.283L715.943 777.482L715.494 778.803L720.787 780.603L721.236 779.283Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2139 || (_path2139 = /*#__PURE__*/React.createElement("path", {
    d: "M736.667 789.081L731.252 787.239L730.792 788.593L736.206 790.435L736.667 789.081Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2140 || (_path2140 = /*#__PURE__*/React.createElement("path", {
    d: "M753.836 800.676L748.268 798.783L747.794 800.176L753.362 802.069L753.836 800.676Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2141 || (_path2141 = /*#__PURE__*/React.createElement("path", {
    d: "M776.789 819.015L770.941 817.026L770.443 818.489L776.291 820.478L776.789 819.015Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2142 || (_path2142 = /*#__PURE__*/React.createElement("path", {
    d: "M800.2 836.867L794.088 834.788L793.568 836.316L799.681 838.395L800.2 836.867Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2143 || (_path2143 = /*#__PURE__*/React.createElement("path", {
    d: "M9.65248 677.185L1.14637 674.292L0.423792 676.417L8.92991 679.31L9.65248 677.185Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2144 || (_path2144 = /*#__PURE__*/React.createElement("path", {
    d: "M23.676 684.383L15.1077 681.469L14.3789 683.612L22.9473 686.526L23.676 684.383Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2145 || (_path2145 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2793 690.878L31.6928 687.958L30.9623 690.106L39.5488 693.026L40.2793 690.878Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2146 || (_path2146 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5525 695.723L53.0256 692.823L52.3013 694.953L60.8281 697.853L61.5525 695.723Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2147 || (_path2147 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3808 698.194L80.0199 695.35L79.3088 697.441L87.6697 700.285L88.3808 698.194Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2148 || (_path2148 = /*#__PURE__*/React.createElement("path", {
    d: "M125.119 695.935L117.129 693.217L116.45 695.215L124.44 697.932L125.119 695.935Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2149 || (_path2149 = /*#__PURE__*/React.createElement("path", {
    d: "M168.469 689.43L161.015 686.895L160.381 688.76L167.834 691.295L168.469 689.43Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2150 || (_path2150 = /*#__PURE__*/React.createElement("path", {
    d: "M195.929 688.86L188.727 686.411L188.114 688.214L195.316 690.663L195.929 688.86Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2151 || (_path2151 = /*#__PURE__*/React.createElement("path", {
    d: "M207.715 695.67L200.438 693.195L199.82 695.014L207.096 697.489L207.715 695.67Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2152 || (_path2152 = /*#__PURE__*/React.createElement("path", {
    d: "M221.526 701.586L214.221 699.101L213.599 700.93L220.904 703.415L221.526 701.586Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2153 || (_path2153 = /*#__PURE__*/React.createElement("path", {
    d: "M244.856 701.779L237.745 699.36L237.14 701.14L244.251 703.559L244.856 701.779Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2154 || (_path2154 = /*#__PURE__*/React.createElement("path", {
    d: "M267.882 701.359L260.979 699.011L260.391 700.739L267.294 703.087L267.882 701.359Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2155 || (_path2155 = /*#__PURE__*/React.createElement("path", {
    d: "M290.454 700.345L283.768 698.071L283.2 699.742L289.885 702.016L290.454 700.345Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2156 || (_path2156 = /*#__PURE__*/React.createElement("path", {
    d: "M311.691 699.349L305.213 697.146L304.662 698.764L311.14 700.968L311.691 699.349Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2157 || (_path2157 = /*#__PURE__*/React.createElement("path", {
    d: "M328.566 701.054L322.189 698.885L321.647 700.481L328.024 702.649L328.566 701.054Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2158 || (_path2158 = /*#__PURE__*/React.createElement("path", {
    d: "M342.761 704.727L336.413 702.568L335.874 704.153L342.222 706.312L342.761 704.727Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2159 || (_path2159 = /*#__PURE__*/React.createElement("path", {
    d: "M360.091 705.012L353.885 702.902L353.358 704.453L359.563 706.564L360.091 705.012Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2160 || (_path2160 = /*#__PURE__*/React.createElement("path", {
    d: "M372.609 709.875L366.387 707.759L365.858 709.315L372.079 711.431L372.609 709.875Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2161 || (_path2161 = /*#__PURE__*/React.createElement("path", {
    d: "M379.229 722.227L372.753 720.024L372.202 721.643L378.678 723.846L379.229 722.227Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2162 || (_path2162 = /*#__PURE__*/React.createElement("path", {
    d: "M386.664 735.276L379.924 732.984L379.352 734.667L386.092 736.96L386.664 735.276Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2163 || (_path2163 = /*#__PURE__*/React.createElement("path", {
    d: "M400.288 740.706L393.53 738.407L392.956 740.096L399.714 742.395L400.288 740.706Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2164 || (_path2164 = /*#__PURE__*/React.createElement("path", {
    d: "M416.23 742.171L409.57 739.906L409.004 741.572L415.663 743.837L416.23 742.171Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2165 || (_path2165 = /*#__PURE__*/React.createElement("path", {
    d: "M432.298 742.395L425.771 740.175L425.216 741.807L431.743 744.027L432.298 742.395Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2166 || (_path2166 = /*#__PURE__*/React.createElement("path", {
    d: "M447.05 744.272L440.6 742.079L440.051 743.692L446.501 745.886L447.05 744.272Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2167 || (_path2167 = /*#__PURE__*/React.createElement("path", {
    d: "M460.719 748.163L454.29 745.977L453.743 747.585L460.172 749.772L460.719 748.163Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2168 || (_path2168 = /*#__PURE__*/React.createElement("path", {
    d: "M474.375 751.824L467.969 749.645L467.424 751.248L473.83 753.427L474.375 751.824Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2169 || (_path2169 = /*#__PURE__*/React.createElement("path", {
    d: "M487 759.57L480.508 757.363L479.956 758.987L486.447 761.194L487 759.57Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2170 || (_path2170 = /*#__PURE__*/React.createElement("path", {
    d: "M499.451 770.719L492.786 768.452L492.218 770.12L498.883 772.387L499.451 770.719Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2171 || (_path2171 = /*#__PURE__*/React.createElement("path", {
    d: "M513.242 776.336L506.552 774.061L505.982 775.734L512.673 778.009L513.242 776.336Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2172 || (_path2172 = /*#__PURE__*/React.createElement("path", {
    d: "M527.656 771.908L521.198 769.711L520.649 771.325L527.107 773.521L527.656 771.908Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2173 || (_path2173 = /*#__PURE__*/React.createElement("path", {
    d: "M541.094 768.771L534.831 766.641L534.298 768.208L540.561 770.338L541.094 768.771Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2174 || (_path2174 = /*#__PURE__*/React.createElement("path", {
    d: "M553.263 756.717L547.41 754.727L546.913 756.19L552.766 758.18L553.263 756.717Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2175 || (_path2175 = /*#__PURE__*/React.createElement("path", {
    d: "M563.022 737.068L557.744 735.273L557.296 736.591L562.574 738.386L563.022 737.068Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2176 || (_path2176 = /*#__PURE__*/React.createElement("path", {
    d: "M570.516 717.619L565.797 716.014L565.395 717.194L570.115 718.799L570.516 717.619Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2177 || (_path2177 = /*#__PURE__*/React.createElement("path", {
    d: "M577.036 704.098L572.711 702.627L572.343 703.709L576.668 705.18L577.036 704.098Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2178 || (_path2178 = /*#__PURE__*/React.createElement("path", {
    d: "M581.986 690.362L578.047 689.022L577.712 690.005L581.652 691.345L581.986 690.362Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2179 || (_path2179 = /*#__PURE__*/React.createElement("path", {
    d: "M585.442 676.516L581.884 675.306L581.581 676.199L585.139 677.409L585.442 676.516Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2180 || (_path2180 = /*#__PURE__*/React.createElement("path", {
    d: "M588.433 665.529L585.176 664.421L584.9 665.233L588.157 666.341L588.433 665.529Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2181 || (_path2181 = /*#__PURE__*/React.createElement("path", {
    d: "M591.75 658.397L588.697 657.359L588.438 658.121L591.49 659.16L591.75 658.397Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2182 || (_path2182 = /*#__PURE__*/React.createElement("path", {
    d: "M596.766 657.284L593.786 656.271L593.533 657.015L596.513 658.029L596.766 657.284Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2183 || (_path2183 = /*#__PURE__*/React.createElement("path", {
    d: "M602.799 659.009L599.83 657.999L599.577 658.744L602.546 659.754L602.799 659.009Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2184 || (_path2184 = /*#__PURE__*/React.createElement("path", {
    d: "M614.293 672.096L611.093 671.007L610.821 671.809L614.021 672.897L614.293 672.096Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2185 || (_path2185 = /*#__PURE__*/React.createElement("path", {
    d: "M632.55 696.68L628.886 695.434L628.575 696.35L632.239 697.596L632.55 696.68Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2186 || (_path2186 = /*#__PURE__*/React.createElement("path", {
    d: "M651.909 720.433L647.812 719.039L647.463 720.064L651.561 721.457L651.909 720.433Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2187 || (_path2187 = /*#__PURE__*/React.createElement("path", {
    d: "M667.122 734.691L662.799 733.221L662.431 734.303L666.754 735.773L667.122 734.691Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2188 || (_path2188 = /*#__PURE__*/React.createElement("path", {
    d: "M685.863 753.42L681.229 751.844L680.835 753.001L685.469 754.577L685.863 753.42Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2189 || (_path2189 = /*#__PURE__*/React.createElement("path", {
    d: "M711.536 781.21L706.419 779.47L705.984 780.752L711.1 782.492L711.536 781.21Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2190 || (_path2190 = /*#__PURE__*/React.createElement("path", {
    d: "M736.788 806.154L731.265 804.275L730.794 805.658L736.318 807.537L736.788 806.154Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2191 || (_path2191 = /*#__PURE__*/React.createElement("path", {
    d: "M757.416 822.807L751.646 820.845L751.154 822.29L756.925 824.252L757.416 822.807Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2192 || (_path2192 = /*#__PURE__*/React.createElement("path", {
    d: "M775.806 835.449L769.875 833.432L769.371 834.913L775.302 836.931L775.806 835.449Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2193 || (_path2193 = /*#__PURE__*/React.createElement("path", {
    d: "M794.652 848.041L788.566 845.971L788.048 847.494L794.134 849.564L794.652 848.041Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2194 || (_path2194 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1781 692.116L3.80941 689.269L3.09741 691.363L11.4661 694.209L12.1781 692.116Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2195 || (_path2195 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7055 699.411L17.272 696.543L16.5548 698.652L24.9883 701.52L25.7055 699.411Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2196 || (_path2196 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2013 705.788L33.7496 702.914L33.0306 705.028L41.4822 707.903L42.2013 705.788Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2197 || (_path2197 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2458 710.007L55.8719 707.159L55.1599 709.252L63.5338 712.101L64.2458 710.007Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2198 || (_path2198 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8259 712.465L81.6025 709.668L80.9037 711.722L89.1272 714.519L89.8259 712.465Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2199 || (_path2199 = /*#__PURE__*/React.createElement("path", {
    d: "M121.909 711.456L113.968 708.755L113.292 710.742L121.233 713.443L121.909 711.456Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2200 || (_path2200 = /*#__PURE__*/React.createElement("path", {
    d: "M159.604 706.715L152.081 704.156L151.441 706.036L158.964 708.595L159.604 706.715Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2201 || (_path2201 = /*#__PURE__*/React.createElement("path", {
    d: "M184.138 707.39L176.797 704.893L176.172 706.729L183.514 709.226L184.138 707.39Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2202 || (_path2202 = /*#__PURE__*/React.createElement("path", {
    d: "M195.752 714.671L188.333 712.147L187.702 714.002L195.121 716.526L195.752 714.671Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2203 || (_path2203 = /*#__PURE__*/React.createElement("path", {
    d: "M210.089 720.615L202.641 718.082L202.009 719.942L209.457 722.475L210.089 720.615Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2204 || (_path2204 = /*#__PURE__*/React.createElement("path", {
    d: "M233.327 720.84L226.061 718.369L225.443 720.185L232.71 722.656L233.327 720.84Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2205 || (_path2205 = /*#__PURE__*/React.createElement("path", {
    d: "M255.941 720.715L248.863 718.307L248.261 720.079L255.338 722.486L255.941 720.715Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2206 || (_path2206 = /*#__PURE__*/React.createElement("path", {
    d: "M278.211 719.991L271.333 717.652L270.748 719.372L277.626 721.711L278.211 719.991Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2207 || (_path2207 = /*#__PURE__*/React.createElement("path", {
    d: "M299.775 718.901L293.095 716.629L292.526 718.299L299.207 720.571L299.775 718.901Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2208 || (_path2208 = /*#__PURE__*/React.createElement("path", {
    d: "M317.61 720.116L311.044 717.883L310.485 719.525L317.051 721.758L317.61 720.116Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2209 || (_path2209 = /*#__PURE__*/React.createElement("path", {
    d: "M332.565 723.521L326.04 721.302L325.485 722.934L332.01 725.153L332.565 723.521Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2210 || (_path2210 = /*#__PURE__*/React.createElement("path", {
    d: "M349.235 724.852L342.813 722.669L342.267 724.274L348.688 726.458L349.235 724.852Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2211 || (_path2211 = /*#__PURE__*/React.createElement("path", {
    d: "M361.265 730.993L354.792 728.792L354.242 730.41L360.715 732.612L361.265 730.993Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2212 || (_path2212 = /*#__PURE__*/React.createElement("path", {
    d: "M368.323 743.92L361.604 741.635L361.032 743.316L367.752 745.601L368.323 743.92Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2213 || (_path2213 = /*#__PURE__*/React.createElement("path", {
    d: "M376.554 757.023L369.586 754.653L368.994 756.393L375.962 758.763L376.554 757.023Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2214 || (_path2214 = /*#__PURE__*/React.createElement("path", {
    d: "M390.822 762.347L383.846 759.974L383.253 761.717L390.229 764.09L390.822 762.347Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2215 || (_path2215 = /*#__PURE__*/React.createElement("path", {
    d: "M408.172 762.162L401.339 759.837L400.757 761.547L407.591 763.871L408.172 762.162Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2216 || (_path2216 = /*#__PURE__*/React.createElement("path", {
    d: "M426.332 758.805L419.727 756.558L419.165 758.211L425.77 760.457L426.332 758.805Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2217 || (_path2217 = /*#__PURE__*/React.createElement("path", {
    d: "M443.126 756.138L436.718 753.959L436.173 755.562L442.581 757.741L443.126 756.138Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2218 || (_path2218 = /*#__PURE__*/React.createElement("path", {
    d: "M457.992 756.344L451.698 754.203L451.163 755.775L457.457 757.916L457.992 756.344Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2219 || (_path2219 = /*#__PURE__*/React.createElement("path", {
    d: "M471.832 758.261L465.608 756.144L465.079 757.7L471.303 759.817L471.832 758.261Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2220 || (_path2220 = /*#__PURE__*/React.createElement("path", {
    d: "M484.48 764.076L478.217 761.946L477.685 763.511L483.948 765.641L484.48 764.076Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2221 || (_path2221 = /*#__PURE__*/React.createElement("path", {
    d: "M496.712 773.174L490.332 771.004L489.789 772.602L496.169 774.772L496.712 773.174Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2222 || (_path2222 = /*#__PURE__*/React.createElement("path", {
    d: "M510.074 777.067L503.71 774.903L503.169 776.493L509.533 778.658L510.074 777.067Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2223 || (_path2223 = /*#__PURE__*/React.createElement("path", {
    d: "M524.012 771.418L517.897 769.338L517.377 770.866L523.492 772.946L524.012 771.418Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2224 || (_path2224 = /*#__PURE__*/React.createElement("path", {
    d: "M536.876 767.672L530.953 765.658L530.45 767.136L536.373 769.151L536.876 767.672Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2225 || (_path2225 = /*#__PURE__*/React.createElement("path", {
    d: "M548.675 755.66L543.133 753.775L542.662 755.161L548.204 757.046L548.675 755.66Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2226 || (_path2226 = /*#__PURE__*/React.createElement("path", {
    d: "M558.407 737.264L553.381 735.555L552.954 736.81L557.98 738.52L558.407 737.264Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2227 || (_path2227 = /*#__PURE__*/React.createElement("path", {
    d: "M566.277 720.385L561.713 718.833L561.325 719.974L565.889 721.527L566.277 720.385Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2228 || (_path2228 = /*#__PURE__*/React.createElement("path", {
    d: "M573.37 709.621L569.122 708.176L568.761 709.237L573.009 710.681L573.37 709.621Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2229 || (_path2229 = /*#__PURE__*/React.createElement("path", {
    d: "M579.096 698.11L575.167 696.774L574.834 697.755L578.763 699.091L579.096 698.11Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2230 || (_path2230 = /*#__PURE__*/React.createElement("path", {
    d: "M584.131 688.64L580.467 687.394L580.155 688.309L583.82 689.556L584.131 688.64Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2231 || (_path2231 = /*#__PURE__*/React.createElement("path", {
    d: "M589.589 683.95L586.083 682.757L585.785 683.634L589.291 684.826L589.589 683.95Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2232 || (_path2232 = /*#__PURE__*/React.createElement("path", {
    d: "M595.598 682.59L592.175 681.426L591.883 682.284L595.306 683.448L595.598 682.59Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2233 || (_path2233 = /*#__PURE__*/React.createElement("path", {
    d: "M602.823 685.244L599.392 684.077L599.1 684.936L602.531 686.103L602.823 685.244Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2234 || (_path2234 = /*#__PURE__*/React.createElement("path", {
    d: "M610.239 688.339L606.795 687.168L606.502 688.029L609.946 689.2L610.239 688.339Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2235 || (_path2235 = /*#__PURE__*/React.createElement("path", {
    d: "M621.486 699.854L617.861 698.621L617.552 699.529L621.177 700.762L621.486 699.854Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2236 || (_path2236 = /*#__PURE__*/React.createElement("path", {
    d: "M637.36 719.629L633.39 718.278L633.053 719.269L637.023 720.62L637.36 719.629Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2237 || (_path2237 = /*#__PURE__*/React.createElement("path", {
    d: "M652.481 735.68L648.254 734.242L647.894 735.3L652.121 736.738L652.481 735.68Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2238 || (_path2238 = /*#__PURE__*/React.createElement("path", {
    d: "M662.684 741.213L658.408 739.759L658.045 740.828L662.321 742.282L662.684 741.213Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2239 || (_path2239 = /*#__PURE__*/React.createElement("path", {
    d: "M677.961 755.164L673.477 753.639L673.095 754.762L677.579 756.287L677.961 755.164Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2240 || (_path2240 = /*#__PURE__*/React.createElement("path", {
    d: "M703.307 784.376L698.333 782.685L697.91 783.927L702.884 785.619L703.307 784.376Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2241 || (_path2241 = /*#__PURE__*/React.createElement("path", {
    d: "M730.506 813.999L725.05 812.144L724.586 813.508L730.042 815.364L730.506 813.999Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2242 || (_path2242 = /*#__PURE__*/React.createElement("path", {
    d: "M753.278 834.753L747.508 832.791L747.016 834.236L752.786 836.198L753.278 834.753Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2243 || (_path2243 = /*#__PURE__*/React.createElement("path", {
    d: "M772.937 849.703L766.975 847.675L766.468 849.166L772.43 851.194L772.937 849.703Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2244 || (_path2244 = /*#__PURE__*/React.createElement("path", {
    d: "M792.115 863.148L785.984 861.063L785.463 862.596L791.594 864.681L792.115 863.148Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2245 || (_path2245 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5392 703.778L14.4247 701.018L13.7348 703.047L21.8493 705.807L22.5392 703.778Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2246 || (_path2246 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5079 712.905L22.2481 710.095L21.5458 712.16L29.8056 714.97L30.5079 712.905Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2247 || (_path2247 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9222 719.484L37.6313 716.665L36.9264 718.737L45.2172 721.557L45.9222 719.484Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2248 || (_path2248 = /*#__PURE__*/React.createElement("path", {
    d: "M74.638 720.43L66.5468 717.678L65.8586 719.701L73.9498 722.453L74.638 720.43Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2249 || (_path2249 = /*#__PURE__*/React.createElement("path", {
    d: "M102.773 720.981L94.8869 718.299L94.2155 720.273L102.102 722.955L102.773 720.981Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2250 || (_path2250 = /*#__PURE__*/React.createElement("path", {
    d: "M123.604 724.413L115.798 721.758L115.134 723.709L122.94 726.364L123.604 724.413Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2251 || (_path2251 = /*#__PURE__*/React.createElement("path", {
    d: "M143.525 728.025L135.792 725.395L135.135 727.328L142.868 729.958L143.525 728.025Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2252 || (_path2252 = /*#__PURE__*/React.createElement("path", {
    d: "M162.274 732.032L154.593 729.419L153.939 731.342L161.62 733.954L162.274 732.032Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2253 || (_path2253 = /*#__PURE__*/React.createElement("path", {
    d: "M179.908 736.493L172.263 733.892L171.612 735.804L179.258 738.404L179.908 736.493Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2254 || (_path2254 = /*#__PURE__*/React.createElement("path", {
    d: "M200.099 739.167L192.548 736.598L191.905 738.487L199.457 741.055L200.099 739.167Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2255 || (_path2255 = /*#__PURE__*/React.createElement("path", {
    d: "M226.007 737.472L218.693 734.985L218.071 736.816L225.384 739.304L226.007 737.472Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2256 || (_path2256 = /*#__PURE__*/React.createElement("path", {
    d: "M255.181 732.296L248.208 729.924L247.615 731.668L254.588 734.04L255.181 732.296Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2257 || (_path2257 = /*#__PURE__*/React.createElement("path", {
    d: "M279.407 729.463L272.68 727.175L272.108 728.856L278.836 731.144L279.407 729.463Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2258 || (_path2258 = /*#__PURE__*/React.createElement("path", {
    d: "M300.776 727.851L294.251 725.632L293.696 727.264L300.221 729.483L300.776 727.851Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2259 || (_path2259 = /*#__PURE__*/React.createElement("path", {
    d: "M319.008 728.119L312.618 725.946L312.074 727.547L318.464 729.72L319.008 728.119Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2260 || (_path2260 = /*#__PURE__*/React.createElement("path", {
    d: "M331.003 733.991L324.572 731.803L324.025 733.412L330.456 735.599L331.003 733.991Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2261 || (_path2261 = /*#__PURE__*/React.createElement("path", {
    d: "M335.809 748.119L329.098 745.837L328.527 747.515L335.238 749.798L335.809 748.119Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2262 || (_path2262 = /*#__PURE__*/React.createElement("path", {
    d: "M343.018 761.149L336.065 758.784L335.474 760.522L342.426 762.887L343.018 761.149Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2263 || (_path2263 = /*#__PURE__*/React.createElement("path", {
    d: "M356.585 767.297L349.599 764.921L349.005 766.667L355.991 769.043L356.585 767.297Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2264 || (_path2264 = /*#__PURE__*/React.createElement("path", {
    d: "M372.526 770.184L365.597 767.827L365.008 769.56L371.937 771.917L372.526 770.184Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2265 || (_path2265 = /*#__PURE__*/React.createElement("path", {
    d: "M387.15 774.784L380.231 772.431L379.642 774.161L386.561 776.515L387.15 774.784Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2266 || (_path2266 = /*#__PURE__*/React.createElement("path", {
    d: "M402.346 778.228L395.466 775.888L394.88 777.61L401.76 779.95L402.346 778.228Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2267 || (_path2267 = /*#__PURE__*/React.createElement("path", {
    d: "M420.646 774.69L413.986 772.425L413.42 774.09L420.08 776.356L420.646 774.69Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2268 || (_path2268 = /*#__PURE__*/React.createElement("path", {
    d: "M439.413 767.474L433.057 765.312L432.517 766.899L438.873 769.061L439.413 767.474Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2269 || (_path2269 = /*#__PURE__*/React.createElement("path", {
    d: "M455.532 763.738L449.386 761.647L448.864 763.183L455.01 765.274L455.532 763.738Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2270 || (_path2270 = /*#__PURE__*/React.createElement("path", {
    d: "M469.786 763.13L463.761 761.081L463.25 762.586L469.274 764.635L469.786 763.13Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2271 || (_path2271 = /*#__PURE__*/React.createElement("path", {
    d: "M483.344 763.131L477.423 761.118L476.92 762.596L482.841 764.61L483.344 763.131Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2272 || (_path2272 = /*#__PURE__*/React.createElement("path", {
    d: "M495.715 767.157L489.797 765.144L489.294 766.622L495.212 768.635L495.715 767.157Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2273 || (_path2273 = /*#__PURE__*/React.createElement("path", {
    d: "M508.14 770.523L502.245 768.518L501.743 769.994L507.638 771.999L508.14 770.523Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2274 || (_path2274 = /*#__PURE__*/React.createElement("path", {
    d: "M521.067 766.677L515.354 764.734L514.869 766.161L520.582 768.104L521.067 766.677Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2275 || (_path2275 = /*#__PURE__*/React.createElement("path", {
    d: "M533.198 763.252L527.656 761.367L527.184 762.755L532.726 764.64L533.198 763.252Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2276 || (_path2276 = /*#__PURE__*/React.createElement("path", {
    d: "M544.495 751.805L539.298 750.037L538.856 751.337L544.053 753.104L544.495 751.805Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2277 || (_path2277 = /*#__PURE__*/React.createElement("path", {
    d: "M554.072 735.292L549.321 733.676L548.917 734.864L553.668 736.48L554.072 735.292Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2278 || (_path2278 = /*#__PURE__*/React.createElement("path", {
    d: "M562.008 720.152L557.659 718.673L557.289 719.76L561.638 721.239L562.008 720.152Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2279 || (_path2279 = /*#__PURE__*/React.createElement("path", {
    d: "M568.961 709.093L564.915 707.717L564.57 708.732L568.616 710.108L568.961 709.093Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2280 || (_path2280 = /*#__PURE__*/React.createElement("path", {
    d: "M574.998 699.414L571.217 698.128L570.895 699.075L574.676 700.361L574.998 699.414Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2281 || (_path2281 = /*#__PURE__*/React.createElement("path", {
    d: "M582.891 702.136L579.108 700.849L578.786 701.796L582.569 703.083L582.891 702.136Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2282 || (_path2282 = /*#__PURE__*/React.createElement("path", {
    d: "M592.828 712.418L588.889 711.078L588.554 712.062L592.494 713.401L592.828 712.418Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2283 || (_path2283 = /*#__PURE__*/React.createElement("path", {
    d: "M601.413 716.441L597.45 715.093L597.113 716.084L601.076 717.432L601.413 716.441Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2284 || (_path2284 = /*#__PURE__*/React.createElement("path", {
    d: "M609.159 717.767L605.224 716.429L604.89 717.412L608.824 718.75L609.159 717.767Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2285 || (_path2285 = /*#__PURE__*/React.createElement("path", {
    d: "M617.028 719.691L613.109 718.358L612.776 719.339L616.694 720.672L617.028 719.691Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2286 || (_path2286 = /*#__PURE__*/React.createElement("path", {
    d: "M628.226 729.76L624.17 728.38L623.824 729.397L627.88 730.777L628.226 729.76Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2287 || (_path2287 = /*#__PURE__*/React.createElement("path", {
    d: "M642.288 745.071L637.993 743.611L637.628 744.685L641.923 746.145L642.288 745.071Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2288 || (_path2288 = /*#__PURE__*/React.createElement("path", {
    d: "M653.932 753.668L649.528 752.17L649.154 753.27L653.558 754.768L653.932 753.668Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2289 || (_path2289 = /*#__PURE__*/React.createElement("path", {
    d: "M659.253 749.345L654.99 747.895L654.627 748.961L658.891 750.411L659.253 749.345Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2290 || (_path2290 = /*#__PURE__*/React.createElement("path", {
    d: "M670.881 757.387L666.526 755.906L666.157 756.993L670.511 758.473L670.881 757.387Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2291 || (_path2291 = /*#__PURE__*/React.createElement("path", {
    d: "M694.747 786.041L689.928 784.402L689.518 785.608L694.336 787.247L694.747 786.041Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2292 || (_path2292 = /*#__PURE__*/React.createElement("path", {
    d: "M721.669 817.21L716.355 815.403L715.903 816.731L721.217 818.538L721.669 817.21Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2293 || (_path2293 = /*#__PURE__*/React.createElement("path", {
    d: "M745.304 840.683L739.642 838.758L739.161 840.174L744.822 842.099L745.304 840.683Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2294 || (_path2294 = /*#__PURE__*/React.createElement("path", {
    d: "M767.034 859.613L761.111 857.599L760.608 859.077L766.532 861.092L767.034 859.613Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2295 || (_path2295 = /*#__PURE__*/React.createElement("path", {
    d: "M787.458 875.471L781.338 873.389L780.817 874.92L786.938 877.001L787.458 875.471Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2296 || (_path2296 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1624 712.112L31.3954 709.47L30.7345 711.413L38.5015 714.055L39.1624 712.112Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2297 || (_path2297 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8248 723.127L33.8425 720.412L33.1632 722.409L41.1454 725.124L41.8248 723.127Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2298 || (_path2298 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2214 730.616L46.1692 727.878L45.4845 729.89L53.5368 732.629L54.2214 730.616Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2299 || (_path2299 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6854 730.02L76.8639 727.36L76.1995 729.313L84.021 731.974L84.6854 730.02Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2300 || (_path2300 = /*#__PURE__*/React.createElement("path", {
    d: "M112.02 730.143L104.398 727.551L103.75 729.457L111.372 732.049L112.02 730.143Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2301 || (_path2301 = /*#__PURE__*/React.createElement("path", {
    d: "M123.587 737.802L115.882 735.181L115.227 737.108L122.931 739.729L123.587 737.802Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2302 || (_path2302 = /*#__PURE__*/React.createElement("path", {
    d: "M130.358 748.425L122.477 745.745L121.807 747.714L129.688 750.394L130.358 748.425Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2303 || (_path2303 = /*#__PURE__*/React.createElement("path", {
    d: "M143.953 755.691L136.015 752.992L135.34 754.976L143.278 757.676L143.953 755.691Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2304 || (_path2304 = /*#__PURE__*/React.createElement("path", {
    d: "M164.378 758.844L156.52 756.172L155.852 758.135L163.71 760.808L164.378 758.844Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2305 || (_path2305 = /*#__PURE__*/React.createElement("path", {
    d: "M187.784 759.63L180.079 757.01L179.424 758.937L187.128 761.558L187.784 759.63Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2306 || (_path2306 = /*#__PURE__*/React.createElement("path", {
    d: "M215.436 756.642L207.998 754.113L207.367 755.97L214.804 758.5L215.436 756.642Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2307 || (_path2307 = /*#__PURE__*/React.createElement("path", {
    d: "M249.258 747.594L242.258 745.214L241.663 746.965L248.662 749.345L249.258 747.594Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2308 || (_path2308 = /*#__PURE__*/React.createElement("path", {
    d: "M275.451 742.796L268.747 740.516L268.177 742.192L274.881 744.472L275.451 742.796Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2309 || (_path2309 = /*#__PURE__*/React.createElement("path", {
    d: "M297.503 740.222L291.017 738.016L290.465 739.64L296.951 741.846L297.503 740.222Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2310 || (_path2310 = /*#__PURE__*/React.createElement("path", {
    d: "M316.756 739.208L310.428 737.056L309.891 738.635L316.218 740.787L316.756 739.208Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2311 || (_path2311 = /*#__PURE__*/React.createElement("path", {
    d: "M327.482 746.3L321.079 744.122L320.535 745.723L326.938 747.901L327.482 746.3Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2312 || (_path2312 = /*#__PURE__*/React.createElement("path", {
    d: "M325.2 768.865L318.299 766.518L317.713 768.243L324.614 770.59L325.2 768.865Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2313 || (_path2313 = /*#__PURE__*/React.createElement("path", {
    d: "M329.775 786.125L322.537 783.663L321.921 785.474L329.159 787.935L329.775 786.125Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2314 || (_path2314 = /*#__PURE__*/React.createElement("path", {
    d: "M347.947 786.96L340.826 784.538L340.221 786.318L347.342 788.74L347.947 786.96Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2315 || (_path2315 = /*#__PURE__*/React.createElement("path", {
    d: "M369.092 782.358L362.225 780.022L361.64 781.742L368.507 784.078L369.092 782.358Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2316 || (_path2316 = /*#__PURE__*/React.createElement("path", {
    d: "M383.881 786.419L377.032 784.089L376.449 785.804L383.298 788.133L383.881 786.419Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2317 || (_path2317 = /*#__PURE__*/React.createElement("path", {
    d: "M397.484 792.541L390.604 790.201L390.018 791.924L396.898 794.264L397.484 792.541Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2318 || (_path2318 = /*#__PURE__*/React.createElement("path", {
    d: "M415.726 789.004L409.053 786.734L408.486 788.402L415.158 790.672L415.726 789.004Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2319 || (_path2319 = /*#__PURE__*/React.createElement("path", {
    d: "M435.775 778.586L429.471 776.441L428.935 778.019L435.239 780.163L435.775 778.586Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2320 || (_path2320 = /*#__PURE__*/React.createElement("path", {
    d: "M452.827 771.81L446.792 769.758L446.279 771.267L452.314 773.32L452.827 771.81Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2321 || (_path2321 = /*#__PURE__*/React.createElement("path", {
    d: "M467.543 768.798L461.679 766.804L461.181 768.27L467.044 770.264L467.543 768.798Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2322 || (_path2322 = /*#__PURE__*/React.createElement("path", {
    d: "M481.858 764.224L476.197 762.298L475.715 763.714L481.376 765.64L481.858 764.224Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2323 || (_path2323 = /*#__PURE__*/React.createElement("path", {
    d: "M494.373 764.417L488.802 762.522L488.328 763.915L493.899 765.81L494.373 764.417Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2324 || (_path2324 = /*#__PURE__*/React.createElement("path", {
    d: "M506.148 767.191L500.601 765.305L500.129 766.693L505.676 768.579L506.148 767.191Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2325 || (_path2325 = /*#__PURE__*/React.createElement("path", {
    d: "M518.324 764.355L512.927 762.52L512.469 763.868L517.865 765.704L518.324 764.355Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2326 || (_path2326 = /*#__PURE__*/React.createElement("path", {
    d: "M529.895 761.029L524.653 759.246L524.208 760.556L529.449 762.339L529.895 761.029Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2327 || (_path2327 = /*#__PURE__*/React.createElement("path", {
    d: "M540.81 749.955L535.886 748.28L535.466 749.512L540.391 751.187L540.81 749.955Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2328 || (_path2328 = /*#__PURE__*/React.createElement("path", {
    d: "M550.254 734.966L545.718 733.423L545.333 734.557L549.869 736.1L550.254 734.966Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2329 || (_path2329 = /*#__PURE__*/React.createElement("path", {
    d: "M558.273 721.683L554.079 720.257L553.723 721.305L557.916 722.731L558.273 721.683Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2330 || (_path2330 = /*#__PURE__*/React.createElement("path", {
    d: "M565.331 711.555L561.405 710.219L561.072 711.2L564.998 712.535L565.331 711.555Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2331 || (_path2331 = /*#__PURE__*/React.createElement("path", {
    d: "M571.863 704.599L568.134 703.331L567.817 704.262L571.547 705.53L571.863 704.599Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2332 || (_path2332 = /*#__PURE__*/React.createElement("path", {
    d: "M581.655 716.982L577.732 715.648L577.399 716.626L581.323 717.96L581.655 716.982Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2333 || (_path2333 = /*#__PURE__*/React.createElement("path", {
    d: "M594.388 738.362L590.104 736.905L589.739 737.977L594.024 739.434L594.388 738.362Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2334 || (_path2334 = /*#__PURE__*/React.createElement("path", {
    d: "M604.77 746.527L600.385 745.036L600.012 746.13L604.398 747.622L604.77 746.527Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2335 || (_path2335 = /*#__PURE__*/React.createElement("path", {
    d: "M613.113 747.145L608.776 745.67L608.408 746.754L612.744 748.229L613.113 747.145Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2336 || (_path2336 = /*#__PURE__*/React.createElement("path", {
    d: "M621.494 748.354L617.192 746.891L616.825 747.968L621.128 749.431L621.494 748.354Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2337 || (_path2337 = /*#__PURE__*/React.createElement("path", {
    d: "M632.96 757.857L628.538 756.353L628.163 757.458L632.584 758.962L632.96 757.857Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2338 || (_path2338 = /*#__PURE__*/React.createElement("path", {
    d: "M646.359 770.94L641.756 769.375L641.365 770.524L645.968 772.09L646.359 770.94Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2339 || (_path2339 = /*#__PURE__*/React.createElement("path", {
    d: "M656.383 775.154L651.759 773.582L651.367 774.736L655.991 776.309L656.383 775.154Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2340 || (_path2340 = /*#__PURE__*/React.createElement("path", {
    d: "M659.122 764.2L654.755 762.715L654.384 763.807L658.751 765.292L659.122 764.2Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2341 || (_path2341 = /*#__PURE__*/React.createElement("path", {
    d: "M668.384 767.602L664.009 766.114L663.637 767.208L668.012 768.696L668.384 767.602Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2342 || (_path2342 = /*#__PURE__*/React.createElement("path", {
    d: "M690.574 794.693L685.782 793.063L685.374 794.262L690.167 795.892L690.574 794.693Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2343 || (_path2343 = /*#__PURE__*/React.createElement("path", {
    d: "M716.202 825.321L710.94 823.532L710.493 824.847L715.755 826.636L716.202 825.321Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2344 || (_path2344 = /*#__PURE__*/React.createElement("path", {
    d: "M739.099 848.844L733.5 846.94L733.024 848.341L738.623 850.245L739.099 848.844Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2345 || (_path2345 = /*#__PURE__*/React.createElement("path", {
    d: "M760.992 869.025L755.118 867.027L754.619 868.495L760.493 870.493L760.992 869.025Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2346 || (_path2346 = /*#__PURE__*/React.createElement("path", {
    d: "M781.539 885.821L775.455 883.752L774.938 885.272L781.022 887.341L781.539 885.821Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2347 || (_path2347 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5684 717.652L52.1956 715.144L51.5691 716.986L58.942 719.493L59.5684 717.652Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2348 || (_path2348 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4651 729.61L51.8485 727.019L51.2009 728.923L58.8175 731.514L59.4651 729.61Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2349 || (_path2349 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7738 738.037L61.0509 735.411L60.3936 737.343L68.1165 739.97L68.7738 738.037Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2350 || (_path2350 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0386 737.536L89.5205 734.979L88.8809 736.859L96.3989 739.416L97.0386 737.536Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2351 || (_path2351 = /*#__PURE__*/React.createElement("path", {
    d: "M120.636 738.728L113.258 736.219L112.631 738.063L120.009 740.573L120.636 738.728Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2352 || (_path2352 = /*#__PURE__*/React.createElement("path", {
    d: "M126.8 749.053L119.253 746.486L118.612 748.372L126.158 750.939L126.8 749.053Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2353 || (_path2353 = /*#__PURE__*/React.createElement("path", {
    d: "M128.558 762.622L120.747 759.966L120.083 761.919L127.894 764.576L128.558 762.622Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2354 || (_path2354 = /*#__PURE__*/React.createElement("path", {
    d: "M138.051 772.406L130.108 769.705L129.432 771.692L137.375 774.393L138.051 772.406Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2355 || (_path2355 = /*#__PURE__*/React.createElement("path", {
    d: "M154.824 777.883L146.886 775.183L146.21 777.17L154.148 779.87L154.824 777.883Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2356 || (_path2356 = /*#__PURE__*/React.createElement("path", {
    d: "M176.001 780.194L168.162 777.528L167.495 779.489L175.334 782.155L176.001 780.194Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2357 || (_path2357 = /*#__PURE__*/React.createElement("path", {
    d: "M202.678 777.853L195.072 775.266L194.425 777.167L202.032 779.754L202.678 777.853Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2358 || (_path2358 = /*#__PURE__*/React.createElement("path", {
    d: "M235.289 769.542L228.079 767.09L227.466 768.893L234.676 771.345L235.289 769.542Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2359 || (_path2359 = /*#__PURE__*/React.createElement("path", {
    d: "M262.407 764.04L255.496 761.689L254.909 763.417L261.82 765.767L262.407 764.04Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2360 || (_path2360 = /*#__PURE__*/React.createElement("path", {
    d: "M286.853 759.455L280.206 757.194L279.641 758.857L286.287 761.118L286.853 759.455Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2361 || (_path2361 = /*#__PURE__*/React.createElement("path", {
    d: "M308.421 756.305L301.989 754.117L301.441 755.728L307.873 757.916L308.421 756.305Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2362 || (_path2362 = /*#__PURE__*/React.createElement("path", {
    d: "M321.344 761.395L314.9 759.203L314.351 760.817L320.795 763.008L321.344 761.395Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2363 || (_path2363 = /*#__PURE__*/React.createElement("path", {
    d: "M322.635 780.473L315.805 778.149L315.224 779.856L322.055 782.179L322.635 780.473Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2364 || (_path2364 = /*#__PURE__*/React.createElement("path", {
    d: "M328.486 796.21L321.378 793.792L320.772 795.571L327.881 797.989L328.486 796.21Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2365 || (_path2365 = /*#__PURE__*/React.createElement("path", {
    d: "M344.711 799.222L337.652 796.821L337.053 798.585L344.112 800.986L344.711 799.222Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2366 || (_path2366 = /*#__PURE__*/React.createElement("path", {
    d: "M363.626 797.612L356.733 795.268L356.146 796.993L363.039 799.337L363.626 797.612Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2367 || (_path2367 = /*#__PURE__*/React.createElement("path", {
    d: "M378.42 801.744L371.548 799.406L370.963 801.126L377.835 803.464L378.42 801.744Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2368 || (_path2368 = /*#__PURE__*/React.createElement("path", {
    d: "M393.257 805.615L386.408 803.285L385.825 805L392.674 807.33L393.257 805.615Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2369 || (_path2369 = /*#__PURE__*/React.createElement("path", {
    d: "M412.548 799.52L405.956 797.278L405.395 798.928L411.987 801.17L412.548 799.52Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2370 || (_path2370 = /*#__PURE__*/React.createElement("path", {
    d: "M433.657 785.885L427.49 783.787L426.965 785.331L433.132 787.428L433.657 785.885Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2371 || (_path2371 = /*#__PURE__*/React.createElement("path", {
    d: "M451.822 775.005L446.002 773.025L445.506 774.483L451.326 776.462L451.822 775.005Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2372 || (_path2372 = /*#__PURE__*/React.createElement("path", {
    d: "M466.763 769.618L461.156 767.711L460.679 769.115L466.286 771.022L466.763 769.618Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2373 || (_path2373 = /*#__PURE__*/React.createElement("path", {
    d: "M480.808 763.968L475.414 762.133L474.955 763.482L480.349 765.317L480.808 763.968Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2374 || (_path2374 = /*#__PURE__*/React.createElement("path", {
    d: "M492.884 763.502L487.586 761.7L487.135 763.026L492.433 764.828L492.884 763.502Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2375 || (_path2375 = /*#__PURE__*/React.createElement("path", {
    d: "M503.855 767.74L498.546 765.934L498.094 767.265L503.402 769.071L503.855 767.74Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2376 || (_path2376 = /*#__PURE__*/React.createElement("path", {
    d: "M515.162 769.135L509.903 767.346L509.456 768.661L514.715 770.45L515.162 769.135Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2377 || (_path2377 = /*#__PURE__*/React.createElement("path", {
    d: "M526.463 766.984L521.323 765.236L520.886 766.52L526.026 768.268L526.463 766.984Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2378 || (_path2378 = /*#__PURE__*/React.createElement("path", {
    d: "M537.362 757.014L532.502 755.361L532.088 756.577L536.948 758.23L537.362 757.014Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2379 || (_path2379 = /*#__PURE__*/React.createElement("path", {
    d: "M547.027 743.876L542.501 742.337L542.116 743.471L546.641 745.01L547.027 743.876Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2380 || (_path2380 = /*#__PURE__*/React.createElement("path", {
    d: "M555.486 733.119L551.238 731.674L550.876 732.738L555.124 734.183L555.486 733.119Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2381 || (_path2381 = /*#__PURE__*/React.createElement("path", {
    d: "M563.353 727.17L559.284 725.786L558.938 726.803L563.007 728.187L563.353 727.17Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2382 || (_path2382 = /*#__PURE__*/React.createElement("path", {
    d: "M570.974 724.22L567.019 722.875L566.683 723.863L570.638 725.208L570.974 724.22Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2383 || (_path2383 = /*#__PURE__*/React.createElement("path", {
    d: "M580.718 735.085L576.608 733.687L576.257 734.717L580.368 736.115L580.718 735.085Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2384 || (_path2384 = /*#__PURE__*/React.createElement("path", {
    d: "M592.757 753.595L588.351 752.097L587.977 753.197L592.383 754.695L592.757 753.595Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2385 || (_path2385 = /*#__PURE__*/React.createElement("path", {
    d: "M603.558 763.011L599.036 761.473L598.651 762.604L603.174 764.142L603.558 763.011Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2386 || (_path2386 = /*#__PURE__*/React.createElement("path", {
    d: "M612.012 762.902L607.549 761.384L607.169 762.502L611.632 764.02L612.012 762.902Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2387 || (_path2387 = /*#__PURE__*/React.createElement("path", {
    d: "M620.477 763.544L616.06 762.042L615.685 763.144L620.102 764.647L620.477 763.544Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2388 || (_path2388 = /*#__PURE__*/React.createElement("path", {
    d: "M632.149 773.537L627.611 771.993L627.225 773.127L631.764 774.67L632.149 773.537Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2389 || (_path2389 = /*#__PURE__*/React.createElement("path", {
    d: "M645.708 787.196L640.983 785.589L640.581 786.772L645.306 788.379L645.708 787.196Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2390 || (_path2390 = /*#__PURE__*/React.createElement("path", {
    d: "M656.277 792.26L651.523 790.644L651.119 791.832L655.873 793.448L656.277 792.26Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2391 || (_path2391 = /*#__PURE__*/React.createElement("path", {
    d: "M661.807 786.012L657.22 784.451L656.83 785.598L661.417 787.158L661.807 786.012Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2392 || (_path2392 = /*#__PURE__*/React.createElement("path", {
    d: "M672.279 791.148L667.66 789.577L667.268 790.731L671.886 792.302L672.279 791.148Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2393 || (_path2393 = /*#__PURE__*/React.createElement("path", {
    d: "M691.486 813.06L686.553 811.382L686.133 812.617L691.066 814.294L691.486 813.06Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2394 || (_path2394 = /*#__PURE__*/React.createElement("path", {
    d: "M712.408 836.169L707.149 834.38L706.702 835.695L711.961 837.484L712.408 836.169Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2395 || (_path2395 = /*#__PURE__*/React.createElement("path", {
    d: "M732.569 856.024L727.045 854.145L726.575 855.527L732.099 857.406L732.569 856.024Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2396 || (_path2396 = /*#__PURE__*/React.createElement("path", {
    d: "M754.623 877.57L748.811 875.593L748.317 877.046L754.129 879.022L754.623 877.57Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2397 || (_path2397 = /*#__PURE__*/React.createElement("path", {
    d: "M775.764 896.149L769.719 894.093L769.205 895.605L775.25 897.661L775.764 896.149Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2398 || (_path2398 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7812 722.74L70.7637 720.354L70.1672 722.107L77.1848 724.494L77.7812 722.74Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2399 || (_path2399 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4375 735.113L69.1709 732.642L68.5525 734.46L75.819 736.932L76.4375 735.113Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2400 || (_path2400 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9147 743.527L77.5418 741.019L76.9154 742.861L84.2882 745.369L84.9147 743.527Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2401 || (_path2401 = /*#__PURE__*/React.createElement("path", {
    d: "M114.087 741.574L106.945 739.145L106.338 740.93L113.48 743.359L114.087 741.574Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2402 || (_path2402 = /*#__PURE__*/React.createElement("path", {
    d: "M135.69 742.931L128.664 740.541L128.068 742.295L135.093 744.684L135.69 742.931Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2403 || (_path2403 = /*#__PURE__*/React.createElement("path", {
    d: "M136.401 756.049L129.124 753.574L128.505 755.395L135.782 757.87L136.401 756.049Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2404 || (_path2404 = /*#__PURE__*/React.createElement("path", {
    d: "M132.889 772.772L125.265 770.179L124.616 772.086L132.241 774.679L132.889 772.772Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2405 || (_path2405 = /*#__PURE__*/React.createElement("path", {
    d: "M137.816 785.399L129.979 782.734L129.312 784.692L137.15 787.358L137.816 785.399Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2406 || (_path2406 = /*#__PURE__*/React.createElement("path", {
    d: "M149.902 793.929L141.977 791.234L141.303 793.216L149.228 795.911L149.902 793.929Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2407 || (_path2407 = /*#__PURE__*/React.createElement("path", {
    d: "M167.992 798.366L160.101 795.682L159.429 797.656L167.321 800.34L167.992 798.366Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2408 || (_path2408 = /*#__PURE__*/React.createElement("path", {
    d: "M192.974 797.147L185.272 794.527L184.616 796.455L192.318 799.074L192.974 797.147Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2409 || (_path2409 = /*#__PURE__*/React.createElement("path", {
    d: "M223.213 790.509L215.84 788.002L215.214 789.844L222.586 792.351L223.213 790.509Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2410 || (_path2410 = /*#__PURE__*/React.createElement("path", {
    d: "M251.457 783.969L244.398 781.568L243.798 783.332L250.857 785.733L251.457 783.969Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2411 || (_path2411 = /*#__PURE__*/React.createElement("path", {
    d: "M279.305 776.084L272.588 773.8L272.017 775.478L278.734 777.763L279.305 776.084Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2412 || (_path2412 = /*#__PURE__*/React.createElement("path", {
    d: "M303.757 769.829L297.32 767.64L296.773 769.251L303.209 771.44L303.757 769.829Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2413 || (_path2413 = /*#__PURE__*/React.createElement("path", {
    d: "M319.158 772.118L312.778 769.948L312.236 771.544L318.615 773.713L319.158 772.118Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2414 || (_path2414 = /*#__PURE__*/React.createElement("path", {
    d: "M325.396 785.33L318.801 783.087L318.24 784.737L324.835 786.98L325.396 785.33Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2415 || (_path2415 = /*#__PURE__*/React.createElement("path", {
    d: "M332.132 799.38L325.309 797.06L324.729 798.766L331.552 801.087L332.132 799.38Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2416 || (_path2416 = /*#__PURE__*/React.createElement("path", {
    d: "M343.692 808.105L336.776 805.752L336.188 807.48L343.105 809.832L343.692 808.105Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2417 || (_path2417 = /*#__PURE__*/React.createElement("path", {
    d: "M357.892 813.339L350.968 810.984L350.379 812.715L357.303 815.07L357.892 813.339Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2418 || (_path2418 = /*#__PURE__*/React.createElement("path", {
    d: "M372.587 817.773L365.673 815.421L365.085 817.149L371.999 819.5L372.587 817.773Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2419 || (_path2419 = /*#__PURE__*/React.createElement("path", {
    d: "M389.478 817.773L382.675 815.459L382.096 817.164L388.898 819.477L389.478 817.773Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2420 || (_path2420 = /*#__PURE__*/React.createElement("path", {
    d: "M410.261 807.998L403.788 805.796L403.237 807.415L409.71 809.616L410.261 807.998Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2421 || (_path2421 = /*#__PURE__*/React.createElement("path", {
    d: "M432.763 790.038L426.785 788.004L426.277 789.499L432.255 791.532L432.763 790.038Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2422 || (_path2422 = /*#__PURE__*/React.createElement("path", {
    d: "M452.499 773.345L446.98 771.468L446.511 772.848L452.029 774.725L452.499 773.345Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2423 || (_path2423 = /*#__PURE__*/React.createElement("path", {
    d: "M467.553 765.323L462.291 763.533L461.844 764.849L467.105 766.638L467.553 765.323Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2424 || (_path2424 = /*#__PURE__*/React.createElement("path", {
    d: "M480.864 759.677L475.799 757.955L475.369 759.221L480.433 760.943L480.864 759.677Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2425 || (_path2425 = /*#__PURE__*/React.createElement("path", {
    d: "M492.113 759.839L487.118 758.141L486.694 759.388L491.689 761.087L492.113 759.839Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2426 || (_path2426 = /*#__PURE__*/React.createElement("path", {
    d: "M501.744 768.29L496.651 766.557L496.217 767.831L501.311 769.563L501.744 768.29Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2427 || (_path2427 = /*#__PURE__*/React.createElement("path", {
    d: "M511.601 778.611L506.37 776.832L505.925 778.139L511.156 779.919L511.601 778.611Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2428 || (_path2428 = /*#__PURE__*/React.createElement("path", {
    d: "M522.727 779.09L517.559 777.333L517.119 778.624L522.288 780.382L522.727 779.09Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2429 || (_path2429 = /*#__PURE__*/React.createElement("path", {
    d: "M533.818 770.777L528.886 769.099L528.466 770.334L533.398 772.012L533.818 770.777Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2430 || (_path2430 = /*#__PURE__*/React.createElement("path", {
    d: "M543.903 759.663L539.255 758.083L538.861 759.242L543.508 760.823L543.903 759.663Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2431 || (_path2431 = /*#__PURE__*/React.createElement("path", {
    d: "M552.956 751.097L548.534 749.593L548.159 750.695L552.581 752.199L552.956 751.097Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2432 || (_path2432 = /*#__PURE__*/React.createElement("path", {
    d: "M561.765 749.798L557.429 748.323L557.06 749.407L561.396 750.882L561.765 749.798Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2433 || (_path2433 = /*#__PURE__*/React.createElement("path", {
    d: "M570.548 750.915L566.246 749.452L565.881 750.526L570.183 751.989L570.548 750.915Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2434 || (_path2434 = /*#__PURE__*/React.createElement("path", {
    d: "M579.653 754.829L575.338 753.361L574.971 754.44L579.286 755.908L579.653 754.829Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2435 || (_path2435 = /*#__PURE__*/React.createElement("path", {
    d: "M589.777 763.507L585.358 762.004L584.983 763.107L589.402 764.61L589.777 763.507Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2436 || (_path2436 = /*#__PURE__*/React.createElement("path", {
    d: "M600.109 771.417L595.604 769.885L595.222 771.011L599.726 772.543L600.109 771.417Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2437 || (_path2437 = /*#__PURE__*/React.createElement("path", {
    d: "M607.61 767.619L603.23 766.129L602.858 767.224L607.238 768.714L607.61 767.619Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2438 || (_path2438 = /*#__PURE__*/React.createElement("path", {
    d: "M615.422 766.377L611.117 764.913L610.751 765.99L615.056 767.454L615.422 766.377Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2439 || (_path2439 = /*#__PURE__*/React.createElement("path", {
    d: "M627.201 777.819L622.751 776.305L622.371 777.42L626.821 778.934L627.201 777.819Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2440 || (_path2440 = /*#__PURE__*/React.createElement("path", {
    d: "M641.427 794.483L636.746 792.891L636.349 794.061L641.03 795.653L641.427 794.483Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2441 || (_path2441 = /*#__PURE__*/React.createElement("path", {
    d: "M653.775 804.346L648.982 802.716L648.576 803.912L653.368 805.542L653.775 804.346Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2442 || (_path2442 = /*#__PURE__*/React.createElement("path", {
    d: "M664.919 810.458L660.082 808.813L659.671 810.021L664.508 811.666L664.919 810.458Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2443 || (_path2443 = /*#__PURE__*/React.createElement("path", {
    d: "M678.524 821.617L673.56 819.929L673.137 821.171L678.101 822.859L678.524 821.617Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2444 || (_path2444 = /*#__PURE__*/React.createElement("path", {
    d: "M693.958 835.641L688.823 833.895L688.386 835.179L693.521 836.925L693.958 835.641Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2445 || (_path2445 = /*#__PURE__*/React.createElement("path", {
    d: "M708.007 845.817L702.769 844.036L702.323 845.346L707.562 847.127L708.007 845.817Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2446 || (_path2446 = /*#__PURE__*/React.createElement("path", {
    d: "M724.229 859.346L718.832 857.51L718.374 858.859L723.77 860.695L724.229 859.346Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2447 || (_path2447 = /*#__PURE__*/React.createElement("path", {
    d: "M746.92 883.366L741.206 881.423L740.721 882.849L746.434 884.793L746.92 883.366Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2448 || (_path2448 = /*#__PURE__*/React.createElement("path", {
    d: "M769.346 905.152L763.358 903.115L762.848 904.614L768.836 906.651L769.346 905.152Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2449 || (_path2449 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2353 725.544L91.6016 723.288L91.0369 724.948L97.6706 727.204L98.2353 725.544Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2450 || (_path2450 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9399 737.664L90.0727 735.328L89.4878 737.048L96.3549 739.384L96.9399 737.664Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2451 || (_path2451 = /*#__PURE__*/React.createElement("path", {
    d: "M105.309 745.613L98.3434 743.244L97.7514 744.984L104.717 747.354L105.309 745.613Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2452 || (_path2452 = /*#__PURE__*/React.createElement("path", {
    d: "M132.542 743.568L125.789 741.271L125.215 742.96L131.968 745.257L132.542 743.568Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2453 || (_path2453 = /*#__PURE__*/React.createElement("path", {
    d: "M150.091 746.339L143.398 744.062L142.829 745.735L149.522 748.012L150.091 746.339Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2454 || (_path2454 = /*#__PURE__*/React.createElement("path", {
    d: "M146.12 762.081L139.108 759.696L138.511 761.449L145.523 763.834L146.12 762.081Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2455 || (_path2455 = /*#__PURE__*/React.createElement("path", {
    d: "M138.394 781.573L130.969 779.048L130.338 780.902L137.763 783.428L138.394 781.573Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2456 || (_path2456 = /*#__PURE__*/React.createElement("path", {
    d: "M139.055 797.05L131.348 794.429L130.692 796.356L138.4 798.977L139.055 797.05Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2457 || (_path2457 = /*#__PURE__*/React.createElement("path", {
    d: "M146.803 808.596L138.929 805.918L138.261 807.885L146.134 810.562L146.803 808.596Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2458 || (_path2458 = /*#__PURE__*/React.createElement("path", {
    d: "M161.992 815.123L154.095 812.437L153.423 814.413L161.32 817.099L161.992 815.123Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2459 || (_path2459 = /*#__PURE__*/React.createElement("path", {
    d: "M186.359 814.155L178.631 811.526L177.974 813.459L185.702 816.087L186.359 814.155Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2460 || (_path2460 = /*#__PURE__*/React.createElement("path", {
    d: "M217.438 806.356L210.052 803.844L209.425 805.688L216.811 808.2L217.438 806.356Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2461 || (_path2461 = /*#__PURE__*/React.createElement("path", {
    d: "M247.851 797.353L240.826 794.963L240.228 796.719L247.254 799.109L247.851 797.353Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2462 || (_path2462 = /*#__PURE__*/React.createElement("path", {
    d: "M277.755 786.824L271.116 784.566L270.551 786.229L277.19 788.487L277.755 786.824Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2463 || (_path2463 = /*#__PURE__*/React.createElement("path", {
    d: "M303.52 778.523L297.2 776.374L296.662 777.954L302.982 780.103L303.52 778.523Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2464 || (_path2464 = /*#__PURE__*/React.createElement("path", {
    d: "M319.605 779.575L313.365 777.453L312.835 779.012L319.075 781.134L319.605 779.575Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2465 || (_path2465 = /*#__PURE__*/React.createElement("path", {
    d: "M326.206 792.109L319.777 789.922L319.23 791.531L325.659 793.717L326.206 792.109Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2466 || (_path2466 = /*#__PURE__*/React.createElement("path", {
    d: "M331.567 807.729L324.879 805.454L324.31 807.127L330.998 809.402L331.567 807.729Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2467 || (_path2467 = /*#__PURE__*/React.createElement("path", {
    d: "M339.932 820.804L333.057 818.466L332.472 820.186L339.347 822.524L339.932 820.804Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2468 || (_path2468 = /*#__PURE__*/React.createElement("path", {
    d: "M351.573 830.089L344.594 827.715L344.001 829.459L350.98 831.832L351.573 830.089Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2469 || (_path2469 = /*#__PURE__*/React.createElement("path", {
    d: "M366.289 834.698L359.321 832.328L358.728 834.071L365.696 836.441L366.289 834.698Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2470 || (_path2470 = /*#__PURE__*/React.createElement("path", {
    d: "M384.453 832.352L377.642 830.036L377.063 831.74L383.873 834.056L384.453 832.352Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2471 || (_path2471 = /*#__PURE__*/React.createElement("path", {
    d: "M406.396 819.863L399.959 817.674L399.411 819.285L405.848 821.474L406.396 819.863Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2472 || (_path2472 = /*#__PURE__*/React.createElement("path", {
    d: "M429.727 799.465L423.814 797.454L423.312 798.93L429.225 800.941L429.727 799.465Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2473 || (_path2473 = /*#__PURE__*/React.createElement("path", {
    d: "M450.175 780.279L444.752 778.435L444.291 779.792L449.714 781.636L450.175 780.279Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2474 || (_path2474 = /*#__PURE__*/React.createElement("path", {
    d: "M465.58 770.434L460.437 768.685L460 769.972L465.142 771.721L465.58 770.434Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2475 || (_path2475 = /*#__PURE__*/React.createElement("path", {
    d: "M478.848 764.03L473.905 762.349L473.484 763.587L478.427 765.268L478.848 764.03Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2476 || (_path2476 = /*#__PURE__*/React.createElement("path", {
    d: "M489.761 764.535L484.883 762.876L484.467 764.098L489.345 765.757L489.761 764.535Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2477 || (_path2477 = /*#__PURE__*/React.createElement("path", {
    d: "M498.782 774.975L493.764 773.268L493.336 774.524L498.355 776.23L498.782 774.975Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2478 || (_path2478 = /*#__PURE__*/React.createElement("path", {
    d: "M508.044 788.295L502.839 786.525L502.396 787.827L507.601 789.597L508.044 788.295Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2479 || (_path2479 = /*#__PURE__*/React.createElement("path", {
    d: "M519.091 789.494L513.93 787.739L513.491 789.028L518.652 790.783L519.091 789.494Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2480 || (_path2480 = /*#__PURE__*/React.createElement("path", {
    d: "M530.318 781.119L525.388 779.443L524.969 780.675L529.899 782.351L530.318 781.119Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2481 || (_path2481 = /*#__PURE__*/React.createElement("path", {
    d: "M540.604 770.086L535.943 768.501L535.546 769.668L540.207 771.253L540.604 770.086Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2482 || (_path2482 = /*#__PURE__*/React.createElement("path", {
    d: "M549.894 762.057L545.438 760.542L545.06 761.655L549.515 763.17L549.894 762.057Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2483 || (_path2483 = /*#__PURE__*/React.createElement("path", {
    d: "M558.959 762.403L554.556 760.905L554.182 762.005L558.585 763.502L558.959 762.403Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2484 || (_path2484 = /*#__PURE__*/React.createElement("path", {
    d: "M568.225 766.399L563.808 764.897L563.433 765.999L567.85 767.501L568.225 766.399Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2485 || (_path2485 = /*#__PURE__*/React.createElement("path", {
    d: "M577.548 770.334L573.116 768.827L572.74 769.932L577.172 771.439L577.548 770.334Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2486 || (_path2486 = /*#__PURE__*/React.createElement("path", {
    d: "M587.423 777.012L582.931 775.484L582.549 776.608L587.041 778.135L587.423 777.012Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2487 || (_path2487 = /*#__PURE__*/React.createElement("path", {
    d: "M597.591 783.941L593.035 782.391L592.648 783.53L597.204 785.08L597.591 783.941Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2488 || (_path2488 = /*#__PURE__*/React.createElement("path", {
    d: "M605.069 779.029L600.647 777.525L600.272 778.627L604.694 780.131L605.069 779.029Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2489 || (_path2489 = /*#__PURE__*/React.createElement("path", {
    d: "M612.929 777.364L608.591 775.888L608.222 776.972L612.561 778.448L612.929 777.364Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2490 || (_path2490 = /*#__PURE__*/React.createElement("path", {
    d: "M624.91 789.869L620.414 788.34L620.032 789.463L624.528 790.993L624.91 789.869Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2491 || (_path2491 = /*#__PURE__*/React.createElement("path", {
    d: "M639.917 809.516L635.15 807.895L634.744 809.088L639.511 810.71L639.917 809.516Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2492 || (_path2492 = /*#__PURE__*/React.createElement("path", {
    d: "M654.167 824.504L649.211 822.819L648.789 824.059L653.745 825.744L654.167 824.504Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2493 || (_path2493 = /*#__PURE__*/React.createElement("path", {
    d: "M668.223 837.305L663.117 835.568L662.682 836.847L667.788 838.583L668.223 837.305Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2494 || (_path2494 = /*#__PURE__*/React.createElement("path", {
    d: "M683.056 850.69L677.796 848.902L677.349 850.217L682.608 852.006L683.056 850.69Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2495 || (_path2495 = /*#__PURE__*/React.createElement("path", {
    d: "M696.552 859.949L691.204 858.13L690.749 859.469L696.097 861.288L696.552 859.949Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2496 || (_path2496 = /*#__PURE__*/React.createElement("path", {
    d: "M706.939 862.177L701.615 860.366L701.162 861.699L706.486 863.51L706.939 862.177Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2497 || (_path2497 = /*#__PURE__*/React.createElement("path", {
    d: "M719.483 868.793L714.117 866.968L713.66 868.312L719.026 870.137L719.483 868.793Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2498 || (_path2498 = /*#__PURE__*/React.createElement("path", {
    d: "M738.912 887.907L733.31 886.001L732.834 887.402L738.435 889.307L738.912 887.907Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2499 || (_path2499 = /*#__PURE__*/React.createElement("path", {
    d: "M759.304 907.351L753.472 905.367L752.975 906.828L758.808 908.811L759.304 907.351Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2500 || (_path2500 = /*#__PURE__*/React.createElement("path", {
    d: "M132.565 720.217L126.51 718.157L125.995 719.67L132.051 721.729L132.565 720.217Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2501 || (_path2501 = /*#__PURE__*/React.createElement("path", {
    d: "M130.841 731.922L124.568 729.788L124.034 731.358L130.307 733.491L130.841 731.922Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2502 || (_path2502 = /*#__PURE__*/React.createElement("path", {
    d: "M137.471 739.881L131.096 737.713L130.554 739.309L136.928 741.477L137.471 739.881Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2503 || (_path2503 = /*#__PURE__*/React.createElement("path", {
    d: "M152.876 743.185L146.531 741.027L145.992 742.612L152.337 744.77L152.876 743.185Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2504 || (_path2504 = /*#__PURE__*/React.createElement("path", {
    d: "M159.923 751.425L153.476 749.232L152.928 750.843L159.375 753.036L159.923 751.425Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2505 || (_path2505 = /*#__PURE__*/React.createElement("path", {
    d: "M155.347 767.566L148.584 765.266L148.009 766.955L154.773 769.255L155.347 767.566Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2506 || (_path2506 = /*#__PURE__*/React.createElement("path", {
    d: "M150.554 785.197L143.446 782.779L142.841 784.559L149.949 786.976L150.554 785.197Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2507 || (_path2507 = /*#__PURE__*/React.createElement("path", {
    d: "M148.796 802.157L141.379 799.635L140.748 801.49L148.165 804.012L148.796 802.157Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2508 || (_path2508 = /*#__PURE__*/React.createElement("path", {
    d: "M148.513 819.441L140.783 816.811L140.125 818.744L147.856 821.373L148.513 819.441Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2509 || (_path2509 = /*#__PURE__*/React.createElement("path", {
    d: "M157.391 830.778L149.512 828.098L148.841 830.072L156.719 832.752L157.391 830.778Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2510 || (_path2510 = /*#__PURE__*/React.createElement("path", {
    d: "M181.959 829.328L174.254 826.708L173.599 828.635L181.304 831.256L181.959 829.328Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2511 || (_path2511 = /*#__PURE__*/React.createElement("path", {
    d: "M216.431 817.859L209.141 815.38L208.521 817.203L215.811 819.683L216.431 817.859Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2512 || (_path2512 = /*#__PURE__*/React.createElement("path", {
    d: "M249.12 805.862L242.243 803.523L241.658 805.243L248.535 807.582L249.12 805.862Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2513 || (_path2513 = /*#__PURE__*/React.createElement("path", {
    d: "M277.073 796.444L270.533 794.22L269.976 795.856L276.516 798.081L277.073 796.444Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2514 || (_path2514 = /*#__PURE__*/React.createElement("path", {
    d: "M300.225 790.363L293.934 788.223L293.399 789.795L299.69 791.935L300.225 790.363Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2515 || (_path2515 = /*#__PURE__*/React.createElement("path", {
    d: "M317.252 790.073L311.07 787.971L310.544 789.517L316.726 791.62L317.252 790.073Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2516 || (_path2516 = /*#__PURE__*/React.createElement("path", {
    d: "M326.862 798.713L320.586 796.579L320.052 798.148L326.328 800.283L326.862 798.713Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2517 || (_path2517 = /*#__PURE__*/React.createElement("path", {
    d: "M331.995 814.374L325.467 812.154L324.912 813.786L331.44 816.006L331.995 814.374Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2518 || (_path2518 = /*#__PURE__*/React.createElement("path", {
    d: "M334.111 836.592L327.202 834.242L326.614 835.97L333.523 838.319L334.111 836.592Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2519 || (_path2519 = /*#__PURE__*/React.createElement("path", {
    d: "M339.476 856.589L332.243 854.129L331.627 855.939L338.86 858.399L339.476 856.589Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2520 || (_path2520 = /*#__PURE__*/React.createElement("path", {
    d: "M354.671 861.491L347.441 859.032L346.825 860.842L354.055 863.301L354.671 861.491Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2521 || (_path2521 = /*#__PURE__*/React.createElement("path", {
    d: "M376.995 851.881L370.073 849.526L369.485 851.257L376.406 853.611L376.995 851.881Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2522 || (_path2522 = /*#__PURE__*/React.createElement("path", {
    d: "M401.61 833.789L395.161 831.595L394.612 833.208L401.062 835.402L401.61 833.789Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2523 || (_path2523 = /*#__PURE__*/React.createElement("path", {
    d: "M424.378 814.724L418.406 812.692L417.898 814.187L423.87 816.218L424.378 814.724Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2524 || (_path2524 = /*#__PURE__*/React.createElement("path", {
    d: "M443.584 799.48L438 797.581L437.526 798.977L443.109 800.876L443.584 799.48Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2525 || (_path2525 = /*#__PURE__*/React.createElement("path", {
    d: "M459.473 789.317L454.17 787.513L453.718 788.841L459.021 790.645L459.473 789.317Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2526 || (_path2526 = /*#__PURE__*/React.createElement("path", {
    d: "M473.832 780.199L468.778 778.48L468.348 779.743L473.403 781.462L473.832 780.199Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2527 || (_path2527 = /*#__PURE__*/React.createElement("path", {
    d: "M485.272 779.528L480.298 777.837L479.875 779.079L484.849 780.771L485.272 779.528Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2528 || (_path2528 = /*#__PURE__*/React.createElement("path", {
    d: "M494.213 791.333L489.084 789.588L488.648 790.87L493.777 792.614L494.213 791.333Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2529 || (_path2529 = /*#__PURE__*/React.createElement("path", {
    d: "M503.462 805.968L498.127 804.154L497.674 805.487L503.008 807.302L503.462 805.968Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2530 || (_path2530 = /*#__PURE__*/React.createElement("path", {
    d: "M514.794 807.366L509.504 805.566L509.055 806.887L514.345 808.686L514.794 807.366Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2531 || (_path2531 = /*#__PURE__*/React.createElement("path", {
    d: "M526.498 797.813L521.448 796.096L521.02 797.356L526.069 799.074L526.498 797.813Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2532 || (_path2532 = /*#__PURE__*/React.createElement("path", {
    d: "M537.223 785.581L532.459 783.96L532.053 785.154L536.817 786.774L537.223 785.581Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2533 || (_path2533 = /*#__PURE__*/React.createElement("path", {
    d: "M546.836 775.682L542.306 774.141L541.92 775.275L546.451 776.816L546.836 775.682Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2534 || (_path2534 = /*#__PURE__*/React.createElement("path", {
    d: "M555.844 771.69L551.438 770.191L551.063 771.294L555.469 772.792L555.844 771.69Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2535 || (_path2535 = /*#__PURE__*/React.createElement("path", {
    d: "M565.11 775.744L560.688 774.24L560.313 775.343L564.735 776.846L565.11 775.744Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2536 || (_path2536 = /*#__PURE__*/React.createElement("path", {
    d: "M574.858 783.074L570.367 781.546L569.985 782.669L574.476 784.197L574.858 783.074Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2537 || (_path2537 = /*#__PURE__*/React.createElement("path", {
    d: "M585.166 792.052L580.576 790.491L580.185 791.64L584.775 793.202L585.166 792.052Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2538 || (_path2538 = /*#__PURE__*/React.createElement("path", {
    d: "M595.699 800.248L591.026 798.659L590.628 799.829L595.301 801.418L595.699 800.248Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2539 || (_path2539 = /*#__PURE__*/React.createElement("path", {
    d: "M605.115 802.177L600.468 800.597L600.071 801.761L604.719 803.342L605.115 802.177Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2540 || (_path2540 = /*#__PURE__*/React.createElement("path", {
    d: "M614.44 804.081L609.814 802.508L609.421 803.662L614.048 805.236L614.44 804.081Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2541 || (_path2541 = /*#__PURE__*/React.createElement("path", {
    d: "M625.023 810.61L620.342 809.018L619.944 810.188L624.625 811.78L625.023 810.61Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2542 || (_path2542 = /*#__PURE__*/React.createElement("path", {
    d: "M637.704 823.116L632.881 821.475L632.471 822.679L637.295 824.319L637.704 823.116Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2543 || (_path2543 = /*#__PURE__*/React.createElement("path", {
    d: "M653.43 842.782L648.35 841.054L647.916 842.328L652.997 844.056L653.43 842.782Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2544 || (_path2544 = /*#__PURE__*/React.createElement("path", {
    d: "M672.514 868.898L667.084 867.051L666.622 868.408L672.053 870.255L672.514 868.898Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2545 || (_path2545 = /*#__PURE__*/React.createElement("path", {
    d: "M690.454 889.091L684.772 887.159L684.289 888.578L689.971 890.51L690.454 889.091Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2546 || (_path2546 = /*#__PURE__*/React.createElement("path", {
    d: "M702.503 893.595L696.813 891.659L696.329 893.083L702.019 895.019L702.503 893.595Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2547 || (_path2547 = /*#__PURE__*/React.createElement("path", {
    d: "M709.689 887.466L704.152 885.583L703.68 886.971L709.217 888.854L709.689 887.466Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2548 || (_path2548 = /*#__PURE__*/React.createElement("path", {
    d: "M718.78 886.359L713.318 884.501L712.854 885.865L718.316 887.723L718.78 886.359Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2549 || (_path2549 = /*#__PURE__*/React.createElement("path", {
    d: "M729.642 889.222L724.196 887.37L723.733 888.732L729.179 890.584L729.642 889.222Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2550 || (_path2550 = /*#__PURE__*/React.createElement("path", {
    d: "M743.174 897.144L737.668 895.272L737.199 896.652L742.704 898.524L743.174 897.144Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2551 || (_path2551 = /*#__PURE__*/React.createElement("path", {
    d: "M163.223 714.79L157.681 712.905L157.209 714.293L162.751 716.178L163.223 714.79Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2552 || (_path2552 = /*#__PURE__*/React.createElement("path", {
    d: "M160.475 726.485L154.715 724.526L154.225 725.966L159.985 727.925L160.475 726.485Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2553 || (_path2553 = /*#__PURE__*/React.createElement("path", {
    d: "M165.043 734.814L159.166 732.816L158.667 734.284L164.543 736.283L165.043 734.814Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2554 || (_path2554 = /*#__PURE__*/React.createElement("path", {
    d: "M170.786 742.897L164.805 740.863L164.297 742.358L170.277 744.391L170.786 742.897Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2555 || (_path2555 = /*#__PURE__*/React.createElement("path", {
    d: "M169.708 755.737L163.5 753.625L162.971 755.179L169.18 757.291L169.708 755.737Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2556 || (_path2556 = /*#__PURE__*/React.createElement("path", {
    d: "M165.078 771.912L158.566 769.697L158.012 771.326L164.524 773.541L165.078 771.912Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2557 || (_path2557 = /*#__PURE__*/React.createElement("path", {
    d: "M162.967 787.638L156.175 785.328L155.598 787.025L162.39 789.335L162.967 787.638Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2558 || (_path2558 = /*#__PURE__*/React.createElement("path", {
    d: "M159.556 805.612L152.435 803.19L151.829 804.972L158.95 807.394L159.556 805.612Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2559 || (_path2559 = /*#__PURE__*/React.createElement("path", {
    d: "M152.942 827.687L145.406 825.124L144.764 827.01L152.3 829.573L152.942 827.687Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2560 || (_path2560 = /*#__PURE__*/React.createElement("path", {
    d: "M156.591 843.176L148.808 840.529L148.147 842.475L155.929 845.122L156.591 843.176Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2561 || (_path2561 = /*#__PURE__*/React.createElement("path", {
    d: "M180.8 841.541L173.189 838.952L172.541 840.856L180.152 843.445L180.8 841.541Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2562 || (_path2562 = /*#__PURE__*/React.createElement("path", {
    d: "M217.081 827.527L209.918 825.09L209.308 826.883L216.471 829.319L217.081 827.527Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2563 || (_path2563 = /*#__PURE__*/React.createElement("path", {
    d: "M250.535 813.824L243.803 811.535L243.23 813.218L249.963 815.508L250.535 813.824Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2564 || (_path2564 = /*#__PURE__*/React.createElement("path", {
    d: "M275.957 806.266L269.502 804.071L268.954 805.685L275.408 807.88L275.957 806.266Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2565 || (_path2565 = /*#__PURE__*/React.createElement("path", {
    d: "M296.321 802.829L290.045 800.694L289.511 802.263L295.787 804.398L296.321 802.829Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2566 || (_path2566 = /*#__PURE__*/React.createElement("path", {
    d: "M313.786 801.82L307.63 799.726L307.106 801.267L313.262 803.361L313.786 801.82Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2567 || (_path2567 = /*#__PURE__*/React.createElement("path", {
    d: "M325.901 807.136L319.724 805.035L319.198 806.581L325.375 808.682L325.901 807.136Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2568 || (_path2568 = /*#__PURE__*/React.createElement("path", {
    d: "M331.181 822.467L324.773 820.288L324.226 821.894L330.635 824.073L331.181 822.467Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2569 || (_path2569 = /*#__PURE__*/React.createElement("path", {
    d: "M328.587 851.965L321.657 849.608L321.068 851.341L327.997 853.698L328.587 851.965Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2570 || (_path2570 = /*#__PURE__*/React.createElement("path", {
    d: "M329.039 880.707L321.619 878.184L320.989 880.038L328.408 882.562L329.039 880.707Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2571 || (_path2571 = /*#__PURE__*/React.createElement("path", {
    d: "M344.585 885.812L337.168 883.29L336.537 885.144L343.954 887.667L344.585 885.812Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2572 || (_path2572 = /*#__PURE__*/React.createElement("path", {
    d: "M370.217 870.15L363.218 867.769L362.623 869.518L369.622 871.898L370.217 870.15Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2573 || (_path2573 = /*#__PURE__*/React.createElement("path", {
    d: "M396.926 847.494L390.468 845.298L389.92 846.911L396.377 849.107L396.926 847.494Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2574 || (_path2574 = /*#__PURE__*/React.createElement("path", {
    d: "M419.125 829.761L413.103 827.713L412.591 829.22L418.612 831.268L419.125 829.761Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2575 || (_path2575 = /*#__PURE__*/React.createElement("path", {
    d: "M437.212 818.079L431.496 816.135L431.01 817.564L436.726 819.508L437.212 818.079Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2576 || (_path2576 = /*#__PURE__*/React.createElement("path", {
    d: "M453.43 807.902L447.984 806.05L447.52 807.412L452.966 809.264L453.43 807.902Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2577 || (_path2577 = /*#__PURE__*/React.createElement("path", {
    d: "M468.74 796.532L463.577 794.776L463.138 796.065L468.301 797.821L468.74 796.532Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2578 || (_path2578 = /*#__PURE__*/React.createElement("path", {
    d: "M480.7 794.707L475.637 792.985L475.207 794.251L480.269 795.973L480.7 794.707Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2579 || (_path2579 = /*#__PURE__*/React.createElement("path", {
    d: "M489.61 807.462L484.382 805.684L483.937 806.991L489.165 808.77L489.61 807.462Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2580 || (_path2580 = /*#__PURE__*/React.createElement("path", {
    d: "M498.853 823.083L493.413 821.232L492.95 822.591L498.391 824.442L498.853 823.083Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2581 || (_path2581 = /*#__PURE__*/React.createElement("path", {
    d: "M510.422 824.61L505.02 822.772L504.561 824.124L509.963 825.961L510.422 824.61Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2582 || (_path2582 = /*#__PURE__*/React.createElement("path", {
    d: "M522.564 814.04L517.416 812.289L516.978 813.578L522.126 815.329L522.564 814.04Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2583 || (_path2583 = /*#__PURE__*/React.createElement("path", {
    d: "M533.718 800.709L528.861 799.057L528.447 800.273L533.304 801.925L533.718 800.709Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2584 || (_path2584 = /*#__PURE__*/React.createElement("path", {
    d: "M543.67 789.006L539.075 787.443L538.684 788.593L543.279 790.156L543.67 789.006Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2585 || (_path2585 = /*#__PURE__*/React.createElement("path", {
    d: "M552.725 780.97L548.319 779.471L547.945 780.571L552.351 782.07L552.725 780.97Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2586 || (_path2586 = /*#__PURE__*/React.createElement("path", {
    d: "M561.925 784.359L557.514 782.859L557.14 783.959L561.551 785.459L561.925 784.359Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2587 || (_path2587 = /*#__PURE__*/React.createElement("path", {
    d: "M571.867 794.105L567.347 792.567L566.963 793.699L571.483 795.236L571.867 794.105Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2588 || (_path2588 = /*#__PURE__*/React.createElement("path", {
    d: "M582.422 805.098L577.774 803.517L577.38 804.677L582.027 806.257L582.422 805.098Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2589 || (_path2589 = /*#__PURE__*/React.createElement("path", {
    d: "M593.233 814.748L588.484 813.133L588.08 814.321L592.829 815.936L593.233 814.748Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2590 || (_path2590 = /*#__PURE__*/React.createElement("path", {
    d: "M604.082 822.678L599.261 821.039L598.852 822.242L603.673 823.882L604.082 822.678Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2591 || (_path2591 = /*#__PURE__*/React.createElement("path", {
    d: "M614.492 827.631L609.647 825.983L609.236 827.192L614.081 828.84L614.492 827.631Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2592 || (_path2592 = /*#__PURE__*/React.createElement("path", {
    d: "M623.964 828.746L619.154 827.11L618.745 828.311L623.556 829.947L623.964 828.746Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2593 || (_path2593 = /*#__PURE__*/React.createElement("path", {
    d: "M634.614 834.261L629.769 832.613L629.358 833.822L634.203 835.47L634.614 834.261Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2594 || (_path2594 = /*#__PURE__*/React.createElement("path", {
    d: "M650.844 856.477L645.714 854.732L645.278 856.014L650.408 857.759L650.844 856.477Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2595 || (_path2595 = /*#__PURE__*/React.createElement("path", {
    d: "M673.079 892.648L667.462 890.738L666.983 892.144L672.601 894.054L673.079 892.648Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2596 || (_path2596 = /*#__PURE__*/React.createElement("path", {
    d: "M693.096 918.37L687.152 916.348L686.646 917.835L692.59 919.856L693.096 918.37Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2597 || (_path2597 = /*#__PURE__*/React.createElement("path", {
    d: "M704.311 919.73L698.411 917.723L697.91 919.197L703.81 921.203L704.311 919.73Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2598 || (_path2598 = /*#__PURE__*/React.createElement("path", {
    d: "M709.674 907.992L704.005 906.064L703.523 907.483L709.192 909.411L709.674 907.992Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2599 || (_path2599 = /*#__PURE__*/React.createElement("path", {
    d: "M716.887 902.038L711.363 900.159L710.893 901.542L716.417 903.421L716.887 902.038Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2600 || (_path2600 = /*#__PURE__*/React.createElement("path", {
    d: "M721.993 892.777L716.658 890.962L716.204 892.298L721.539 894.113L721.993 892.777Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })), _path2601 || (_path2601 = /*#__PURE__*/React.createElement("path", {
    d: "M730.669 891.774L725.4 889.982L724.953 891.297L730.222 893.089L730.669 891.774Z",
    fill: "#6F6F6F",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMain);
export default __webpack_public_path__ + "static/media/main.065f362335f0dc6db20ad49c96620708.svg";
export { ForwardRef as ReactComponent };